// ═══════════════════════════════════════════════════════════════════
// USV CONNECT — application
// ═══════════════════════════════════════════════════════════════════
// Ce fichier vit dans Assets/ et non dans la section : le modèle Shopify
// est plafonné à 256 Ko, et la section en approchait dangereusement.
// Un asset n'a pas cette limite et se met en cache côté navigateur.
//
// Aucune valeur Liquid n'est utilisée ici — le code était déjà autonome,
// l'extraction est donc sans effet de bord.


(function(){

  // ===== Force l'adaptation à l'écran + bloque le zoom (mobile & WebView) =====
  (function setViewport(){
    try{
      var content='width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover';
      var vp=document.querySelector('meta[name="viewport"]');
      if(!vp){ vp=document.createElement('meta'); vp.name='viewport'; document.getElementsByTagName('head')[0].appendChild(vp); }
      vp.setAttribute('content', content);
      // iOS ignore parfois user-scalable : on bloque le double-tap de zoom.
      // ⚠️ Ne JAMAIS bloquer un tap sur un élément interactif (bouton, lien,
      // champ) : preventDefault() sur touchend annule le clic qui suit et
      // rend les boutons inutilisables sur mobile.
      var lastTouch=0, lastX=0, lastY=0;
      document.addEventListener('touchend', function(e){
        var t=e.target;
        // remonte quelques niveaux pour détecter un élément cliquable
        for(var n=0; t && n<4; n++){
          var tag=(t.tagName||'').toUpperCase();
          if(tag==='BUTTON'||tag==='A'||tag==='INPUT'||tag==='SELECT'||tag==='TEXTAREA'||tag==='LABEL'){ lastTouch=0; return; }
          t=t.parentNode;
        }
        var now=Date.now();
        var ct=(e.changedTouches&&e.changedTouches[0])||null;
        var x=ct?ct.clientX:0, y=ct?ct.clientY:0;
        // vrai double-tap de zoom = 2 taps rapprochés ET au même endroit
        if(now-lastTouch<=350 && Math.abs(x-lastX)<30 && Math.abs(y-lastY)<30){ e.preventDefault(); }
        lastTouch=now; lastX=x; lastY=y;
      }, { passive:false });
      document.addEventListener('gesturestart', function(e){ e.preventDefault(); }, { passive:false });
    }catch(e){}
  })();

  // ===== Polyfill requestIdleCallback =====
  // Safari/WebView iOS ne fournit pas requestIdleCallback. Un script du thème
  // (ou d'une app Shopify) l'appelle et plante avec :
  //   ReferenceError: Can't find variable: requestIdleCallback
  // Cette erreur interrompt l'initialisation de la page dans l'app.
  // On fournit un équivalent minimal basé sur setTimeout.
  (function polyfillIdle(){
    try{
      if(typeof window.requestIdleCallback!=='function'){
        window.requestIdleCallback=function(cb,opts){
          var start=Date.now();
          var delay=(opts&&opts.timeout)?Math.min(opts.timeout,1):1;
          return setTimeout(function(){
            cb({
              didTimeout:false,
              timeRemaining:function(){ return Math.max(0, 50-(Date.now()-start)); }
            });
          }, delay);
        };
      }
      if(typeof window.cancelIdleCallback!=='function'){
        window.cancelIdleCallback=function(id){ clearTimeout(id); };
      }
    }catch(e){}
  })();

  // ===== Anti-rechargement =====
  // Certains thèmes Shopify enveloppent le contenu d'une page dans un <form>
  // (ou en ajoutent un autour des sections). Une soumission renvoie alors vers
  // l'action du formulaire — souvent la racine du site — ce qui se traduit,
  // dans l'app, par un retour brutal sur la page d'accueil.
  // On neutralise toute soumission déclenchée depuis cette page, dès le
  // chargement (et non seulement après connexion).
  (function guardForms(){
    try{
      document.addEventListener('submit', function(e){
        var f=e.target;
        if(!f || f.tagName!=='FORM') return;
        // On laisse passer les formulaires Shopify légitimes (panier, compte,
        // recherche, newsletter) : eux doivent continuer à fonctionner.
        var action=(f.getAttribute('action')||'');
        var isShopify=/\/(cart|account|search|contact|checkout)/i.test(action);
        if(isShopify) return;
        e.preventDefault();
      }, true);
    }catch(e){}
  })();


  var SUPA_URL = 'https://lkjoirwoobcehmhjphiq.supabase.co';
  var SUPA_KEY = 'sb_publishable_pvsUgbmgI_PUWMwfdmqtLw_rnWX0Wcv';

  var TOKEN=null, USER=null, PROFILE=null, REFRESH=null;
  var STATE={ teams:[], myTeams:[], events:[], evType:'entrainement', view:'cal', calFilter:'all', calType:'all', chatTeam:null, chatChannel:'general', chatOpen:false, msgMode:'cat', dmThread:null, dmThreads:[], dmContacts:[], adminMembers:null, adminPage:1, adminQuery:'', myGroups:[], editingEvent:null, convocMode:'sent' };

  var ROOT = document.getElementById('usveq-root');

  // Détecte si on tourne dans l'app native (pour décaler la nav au-dessus de la barre native)
  function markNativeContext(){
    var sec=document.querySelector('.usveq');
    if(!sec) return;
    // app native si le pont JS est là, OU si on tourne dans une WebView iOS/Android standalone
    var ua=navigator.userAgent||'';
    var isWebView = window.USV_NATIVE === true
      || /USVApp/i.test(ua)
      || (window.ReactNativeWebView!=null)
      || (window.navigator.standalone===true);
    if(isWebView){ sec.classList.add('eq-in-app'); }
  }
  markNativeContext();
  // le token/flag peut arriver après le chargement initial : on revérifie
  setTimeout(markNativeContext, 800);
  setTimeout(markNativeContext, 2500);

  /* ===== Mesure du header du thème + de la scrollbar =====
     Le header de usvinayrugby.com est sticky et passe sur DEUX lignes
     dès qu'il y a beaucoup d'onglets : sa hauteur varie de ~110px à
     ~215px selon la largeur. Tout ce qui est fixed/sticky dans la
     section doit s'y adapter, sinon la modale se centre derrière lui
     (le champ de recherche disparaît). On expose la valeur mesurée
     en --eq-hdr, et le CSS fait le reste. */
  function measureChrome(){
    try{
      var sec=document.querySelector('.usveq');
      if(!sec) return;

      // largeur de la barre de défilement (0 sur mobile / overlay)
      var sbw=window.innerWidth-document.documentElement.clientWidth;
      if(!(sbw>0)||sbw>40) sbw=0;
      sec.style.setProperty('--eq-sbw', sbw+'px');

      // on ne réserve de la place que si le header reste à l'écran
      var hdr=0;
      var cands=document.querySelectorAll(
        'header, .header-wrapper, header-component, #header-component, ' +
        'sticky-header, .shopify-section-group-header-group, .section-header'
      );
      for(var i=0;i<cands.length;i++){
        var el=cands[i];
        if(!el||sec.contains(el)) continue;
        var cs=window.getComputedStyle(el);
        if(cs.position!=='fixed'&&cs.position!=='sticky') continue;
        if(cs.display==='none'||cs.visibility==='hidden') continue;
        var r=el.getBoundingClientRect();
        // header collé en haut uniquement (on ignore les barres basses)
        if(r.height<=0||r.top>80) continue;
        var h=r.top+r.height;
        if(h>hdr) hdr=h;
      }
      if(hdr<0) hdr=0;
      if(hdr>320) hdr=320; // garde-fou : jamais plus d'un tiers d'écran
      sec.style.setProperty('--eq-hdr', Math.round(hdr)+'px');
    }catch(e){}
  }
  measureChrome();
  // le header du thème se replie/déplie après hydratation
  setTimeout(measureChrome, 300);
  setTimeout(measureChrome, 1200);
  window.addEventListener('resize', measureChrome);
  window.addEventListener('orientationchange', function(){ setTimeout(measureChrome,250); });
  try{
    if(typeof ResizeObserver==='function'){
      var ro=new ResizeObserver(function(){ measureChrome(); });
      var hEl=document.querySelector('header, .header-wrapper, header-component');
      if(hEl) ro.observe(hEl);
    }
  }catch(e){}

  /* ---------- icons (inline svg, marche partout) ---------- */
  var IC = {
    cal:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>',
    teams:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
    staff:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 20h9M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>',
    admin:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l2.4 7.4H22l-6 4.6 2.3 7.4-6.3-4.6L5.7 21 8 14 2 9.4h7.6z"/></svg>',
    clock:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    pin:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
    phone:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>',
    note:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></svg>',
    check:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6L9 17l-5-5"/></svg>',
    cross:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M18 6L6 18M6 6l12 12"/></svg>',
    help:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>',
    chev:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>',
    dots:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><circle cx="5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/></svg>',
    trash:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M10 11v6M14 11v6"/></svg>',
    edit:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>',
    chat:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>',
    send:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg>',
    search:'<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>',
    users:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
    whistle:'<svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4a1 1 0 0 1 1 1v1h7a2 2 0 0 1 2 2v2a7 7 0 1 1-13.9-1.2A1 1 0 0 1 9 8h2V5a1 1 0 0 1 1-1zM6 13a3 3 0 1 0 6 0 3 3 0 0 0-6 0z"/></svg>',
    back:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M15 18l-6-6 6-6"/></svg>',
    plus:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 5v14M5 12h14"/></svg>',
    camera:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
    clipboard:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12h6M9 16h4"/></svg>',
    eyeoff:'<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 10 8 10 8a13.2 13.2 0 0 1-1.67 2.68M6.6 6.6A13.3 13.3 0 0 0 2 12s3 8 10 8a9.1 9.1 0 0 0 5.4-1.6M1 1l22 22M9.9 9.9a3 3 0 0 0 4.2 4.2"/></svg>',
    chart:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3v18h18"/><rect x="7" y="11" width="3" height="6" rx="0.5"/><rect x="12" y="7" width="3" height="10" rx="0.5"/><rect x="17" y="13" width="3" height="4" rx="0.5"/></svg>',
    check2:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/></svg>'
  };

  /* ---------- REST client (compatible vieux Chrome) ---------- */
  function api(path, opts){
    opts = opts || {};
    return apiRaw(path, opts).catch(function(err){
      // token expiré en cours d'usage → on régénère puis on réessaie 1 fois
      if(err && err.status===401 && REFRESH && !opts._retried){
        opts._retried=true;
        return refreshSession().then(function(){ return apiRaw(path, opts); });
      }
      throw err;
    });
  }
  function apiRaw(path, opts){
    opts = opts || {};
    var headers = { 'apikey':SUPA_KEY, 'Content-Type':'application/json' };
    if (TOKEN) headers['Authorization'] = 'Bearer ' + TOKEN;
    if (opts.prefer) headers['Prefer'] = opts.prefer;
    return fetch(SUPA_URL + path, {
      method: opts.method || 'GET', headers: headers,
      body: opts.body ? JSON.stringify(opts.body) : undefined
    }).then(function(r){
      return r.text().then(function(t){
        var d=null; if(t){ try{ d=JSON.parse(t); }catch(e){ d=t; } }
        if(!r.ok){
          var m=(d&&d.msg)||(d&&d.message)||(d&&d.error_description)||(d&&d.error)||('Erreur '+r.status);
          var err=new Error(m); err.status=r.status; err.code=(d&&d.code)||''; throw err;
        }
        return d;
      });
    });
  }
  /* ---- Compression + upload d'une photo vers Storage (bucket chat-photos) ---- */
  function compressImage(file, maxDim, quality){
    return new Promise(function(resolve,reject){
      var reader=new FileReader();
      reader.onload=function(ev){
        var img=new Image();
        img.onload=function(){
          var w=img.width, h=img.height;
          if(w>h){ if(w>maxDim){ h=Math.round(h*maxDim/w); w=maxDim; } }
          else { if(h>maxDim){ w=Math.round(w*maxDim/h); h=maxDim; } }
          var canvas=document.createElement('canvas'); canvas.width=w; canvas.height=h;
          var ctx=canvas.getContext('2d'); ctx.drawImage(img,0,0,w,h);
          canvas.toBlob(function(blob){
            if(!blob){ reject(new Error('Compression impossible')); return; }
            resolve(blob);
          }, 'image/jpeg', quality||0.7);
        };
        img.onerror=function(){ reject(new Error('Image illisible')); };
        img.src=ev.target.result;
      };
      reader.onerror=function(){ reject(new Error('Lecture impossible')); };
      reader.readAsDataURL(file);
    });
  }
  function uploadChatPhoto(file){
    return compressImage(file, 1280, 0.7).then(function(blob){
      var ext='jpg';
      var name=USER.id+'_'+Date.now()+'_'+Math.floor(Math.random()*100000)+'.'+ext;
      var path='chat-photos/'+name;
      return fetch(SUPA_URL+'/storage/v1/object/'+path, {
        method:'POST',
        headers:{ 'apikey':SUPA_KEY, 'Authorization':'Bearer '+TOKEN, 'Content-Type':'image/jpeg', 'x-upsert':'true' },
        body:blob
      }).then(function(r){
        return r.text().then(function(t){
          if(!r.ok){ var d=null; try{d=JSON.parse(t);}catch(e){} throw new Error((d&&(d.message||d.error))||'Upload échoué ('+r.status+')'); }
          return SUPA_URL+'/storage/v1/object/public/'+path;
        });
      });
    });
  }
  function authReq(action,email,password,meta){
    var path = action==='signup' ? '/auth/v1/signup' : '/auth/v1/token?grant_type=password';
    var body={ email:email, password:password }; if(meta) body.data=meta;
    return fetch(SUPA_URL+path,{ method:'POST', headers:{'apikey':SUPA_KEY,'Content-Type':'application/json'}, body:JSON.stringify(body) })
      .then(function(r){ return r.text().then(function(t){
        var d=t?JSON.parse(t):{};
        if(!r.ok){ var err=new Error(d.msg||d.error_description||d.error||'Erreur'); err.status=r.status; err.code=d.error_code||d.code||''; throw err; }
        return d;
      }); });
  }

  /* ---------- NOTIFICATIONS PUSH (pont avec l'app native) ---------- */
  // L'app Expo appelle window.usvOnPushToken(token, platform) ou expose window.USV_PUSH_TOKEN.
  var PENDING_PUSH_TOKEN = null;
  window.usvOnPushToken = function(token, platform){
    PENDING_PUSH_TOKEN = { token: token, platform: platform || '' };
    // si déjà connecté, on enregistre tout de suite
    if (USER && TOKEN) savePushToken();
  };
  // État de l'enregistrement, pour le bandeau d'alerte plus bas.
  var PUSH_STATE = { tried:false, ok:false, error:null, hasToken:false };

  function savePushToken(){
    if(!PENDING_PUSH_TOKEN || !USER) return;
    var p = PENDING_PUSH_TOKEN;
    PUSH_STATE.tried = true;
    PUSH_STATE.hasToken = true;

    // upsert : on évite les doublons grâce à la contrainte unique sur token
    return api('/rest/v1/push_tokens?on_conflict=token', {
      method:'POST',
      prefer:'resolution=merge-duplicates,return=minimal',
      body:{ profile_id:USER.id, token:p.token, platform:p.platform, last_seen:new Date().toISOString() }
    })
    .then(function(){ PUSH_STATE.ok=true; PUSH_STATE.error=null; })
    .catch(function(e){
      // Un échec silencieux ici est invisible pendant des mois : la
      // personne croit être prévenue et ne reçoit jamais rien.
      PUSH_STATE.ok=false;
      PUSH_STATE.error=(e && e.message) || 'erreur inconnue';
      console.error('push_tokens :', e);

      // Deuxième tentative sans upsert : si la contrainte unique
      // attendue par on_conflict n'existe pas, la première échoue
      // toujours alors qu'une insertion simple passerait.
      return api('/rest/v1/push_tokens', {
        method:'POST', prefer:'return=minimal',
        body:{ profile_id:USER.id, token:p.token, platform:p.platform, last_seen:new Date().toISOString() }
      })
      .then(function(){ PUSH_STATE.ok=true; PUSH_STATE.error=null; })
      .catch(function(e2){
        PUSH_STATE.error=(e2 && e2.message) || PUSH_STATE.error;
        console.error('push_tokens (2e essai) :', e2);
      });
    });
  }

  /* Contrôle après connexion : cette personne a-t-elle un jeton en base ?
     Sans ça, personne ne sait qu'il ne recevra jamais rien — c'est le
     cas de quatre parents sur cinq aujourd'hui. */
  function checkPushHealth(){
    if(!USER) return Promise.resolve();
    return api('/rest/v1/push_tokens?select=token&profile_id=eq.'+USER.id+'&limit=1')
      .then(function(r){
        PUSH_STATE.ok = !!(r && r.length);
        paintPushBanner();
      })
      .catch(function(){});
  }

  function paintPushBanner(){
    var slot=document.getElementById('eqPushWarn');
    if(!slot) return;
    if(PUSH_STATE.ok){ slot.innerHTML=''; return; }

    // Dans l'app, le jeton devrait exister : s'il manque, c'est
    // l'autorisation qui a été refusée. Sur le site, il n'y a pas de
    // notifications du tout, le message doit le dire autrement.
    var dansApp = (window.ReactNativeWebView!=null) || !!window.USV_PUSH_TOKEN
               || (window.USV_PLATFORM!=null);
    // L'application transmet la raison de l'échec : on l'explique en
    // clair plutôt que d'afficher un message générique qui ne mène
    // nulle part.
    var cause = window.USV_PUSH_FAIL || null;
    var texte;
    if(!dansApp){
      texte = 'Tu utilises le site. Pour être prévenu des convocations et des '+
              'messages, installe l\'application USV Connect sur ton téléphone.';
    } else if(cause === 'permission_refusee'){
      texte = 'Les notifications sont refusées pour USV Connect. Va dans les '+
              'réglages de ton téléphone, autorise-les, puis ferme et rouvre '+
              'l\'application.';
    } else if(cause === 'simulateur'){
      texte = 'Les notifications ne fonctionnent pas sur un simulateur.';
    } else {
      texte = 'Les convocations et les messages ne t\'arriveront pas. '+
              'Ferme complètement l\'application et rouvre-la. Si le message '+
              'persiste, préviens le club.';
    }
    slot.innerHTML='<div class="eq-pushwarn">'+
      '<b>🔕 Tu ne reçois pas les notifications</b>'+
      '<span>'+texte+'</span>'+
      ((cause && cause!=='permission_refusee' && cause!=='simulateur')
        ? '<em>'+esc(cause)+'</em>' : '')+
      '</div>';
  }
  // Appelle l'Edge Function d'envoi de notifications
  function sendPush(payload){
    return fetch(SUPA_URL + '/functions/v1/send-push', {
      method:'POST',
      headers:{ 'apikey':SUPA_KEY, 'Authorization':'Bearer '+TOKEN, 'Content-Type':'application/json' },
      body:JSON.stringify(payload)
    }).then(function(r){ return r.text().then(function(t){ var d=null; try{d=JSON.parse(t);}catch(e){} return d; }); });
  }

  /* ---------- helpers ---------- */
  function esc(s){ s=s==null?'':String(s); return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  // Le champ grandit avec le texte, jusqu'à la limite fixée en CSS.
  function autoGrow(el){
    if(!el) return;
    el.style.height='auto';
    el.style.height=Math.min(el.scrollHeight, 130)+'px';
  }
  function resetGrow(el){ if(el){ el.style.height='auto'; } }

  function initials(name){ name=(name||'').trim(); if(!name) return '?'; var p=name.split(/\s+/); return (p[0][0]+(p[1]?p[1][0]:'')).toUpperCase(); }
  function fmtD(iso){ var d=new Date(iso); return ('0'+d.getDate()).slice(-2); }
  function fmtM(iso){ var d=new Date(iso); return ['JAN','FÉV','MAR','AVR','MAI','JUIN','JUIL','AOÛ','SEP','OCT','NOV','DÉC'][d.getMonth()]; }
  function fmtTime(iso){ var d=new Date(iso),h=d.getHours(),m=d.getMinutes(); var days=['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi']; return days[d.getDay()]+' · '+('0'+h).slice(-2)+'h'+('0'+m).slice(-2); }
  function fmtEndTime(iso){ if(!iso) return ''; var d=new Date(iso); return ('0'+d.getHours()).slice(-2)+'h'+('0'+d.getMinutes()).slice(-2); }

  /* ---------- session ---------- */
  function saveSession(d){
    if(d.access_token) TOKEN=d.access_token;
    if(d.refresh_token) REFRESH=d.refresh_token;
    if(d.user) USER=d.user;
    try{ localStorage.setItem('usv_eq', JSON.stringify({ t:TOKEN, r:REFRESH, u:USER })); }catch(e){}
  }
  function loadSession(){ try{ var s=localStorage.getItem('usv_eq'); if(s){ s=JSON.parse(s); TOKEN=s.t||null; REFRESH=s.r||null; USER=s.u||null; return true; } }catch(e){} return false; }
  function clearSession(){ TOKEN=null;USER=null;PROFILE=null;REFRESH=null; try{ localStorage.removeItem('usv_eq'); }catch(e){} }
  // Régénère un access_token à partir du refresh_token (sans redemander le mot de passe)
  function refreshSession(){
    if(!REFRESH) return Promise.reject(new Error('no refresh token'));
    return fetch(SUPA_URL+'/auth/v1/token?grant_type=refresh_token',{
      method:'POST', headers:{'apikey':SUPA_KEY,'Content-Type':'application/json'},
      body:JSON.stringify({ refresh_token:REFRESH })
    }).then(function(r){ return r.text().then(function(t){
      var d=t?JSON.parse(t):{};
      if(!r.ok || !d.access_token){ throw new Error(d.error_description||d.error||'refresh failed'); }
      saveSession(d); // met à jour token + nouveau refresh_token
      return d;
    }); });
  }
  function loadProfile(){ return api('/rest/v1/profiles?id=eq.'+USER.id+'&select=*').then(function(r){ PROFILE=(r&&r[0])?r[0]:{role:'parent',full_name:''}; return PROFILE; }); }

  /* ---------- data ---------- */
  function loadTeams(){ return api('/rest/v1/teams?select=*&order=sort_order').then(function(r){ STATE.teams=r||[]; }); }
  function loadMyTeams(){
    // enfants propres + enfants liés (où je suis 2e parent)
    return Promise.all([
      // On écarte les demandes refusées et les fiches archivées : sans ce
      // filtre, un parent dont la demande a été refusée garde l'accès à
      // l'agenda et aux messages de la catégorie. Les demandes en attente
      // sont conservées, pour qu'il voie sa demande en cours.
      api('/rest/v1/team_members?profile_id=eq.'+USER.id+'&select=*'
        +'&status=neq.refuse&archived_at=is.null'),
      api('/rest/v1/rpc/my_linked_children',{ method:'POST', body:{} }).catch(function(){ return []; })
    ]).then(function(res){
      var own=(res[0]||[]).map(function(c){ c.owner_id=USER.id; c.linked=false; return c; });
      var linked=(res[1]||[]).map(function(c){ c.linked=true; return c; }); // a déjà owner_id
      STATE.myTeams=own.concat(linked);
    });
  }
  // Fenêtre de chargement de l'agenda.
  // Sur mobile et dans l'app, on borne volontairement : charger toute la
  // saison (plusieurs centaines d'événements et leurs présences) saturait
  // la WebView. Sur un vrai poste de travail cette limite n'a pas lieu
  // d'être, le staff peut demander la saison entière.
  // Délai minimum entre deux relances des absents, en un seul endroit
  // pour que le bouton grisé et le message d'attente restent d'accord.
  var RELANCE_DELAI = 4*3600000;   // 4 heures

  var AGENDA_DAYS_AHEAD = 60;   // événements jusqu'à 60 jours à venir
  // Une seule catégorie demandée : le plafond suffit pour aller
  // nettement plus loin, on élargit la fenêtre en conséquence.
  var AGENDA_DAYS_FILTRE = 210;
  var AGENDA_MAX = 120;         // sécurité : jamais plus de 120 événements
  var AGENDA_FULL_DAYS = 400;   // « toute la saison »
  var AGENDA_FULL_MAX = 900;    // plafond sur ordinateur
  // Sur téléphone, la saison entière est désormais accessible au staff,
  // mais avec un plafond plus bas : 900 événements et leurs présences
  // saturaient la WebView. 350 couvre largement une saison de catégorie
  // tout en restant tenable.
  var AGENDA_FULL_MAX_MOBILE = 350;

  // Poste de travail = grand écran, hors app native, non tactile.
  // Appareil tactile : pas de touche Maj, donc pas de « Maj+Entrée ».
  function isTouch(){
    return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  }

  function isDesktop(){
    var ua=navigator.userAgent||'';
    var native = window.USV_NATIVE === true
      || /USVApp/i.test(ua)
      || (window.ReactNativeWebView!=null)
      || (window.navigator.standalone===true);
    if(native) return false;
    if(/Android|iPhone|iPad|iPod|Mobile/i.test(ua)) return false;
    return window.innerWidth >= 1024;
  }

  // Mode étendu réservé au staff sur ordinateur ; le choix est mémorisé.
  /* Catégories masquées par l'éducateur. Un éducateur du M6 n'a aucune
     raison de faire défiler les entraînements des M14 à chaque ouverture.
     Le choix est propre à l'appareil et n'enlève aucun droit : il ne
     s'agit que de confort d'affichage. */
  function hiddenTeams(){
    try{ return JSON.parse(localStorage.getItem('usv_hidden_teams')||'[]'); }
    catch(e){ return []; }
  }
  function setHiddenTeams(list){
    try{ localStorage.setItem('usv_hidden_teams', JSON.stringify(list||[])); }catch(e){}
  }

  function agendaFull(){
    // Le mode étendu reste réservé au staff, mais n'est plus limité à
    // l'ordinateur : un éducateur prépare aussi sa saison depuis son
    // téléphone. Le volume chargé est adapté plus bas.
    if(!(PROFILE && (PROFILE.role==='educateur'||PROFILE.role==='admin'))) return false;
    try{ return localStorage.getItem('usv_agenda_full')==='1'; }catch(e){ return false; }
  }
  function setAgendaFull(on){
    try{ localStorage.setItem('usv_agenda_full', on?'1':'0'); }catch(e){}
  }

  function loadEvents(){
    var full=agendaFull();
    var max = full
      ? (isDesktop() ? AGENDA_FULL_MAX : AGENDA_FULL_MAX_MOBILE)
      : AGENDA_MAX;

    // Quand une seule catégorie est demandée, on filtre côté serveur.
    // Le plafond d'événements profite alors entièrement à cette
    // catégorie : à volume égal, l'horizon est bien plus long.
    // Sans ça, sélectionner M6 ne changeait rien — on chargeait tout,
    // puis on masquait à l'écran.
    var cible = STATE.calFilter && STATE.calFilter!=='all' ? STATE.calFilter : null;
    var days = full ? AGENDA_FULL_DAYS
                    : (cible ? AGENDA_DAYS_FILTRE : AGENDA_DAYS_AHEAD);

    var from=new Date(Date.now()-21600000).toISOString();
    var to=new Date(Date.now()+days*86400000).toISOString();
    var url='/rest/v1/events?select=*,teams(name),profiles!events_created_by_fkey(full_name)'
      +'&order=start_at&start_at=gte.'+from+'&start_at=lte.'+to+'&limit='+max;
    if(cible){
      // La catégorie peut être la principale OU l'une des associées.
      url += '&or=(team_id.eq.'+cible+',team_ids.cs.{'+cible+'})';
    }
    return api(url).then(function(r){ STATE.events=r||[]; });
  }
  // Les présences sont demandées par paquets : une URL contenant des
  // centaines d'identifiants dépasse les limites acceptées par le serveur.
  function loadAtt(ids){
    if(!ids.length) return Promise.resolve([]);
    var CHUNK=40, chunks=[];
    for(var i=0;i<ids.length;i+=CHUNK){ chunks.push(ids.slice(i,i+CHUNK)); }
    return Promise.all(chunks.map(function(part){
      return api('/rest/v1/attendances?select=*&event_id=in.('+part.join(',')+')').catch(function(){ return []; });
    })).then(function(res){
      var out=[];
      res.forEach(function(r){ if(r&&r.length) out=out.concat(r); });
      return out;
    });
  }
  // Seuls les enfants RÉELLEMENT inscrits comptent dans les effectifs.
  // Sans ces deux filtres, une demande refusée ou une fiche archivée
  // continue d'apparaître dans « pas encore répondu » à chaque
  // entraînement — c'est le cas typique des parents séparés, où chacun
  // inscrit l'enfant de son côté et où l'une des deux fiches est refusée.
  function loadTeamMembers(teamIds){
    if(!teamIds.length) return Promise.resolve([]);
    return api('/rest/v1/team_members?select=*'
      +'&team_id=in.('+teamIds.join(',')+')'
      +'&status=eq.valide'
      +'&archived_at=is.null');
  }
  // Messages : on ne charge que les N plus récents (ordre décroissant côté
  // serveur, puis on remet dans l'ordre chronologique côté client).
  // Sans limite, tout l'historique était chargé -> saturation mémoire du
  // WebView mobile (crash / écran blanc).
  var MSG_LIMIT=80;
  function loadMessages(teamId){
    var so=(STATE.chatChannel==='staff');
    return api('/rest/v1/messages?select=*&team_id=eq.'+teamId+'&staff_only=eq.'+so+'&order=created_at.desc&limit='+MSG_LIMIT)
      .then(function(r){ return (r||[]).slice().reverse(); });
  }
  // Les groupes à afficher dans Messages. Un parent en fait partie par
  // la catégorie de son enfant, sans ligne dans group_members : lire
  // cette table seule laissait 115 parents sans aucun groupe visible.
  // Repli sur l'ancienne lecture si la fonction n'est pas encore en base.
  function loadMyGroups(){
    return api('/rest/v1/rpc/my_group_team_ids',{ method:'POST', body:{} })
      .then(function(ids){ STATE.myGroups=Array.isArray(ids)?ids:[]; })
      .catch(function(){
        return api('/rest/v1/group_members?profile_id=eq.'+USER.id+'&select=team_id')
          .then(function(r){ STATE.myGroups=(r||[]).map(function(g){return g.team_id;}); });
      });
  }
  /* ---- Messages privés (DM) ---- */
  /* Jeu de réactions volontairement court : six choix tiennent sur une
     ligne, même sur un petit téléphone, et personne n'hésite. Un clavier
     emoji complet transformerait un geste d'une seconde en décision. */
  var REACTIONS = ['👍','❤️','😂','😮','👏','💪'];
  var REACT_CACHE = {};   // { 'cat:<id>': [ {emoji, nb, mine, qui} ] }

  function loadReactions(kind, ids){
    if(!ids || !ids.length) return Promise.resolve({});
    return api('/rest/v1/rpc/reactions_for',{ method:'POST',
      body:{ p_kind:kind, p_ids:ids } })
      .then(function(rows){
        var map={};
        (rows||[]).forEach(function(r){
          (map[r.message_id] = map[r.message_id] || []).push(r);
        });
        ids.forEach(function(id){ REACT_CACHE[kind+':'+id]=map[id]||[]; });
        return map;
      })
      .catch(function(){ return {}; });
  }

  function reactionsHTML(kind, id){
    var rs = REACT_CACHE[kind+':'+id] || [];
    var h='<div class="eq-react" data-rk="'+kind+'" data-rm="'+id+'">';
    rs.forEach(function(r){
      h+='<button type="button" class="eq-react-chip'+(r.mine?' on':'')+'" '+
         'data-emo="'+esc(r.emoji)+'" title="'+esc(r.qui||'')+'">'+
         r.emoji+'<span>'+r.nb+'</span></button>';
    });
    h+='<button type="button" class="eq-react-add" title="Réagir">+</button>';
    return h+'</div>';
  }

  function bindReactions(scope, onDone){
    var zones=(scope||document).querySelectorAll('.eq-react');
    for(var i=0;i<zones.length;i++){
      (function(zone){
        var kind=zone.getAttribute('data-rk'), id=zone.getAttribute('data-rm');
        var send=function(emo){
          api('/rest/v1/rpc/toggle_reaction',{ method:'POST',
            body:{ p_kind:kind, p_message:id, p_emoji:emo } })
            .then(function(){ return loadReactions(kind,[id]); })
            .then(function(){ if(onDone) onDone(); })
            .catch(function(e){ alert(e.message); });
        };
        zone.querySelectorAll('.eq-react-chip').forEach(function(c){
          c.addEventListener('click', function(){ send(this.getAttribute('data-emo')); });
        });
        var add=zone.querySelector('.eq-react-add');
        if(add) add.addEventListener('click', function(){
          // Palette ouverte au clic, refermée au choix ou au clic dehors.
          var old=document.querySelector('.eq-react-pal');
          if(old) old.remove();
          var pal=document.createElement('div');
          pal.className='eq-react-pal';
          pal.innerHTML=REACTIONS.map(function(e){
            return '<button type="button" data-e="'+e+'">'+e+'</button>';
          }).join('');
          zone.appendChild(pal);
          pal.querySelectorAll('button').forEach(function(b){
            b.addEventListener('click', function(ev){
              ev.stopPropagation();
              pal.remove(); send(this.getAttribute('data-e'));
            });
          });
          setTimeout(function(){
            document.addEventListener('click', function h(){
              pal.remove(); document.removeEventListener('click', h);
            });
          }, 0);
        });
      })(zones[i]);
    }
  }

  function dmEditMessage(id, body){ return api('/rest/v1/rpc/dm_edit_message',{ method:'POST', body:{ p_id:id, p_body:body }, prefer:'return=minimal' }); }
  function dmDeleteMessage(id){ return api('/rest/v1/rpc/dm_delete_message',{ method:'POST', body:{ p_id:id }, prefer:'return=minimal' }); }
  function dmMyThreads(){ return api('/rest/v1/rpc/dm_my_threads',{ method:'POST', body:{} }); }
  function dmCreateGroup(title, members){ return api('/rest/v1/rpc/dm_create_group',{ method:'POST', body:{ p_title:title, p_members:members } }); }
  function dmGroupMembers(tid){ return api('/rest/v1/rpc/dm_group_members',{ method:'POST', body:{ p_thread:tid } }); }
  function dmAddMember(tid, pid){ return api('/rest/v1/rpc/dm_add_member',{ method:'POST', body:{ p_thread:tid, p_profile:pid }, prefer:'return=minimal' }); }
  function dmRemoveMember(tid, pid){ return api('/rest/v1/rpc/dm_remove_member',{ method:'POST', body:{ p_thread:tid, p_profile:pid }, prefer:'return=minimal' }); }
  function dmRenameGroup(tid, title){ return api('/rest/v1/rpc/dm_rename_group',{ method:'POST', body:{ p_thread:tid, p_title:title }, prefer:'return=minimal' }); }

  function dmContacts(){ return api('/rest/v1/rpc/dm_contacts',{ method:'POST', body:{} }); }
  function dmOpenThread(otherId){ return api('/rest/v1/rpc/dm_open_thread',{ method:'POST', body:{ other_id:otherId } }); }
  function dmLoadMessages(threadId){
    // idem : seulement les messages récents de la conversation
    return api('/rest/v1/dm_messages?select=*&thread_id=eq.'+threadId+'&order=created_at.desc&limit='+MSG_LIMIT)
      .then(function(r){ return (r||[]).slice().reverse(); });
  }
  function dmSend(threadId,bodyTxt,imageUrl){
    return api('/rest/v1/rpc/dm_send',{ method:'POST', body:{ p_thread_id:threadId, p_body:bodyTxt, p_image_url:imageUrl||null }, prefer:'return=minimal' })
      .then(function(res){
        // Notifie l'autre participant. Non bloquant : si la notification
        // échoue, le message est déjà parti et la conversation continue.
        try{
          var who=(PROFILE && PROFILE.full_name) ? PROFILE.full_name : 'Un membre';
          var preview = imageUrl && !bodyTxt ? '📷 Photo' : (bodyTxt||'');
          if(preview.length>90) preview=preview.slice(0,90)+'…';
          sendPush({ mode:'dm', thread_id:threadId, title:who, body:preview }).catch(function(){});
        }catch(e){}
        return res;
      });
  }
  function dmMarkRead(threadId){ return api('/rest/v1/rpc/dm_mark_read',{ method:'POST', body:{ p_thread_id:threadId }, prefer:'return=minimal' }); }
  function dmUnreadCount(){ return api('/rest/v1/rpc/dm_unread_count',{ method:'POST', body:{} }); }
  function loadGroupRoster(teamId){ return api('/rest/v1/rpc/group_roster',{ method:'POST', body:{ t_id:teamId } }); }



  /* ============================================================
     AUTH VIEW
     ============================================================ */
  var isSignup=false;
  function renderAuth(){
    ROOT.innerHTML =
    '<div class="eq-auth">'+
      '<div class="eq-mesh"><span></span><span></span><span></span><span></span></div>'+
      '<div class="eq-grain"></div>'+
      '<div class="eq-auth-inner">'+
        '<div class="eq-auth-logo"><img src="https://cdn.shopify.com/s/files/1/0977/2200/7934/files/14_1.png?v=1776774666" alt="USV"></div>'+
        '<div class="eq-auth-title">USV Connect</div>'+
        '<div class="eq-auth-sub" id="eqAuthSub">'+(isSignup?'Crée ton compte club':'Espace parents & éducateurs')+'</div>'+
        '<div class="eq-auth-hint">🔑 Même identifiant que le <strong>Cashless USV</strong>. Si tu as déjà un compte cashless, connecte-toi directement avec.</div>'+
        '<div class="eq-card">'+
          '<div id="eqMsg"></div>'+
          (isSignup?'<div class="eq-field"><label>Nom complet</label><input class="eq-input" type="text" id="eqName" placeholder="Prénom Nom" autocomplete="name"></div>':'')+
          '<div class="eq-field"><label>Email</label><input class="eq-input" type="email" id="eqEmail" placeholder="email@exemple.fr" autocomplete="email"></div>'+
          '<div class="eq-field"><label>Mot de passe</label><input class="eq-input" type="password" id="eqPass" placeholder="••••••••" autocomplete="current-password"></div>'+
          '<button type="button" class="eq-btn" id="eqBtn">'+(isSignup?'Créer mon compte':'Se connecter')+'</button>'+
          (isSignup?'':'<div class="eq-switch"><a id="eqForgot">Mot de passe oublié&nbsp;?</a></div>')+
          '<div class="eq-switch">'+(isSignup?'Déjà un compte ? <a id="eqToggle">Se connecter</a>':'Nouveau au club ? <a id="eqToggle">Créer un compte</a>')+'</div>'+
        '</div>'+
      '</div>'+
    '</div>';

    document.getElementById('eqToggle').addEventListener('click', function(){ isSignup=!isSignup; renderAuth(); });

    var forgot=document.getElementById('eqForgot');
    if(forgot) forgot.addEventListener('click', function(){
      var mail=(document.getElementById('eqEmail').value||'').trim();
      if(!mail){
        showMsg('err','⚠️','Saisis d\'abord ton adresse e-mail, puis reclique sur « Mot de passe oublié ».');
        document.getElementById('eqEmail').focus();
        return;
      }
      this.textContent='Envoi…';
      var self=this;
      // redirect_to se passe en PARAMÈTRE D'URL, pas dans le corps :
      // dans le corps il est ignoré en silence, et Supabase renvoie
      // alors sur l'URL du site par défaut — la page d'accueil, où
      // l'application n'est pas chargée et où le jeton reste sans effet.
      var retour = window.location.origin + window.location.pathname;
      fetch(SUPA_URL+'/auth/v1/recover?redirect_to='+encodeURIComponent(retour), {
        method:'POST',
        headers:{ 'apikey':SUPA_KEY, 'Content-Type':'application/json' },
        body: JSON.stringify({ email: mail })
      })
      .then(function(){
        // Supabase répond toujours OK, même si l'adresse est inconnue :
        // c'est volontaire, ça évite de révéler qui a un compte.
        showMsg('ok','📧','Si un compte existe avec cette adresse, un e-mail vient de partir. '+
                'Pense à regarder dans les indésirables.');
        self.textContent='Mot de passe oublié ?';
      })
      .catch(function(){
        showMsg('err','⚠️','Envoi impossible pour le moment. Réessaie dans un instant.');
        self.textContent='Mot de passe oublié ?';
      });
    });
    document.getElementById('eqBtn').addEventListener('click', doAuth);
    var pass=document.getElementById('eqPass');
    pass.addEventListener('keydown', function(e){ if(e.keyCode===13) doAuth(); });
  }

  /* Mon profil : nom, photo, déconnexion. L'avatar du bandeau y mène —
     c'est l'endroit où on va naturellement chercher ses réglages, et
     ça évite un onglet de plus dans une barre déjà chargée. */
  function openProfile(){
    var nouvellePhoto=null;
    var ov=document.createElement('div'); ov.className='eq-modal';
    ov.innerHTML='<div class="eq-modal-ov" id="eqPrOv"></div><div class="eq-modal-card">'+
      '<div class="eq-modal-grab"></div>'+
      '<div class="eq-modal-title">Mon profil</div>'+
      '<div class="eq-modal-sub">'+esc((USER&&USER.email)||'')+'</div>'+
      '<div id="eqPrMsg"></div>'+
      '<label class="eq-avatar-edit" id="eqPrPhoto">'+
        (PROFILE.avatar_url
          ? '<img src="'+esc(PROFILE.avatar_url)+'" alt="">'
          : '<span>'+initials(PROFILE.full_name||(USER&&USER.email))+'</span>')+
        '<span class="eq-avatar-cam">'+IC.camera+'</span>'+
        '<input type="file" accept="image/*" id="eqPrFile">'+
      '</label>'+
      '<div class="eq-field-hint" style="text-align:center;margin-bottom:14px">'+
        'Touche la photo pour la changer</div>'+
      '<div class="eq-field"><label>Nom affiché</label>'+
        '<input class="eq-input" id="eqPrName" value="'+esc(PROFILE.full_name||'')+'" maxlength="60"></div>'+
      '<button type="button" class="eq-btn" id="eqPrSave">Enregistrer</button>'+
      (PROFILE.avatar_url
        ? '<button type="button" class="eq-btn eq-btn-ghost" id="eqPrDel" style="margin-top:10px">Retirer la photo</button>'
        : '')+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqPrOut" style="margin-top:10px">Se déconnecter</button>'+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqPrClose" style="margin-top:10px">Fermer</button>'+
      '</div>';
    document.querySelector('.eq-app').appendChild(ov);
    var close=function(){ if(ov.parentNode) ov.parentNode.removeChild(ov); };
    document.getElementById('eqPrOv').addEventListener('click', close);
    document.getElementById('eqPrClose').addEventListener('click', close);
    document.getElementById('eqPrOut').addEventListener('click', function(){
      if(confirm('Se déconnecter ?')){ close(); clearSession(); renderAuth(); }
    });
    var dire=function(t,err){
      document.getElementById('eqPrMsg').innerHTML='<div class="eq-msg eq-msg-'+(err?'err':'ok')+
        '"><span class="eq-msg-ic">'+(err?'⚠️':'✅')+'</span><span>'+esc(t)+'</span></div>';
    };

    document.getElementById('eqPrFile').addEventListener('change', function(){
      var f=this.files && this.files[0]; if(!f) return;
      if(f.size > 6*1024*1024){ dire('Photo trop lourde (6 Mo maximum).', true); return; }
      nouvellePhoto=f;
      var r=new FileReader();
      r.onload=function(e){
        var box=document.getElementById('eqPrPhoto');
        var img=box.querySelector('img');
        if(!img){
          // On insère l'aperçu sans réécrire le contenu : remplacer
          // innerHTML détruirait le champ fichier et son écouteur.
          var sp=box.querySelector('span'); if(sp) sp.remove();
          img=document.createElement('img'); box.insertBefore(img, box.firstChild);
        }
        img.src=e.target.result;
      };
      r.readAsDataURL(f);
    });

    document.getElementById('eqPrSave').addEventListener('click', function(){
      var nom=document.getElementById('eqPrName').value.trim();
      if(!nom){ dire('Indique un nom.', true); return; }
      var btn=this; btn.disabled=true; dire('Enregistrement…');

      var envoiPhoto = nouvellePhoto
        ? (function(){
            var ext=(nouvellePhoto.name.split('.').pop()||'jpg').toLowerCase().replace(/[^a-z0-9]/g,'');
            // Le nom du fichier commence par l'identifiant : c'est ce que
            // la règle de stockage exige, pour que personne ne remplace
            // la photo d'un autre.
            var chemin=USER.id+'-'+Date.now()+'.'+ext;
            return fetch(SUPA_URL+'/storage/v1/object/avatars/'+chemin, {
              method:'POST',
              headers:{ 'apikey':SUPA_KEY, 'Authorization':'Bearer '+TOKEN,
                        'Content-Type':nouvellePhoto.type||'image/jpeg' },
              body:nouvellePhoto
            }).then(function(r){
              if(!r.ok) return r.text().then(function(t){ throw new Error('Envoi de la photo : '+t); });
              return SUPA_URL+'/storage/v1/object/public/avatars/'+chemin;
            });
          })()
        : Promise.resolve(PROFILE.avatar_url || null);

      envoiPhoto.then(function(url){
        return api('/rest/v1/profiles?id=eq.'+USER.id,{ method:'PATCH',
          prefer:'return=minimal', body:{ full_name:nom, avatar_url:url } })
          .then(function(){ PROFILE.full_name=nom; PROFILE.avatar_url=url; });
      })
      .then(function(){ close(); render(); })
      .catch(function(e){ btn.disabled=false; dire(e.message, true); });
    });

    var del=document.getElementById('eqPrDel');
    if(del) del.addEventListener('click', function(){
      api('/rest/v1/profiles?id=eq.'+USER.id,{ method:'PATCH',
        prefer:'return=minimal', body:{ avatar_url:null } })
        .then(function(){ PROFILE.avatar_url=null; close(); render(); })
        .catch(function(e){ dire(e.message, true); });
    });
  }

  function showMsg(type, ic, text){
    var b=document.getElementById('eqMsg');
    if(!b) return;
    b.innerHTML='<div class="eq-msg eq-msg-'+type+'"><span class="eq-msg-ic">'+ic+'</span><span>'+text+'</span></div>';
  }

  function doAuth(){
    var email=document.getElementById('eqEmail').value.trim();
    var pass=document.getElementById('eqPass').value;
    var btn=document.getElementById('eqBtn');
    if(!email||!pass){ showMsg('err','⚠️','Email et mot de passe requis.'); return; }
    btn.disabled=true;
    if(isSignup){
      var nameEl=document.getElementById('eqName');
      var meta={ full_name: nameEl?nameEl.value.trim():'', role:'parent' };
      authReq('signup',email,pass,meta).then(function(d){
        if(d.access_token){ saveSession(d); return loadProfile().then(enterApp); }
        showMsg('ok','✅','Compte créé ! Tu peux te connecter.');
        isSignup=false; setTimeout(renderAuth,1200);
      }).catch(function(e){
        // compte déjà existant -> message clair orienté cashless
        var m=(e.message||'').toLowerCase();
        if(e.status===422 || e.status===400 || m.indexOf('already')!==-1 || m.indexOf('registered')!==-1 || m.indexOf('exist')!==-1 || e.code==='user_already_exists'){
          showMsg('info','🔑','Cet email a déjà un compte (sûrement ton compte <strong>Cashless USV</strong>). Pas besoin d\'en créer un nouveau : connecte-toi avec le même mot de passe que le cashless.');
          isSignup=false;
          setTimeout(function(){ renderAuth(); var em=document.getElementById('eqEmail'); if(em) em.value=email; showMsg('info','🔑','Utilise ton identifiant Cashless USV pour te connecter.'); }, 100);
        } else {
          showMsg('err','⚠️', esc(e.message));
        }
      }).then(function(){ if(document.getElementById('eqBtn')) document.getElementById('eqBtn').disabled=false; });
    } else {
      authReq('login',email,pass).then(function(d){ saveSession(d); return loadProfile().then(enterApp); })
      .catch(function(e){
        var m=(e.message||'').toLowerCase();
        if(m.indexOf('invalid')!==-1 || m.indexOf('credential')!==-1){
          showMsg('err','⚠️','Email ou mot de passe incorrect. <br>Rappel : c\'est le <strong>même identifiant que le Cashless USV</strong>.');
        } else {
          showMsg('err','⚠️', esc(e.message));
        }
        if(document.getElementById('eqBtn')) document.getElementById('eqBtn').disabled=false;
      });
    }
  }

  /* ============================================================
     APP SHELL
     ============================================================ */
  function enterApp(){
    var staff=(PROFILE.role==='educateur'||PROFILE.role==='admin');
    var isAdmin=(PROFILE.role==='admin');
    var roleLabel=PROFILE.role==='educateur'?'Éducateur':(isAdmin?'Administrateur':'Membre');

    // enregistre le token push si l'app native l'a déjà fourni
    if (window.USV_PUSH_TOKEN && !PENDING_PUSH_TOKEN) { PENDING_PUSH_TOKEN={token:window.USV_PUSH_TOKEN, platform:window.USV_PLATFORM||''}; }
    // L'app peut fournir le jeton APRÈS le chargement de la page : on
    // laisse une seconde chance, sinon un démarrage un peu lent suffit
    // à ce que personne ne soit jamais enregistré.
    Promise.resolve(savePushToken()).then(checkPushHealth);
    setTimeout(function(){
      if(!PUSH_STATE.ok){
        if (window.USV_PUSH_TOKEN && !PENDING_PUSH_TOKEN) {
          PENDING_PUSH_TOKEN={token:window.USV_PUSH_TOKEN, platform:window.USV_PLATFORM||''};
        }
        Promise.resolve(savePushToken()).then(checkPushHealth);
      }
    }, 4000);

    var nav='<button type="button" data-tab="cal" class="on"><span class="eq-nav-ic">'+IC.cal+'</span>Agenda</button>'+
            '<button type="button" data-tab="chat"><span class="eq-nav-ic">'+IC.chat+'</span>Messages</button>'+
            '<button type="button" data-tab="teams"><span class="eq-nav-ic">'+IC.teams+'</span>Enfants</button>'+
            (staff?'<button type="button" data-tab="valid"><span class="eq-nav-ic">'+IC.check2+
              '<span class="eq-nav-badge eq-hidden" id="eqPendingBadge"></span></span>Valider</button>':'')+
            (staff?'<button type="button" data-tab="staff"><span class="eq-nav-ic">'+IC.staff+'</span>Coach</button>':'')+
            // Les inscriptions aux stages (coordonnées des familles, paiements)
            // sont réservées aux administrateurs.
            (isAdmin?'<button type="button" data-tab="stage"><span class="eq-nav-ic">'+IC.clipboard+'</span>Stage</button>':'')+
            (isAdmin?'<button type="button" data-tab="admin"><span class="eq-nav-ic">'+IC.admin+'</span>Admin</button>':'');

    ROOT.innerHTML =
    '<div class="eq-app">'+
      '<div class="eq-mesh"><span></span><span></span><span></span><span></span></div>'+
      '<div class="eq-grain"></div>'+
      '<div class="eq-top">'+
        '<div class="eq-top-l">'+
          '<div class="eq-top-logo"><img src="https://cdn.shopify.com/s/files/1/0977/2200/7934/files/14_1.png?v=1776774666" alt="USV"></div>'+
          '<div><div class="eq-top-name">USV Connect</div><div class="eq-top-sub">'+esc(roleLabel)+'</div></div>'+
        '</div>'+
        '<div class="eq-avatar" id="eqProfile" title="Mon profil">'+
          (PROFILE.avatar_url
            ? '<img src="'+esc(PROFILE.avatar_url)+'" alt="">'
            : initials(PROFILE.full_name||(USER&&USER.email)))+'</div>'+
      '</div>'+
      // Emplacement du bandeau de notifications. Il était dans un
      // conteneur eq-wrap, conçu pour le contenu principal : 34 px en haut
      // et jusqu'à 150 px en bas. Vide, il repoussait toute la page de
      // près de 200 px. Son conteneur propre ne prend aucune place tant
      // qu'il n'y a rien à afficher.
      '<div class="eq-pushslot" id="eqPushWarn"></div>'+
      '<div class="eq-wrap" id="eqBody"></div>'+
      (staff?'<button type="button" class="eq-fab eq-hidden" id="eqFab">+</button>':'')+
      '<div class="eq-nav" id="eqNav"><div class="eq-nav-inner">'+nav+'</div></div>'+
    '</div>';

    document.getElementById('eqProfile').addEventListener('click', openProfile);

    /* Demandes d'inscription en attente : une pastille rouge sur l'onglet
       Admin. Rafraîchie à l'ouverture puis toutes les deux minutes —
       assez pour ne rien manquer, assez peu pour ne pas peser sur une
       connexion mobile au bord du terrain. */
    if(staff){
      var refreshPending=function(){
        Promise.all([
          api('/rest/v1/rpc/pending_signups_count',{ method:'POST', body:{} }),
          api('/rest/v1/rpc/count_child_link_requests',{ method:'POST', body:{} })
            .catch(function(){ return 0; })
        ]).then(function(r){
            var b=document.getElementById('eqPendingBadge');
            if(!b) return;
            // Inscriptions + rattachements : les deux se traitent dans le
            // même onglet, la pastille doit annoncer le total.
            var nb=(parseInt(r[0],10)||0)+(parseInt(r[1],10)||0);
            if(nb>0){ b.textContent=(nb>9?'9+':String(nb)); b.classList.remove('eq-hidden'); }
            else { b.classList.add('eq-hidden'); }
          })
          .catch(function(){});
      };
      refreshPending();
      if(window.__eqPendingTimer) clearInterval(window.__eqPendingTimer);
      window.__eqPendingTimer=setInterval(refreshPending, 120000);
    }
    var navBtns=document.getElementById('eqNav').querySelectorAll('button');
    for(var i=0;i<navBtns.length;i++){ navBtns[i].addEventListener('click', function(){ switchTab(this.getAttribute('data-tab')); }); }
    var fab=document.getElementById('eqFab'); if(fab) fab.addEventListener('click', function(){ openEvModal(); });

    // effet de profondeur topbar au scroll (fluide, façon iOS)
    // Garde anti-doublon : enterApp() peut être rappelé (reconnexion),
    // il ne faut pas empiler les listeners de scroll.
    if(!STATE._topbarBound){
      STATE._topbarBound=true;
      var topbar=document.querySelector('.usveq .eq-top');
      var tbTicking=false;
      window.addEventListener('scroll', function(){
        if(tbTicking) return;
        tbTicking=true;
        window.requestAnimationFrame(function(){
          tbTicking=false;
          if(!topbar) return;
          if(window.pageYOffset>8) topbar.classList.add('scrolled');
          else topbar.classList.remove('scrolled');
        });
      }, { passive:true });
    }

    // applique les micro-interactions à chaque changement de contenu
    // Garde anti-doublon + anti-rebond : sans ça, polish() se rappelait
    // en cascade à chaque mutation (boucle → plantage Safari mobile).
    if(window.MutationObserver && !STATE._moBound){
      STATE._moBound=true;
      var bodyEl=document.getElementById('eqBody');
      var polishTimer=null;
      var mo=new MutationObserver(function(){
        if(polishTimer) clearTimeout(polishTimer);
        polishTimer=setTimeout(function(){ polishTimer=null; polish(); }, 120);
      });
      mo.observe(bodyEl, { childList:true });
    }

    Promise.all([loadTeams(),loadMyTeams(),loadEvents(),loadMyGroups()]).then(function(){
      // Arrivée depuis une notification : on ouvre directement la bonne
      // conversation au lieu de l'agenda. Sinon, l'agenda par défaut.
      STATE._ready=true;
      var cible=lireCible();
      if(!(cible && openTarget(cible))) switchTab('cal');
      refreshDMBadge(); loadCatUnread();

      // Rafraîchissement des non-lus : toutes les minutes tant que
      // l'écran est visible, et dès que l'utilisateur revient dans
      // l'application.
      if(!STATE._unreadTimer){
        STATE._unreadTimer=setInterval(function(){
          if(document.visibilityState==='visible'){ loadCatUnread(); refreshDMBadge(); }
        }, 60000);
        document.addEventListener('visibilitychange', function(){
          if(document.visibilityState==='visible'){ loadCatUnread(); refreshDMBadge(); }
        });
      }
    })
      .catch(function(e){ document.getElementById('eqBody').innerHTML='<div class="eq-empty"><div class="eq-empty-t">Erreur de chargement</div><div class="eq-empty-d">'+esc(e.message)+'</div></div>'; });
  }

  function setNav(tab){
    var b=document.getElementById('eqNav').querySelectorAll('button');
    for(var i=0;i<b.length;i++) b[i].classList.toggle('on', b[i].getAttribute('data-tab')===tab);
    var fab=document.getElementById('eqFab');
    if(fab) fab.classList.toggle('eq-hidden', tab!=='staff' && tab!=='cal');
  }

  function switchTab(tab){
    STATE.view=tab; setNav(tab);
    var bodyTab=document.getElementById('eqBody');
    if(bodyTab) bodyTab.classList.remove('eq-chatmode');
    // transition d'entrée façon appli native
    var body=document.getElementById('eqBody');
    if(body){
      body.classList.remove('eq-tab-enter');
      void body.offsetWidth; // force reflow pour relancer l'animation
      body.classList.add('eq-tab-enter');
    }
    if(tab==='cal') renderCalendar();
    if(tab==='chat'){ STATE.chatOpen=false; STATE.dmThread=null; renderMsgList(); }
    if(tab==='teams') renderTeams();
    if(tab==='valid') renderValidation();
    if(tab==='staff') renderStaff();
    if(tab==='stage') renderStage();
    if(tab==='admin') renderAdmin();
  }

  function loadingHTML(){
    var card='<div class="eq-sk-card"><div class="eq-sk eq-sk-av"></div><div class="eq-sk-lines"><div class="eq-sk eq-sk-line w70"></div><div class="eq-sk eq-sk-line w40"></div><div class="eq-sk eq-sk-line w90"></div></div></div>';
    return card+card+card;
  }

  // Compte à rebours humain jusqu'à une date
  function countdownLabel(dateStr){
    var now=new Date();
    var d=new Date(dateStr);
    var diff=d.getTime()-now.getTime();
    if(diff<0) return 'En cours';
    var days=Math.floor(diff/86400000);
    var hours=Math.floor((diff%86400000)/3600000);
    var sameDay=(d.toDateString()===now.toDateString());
    var tomorrow=new Date(now.getTime()+86400000);
    var isTomorrow=(d.toDateString()===tomorrow.toDateString());
    if(sameDay){
      if(hours<=0) return 'Dans moins d\'une heure';
      return 'Aujourd\'hui · dans '+hours+'h';
    }
    if(isTomorrow) return 'Demain';
    if(days<7) return 'Dans '+days+' jour'+(days>1?'s':'');
    if(days<14) return 'Dans une semaine';
    return 'Dans '+Math.floor(days/7)+' semaines';
  }

  // Grande carte vedette pour le prochain événement
  function heroHTML(ev){
    var tn=teamLabel(ev);
    var tl={entrainement:'Entraînement',match:'Match',tournoi:'Tournoi',benevolat:'Bénévolat',autre:'Événement'}[ev.type]||ev.type;
    var dObj=new Date(ev.start_at);
    var dayName=dObj.toLocaleDateString('fr-FR',{weekday:'long'});
    var dateLong=dObj.getDate()+' '+dObj.toLocaleDateString('fr-FR',{month:'long'});
    var h='<div class="eq-hero t-'+ev.type+'">';
    h+='<div class="eq-hero-glow"></div>';
    h+='<div class="eq-hero-top"><span class="eq-hero-count">'+countdownLabel(ev.start_at)+'</span><span class="eq-hero-type">'+tl+'</span></div>';
    h+='<div class="eq-hero-title">'+esc(ev.title)+'</div>';
    h+='<div class="eq-hero-team">'+esc(tn)+'</div>';
    // Date et heure réunies sur une ligne, le lieu sur la suivante : la
    // carte passe de cinq lignes à trois.
    var heure=fmtTime(ev.start_at)+(ev.end_at?' → '+fmtEndTime(ev.end_at):'');
    // fmtTime renvoie « Mardi · 18h00 » : on garde juste l'heure pour ne
    // pas répéter le jour déjà écrit dans la date.
    heure=heure.replace(/^[^·]*·\s*/,'');
    h+='<div class="eq-hero-meta">';
    h+='<div class="eq-hero-meta-row">'+IC.cal+'<span>'+dayName.charAt(0).toUpperCase()+dayName.slice(1)+' '+dateLong+' · '+heure+'</span></div>';
    if(ev.location) h+='<div class="eq-hero-meta-row">'+IC.pin+'<span>'+esc(ev.location)+'</span></div>';
    h+='</div>';
    h+='</div>';
    return h;
  }

  /* ---------- Micro-interactions premium ---------- */
  // Apparition en cascade des cartes + spotlight qui suit le curseur
  function polish(){
    var body=document.getElementById('eqBody');
    if(!body) return;
    // Sur mobile/tactile : pas de spotlight souris (inutile) et surtout
    // pas de listener par carte, qui s'accumulaient à chaque re-rendu
    // et saturaient la mémoire (écrans blancs / plantages).
    var isTouch=('ontouchstart' in window) || (navigator.maxTouchPoints>0) || window.innerWidth<=760;
    var cards=body.querySelectorAll('.eq-ev,.eq-child,.eq-member,.eq-dossier');
    // On ne (re)pose le délai d'apparition qu'UNE FOIS par carte : sans ce
    // garde, polish() étant rappelé à chaque mutation du DOM, les animations
    // d'entrée se relançaient et la page semblait « sauter ».
    var newIdx=0;
    for(var i=0;i<cards.length;i++){
      if(cards[i].getAttribute('data-polished')) continue;
      cards[i].setAttribute('data-polished','1');
      // Cascade plafonnée : seules les premières cartes apparaissent en
      // décalé. Sans plafond, la 30e attendait 1,6 s avant de s'afficher,
      // et l'agenda semblait lent à charger alors qu'il était prêt.
      cards[i].style.animationDelay=(Math.min(newIdx,6)*40)+'ms';
      newIdx++;
    }
    if(isTouch) return;
    // Desktop uniquement : un seul listener délégué sur le conteneur
    // (au lieu d'un par carte), posé une seule fois.
    if(!STATE._spotlightBound){
      STATE._spotlightBound=true;
      body.addEventListener('mousemove', function(e){
        var card=e.target.closest ? e.target.closest('.eq-ev,.eq-child,.eq-member,.eq-dossier') : null;
        if(!card) return;
        var r=card.getBoundingClientRect();
        card.style.setProperty('--mx', ((e.clientX-r.left)/r.width*100)+'%');
        card.style.setProperty('--my', ((e.clientY-r.top)/r.height*100)+'%');
      });
    }
  }

  /* ============================================================
     CALENDRIER
     ============================================================ */
  // Retourne le tableau des équipes d'un événement (multi ou simple)
  function evTeams(ev){
    if(ev.team_ids && ev.team_ids.length) return ev.team_ids;
    if(ev.team_id) return [ev.team_id];
    return [];
  }
  // Libellé des catégories d'un événement (ex: "M6 · M8 · M10")
  function teamLabel(ev){
    var tids=evTeams(ev);
    if(tids.length<=1){ return ev.teams ? ev.teams.name : ((STATE.teams.filter(function(t){return t.id===tids[0];})[0]||{}).name||''); }
    var names=tids.map(function(id){ return (STATE.teams.filter(function(t){return t.id===id;})[0]||{}).name||''; }).filter(Boolean);
    return names.join(' · ');
  }
  /* Choix des catégories affichées dans l'agenda. */
  function openTeamsConfig(){
    var masquees=hiddenTeams();
    var ov=document.createElement('div'); ov.className='eq-modal';
    ov.innerHTML='<div class="eq-modal-ov" id="eqTcOv"></div><div class="eq-modal-card">'+
      '<div class="eq-modal-grab"></div>'+
      '<div class="eq-modal-title">Catégories affichées</div>'+
      '<div class="eq-modal-sub">Décoche celles que tu ne veux pas voir dans ton agenda. '+
        'Ça ne change rien pour les autres, ni tes droits.</div>'+
      '<div class="eq-grp-list">'+
        STATE.teams.map(function(t){
          var visible=(masquees.indexOf(t.id)===-1);
          return '<button type="button" class="eq-grp-row'+(visible?' on':'')+'" '+
            'data-tc="'+t.id+'"><span class="eq-grp-check"></span>'+
            '<span class="eq-grp-name">'+esc(t.name)+'</span></button>';
        }).join('')+
      '</div>'+
      '<button type="button" class="eq-btn" id="eqTcSave" style="margin-top:12px">Appliquer</button>'+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqTcAll" style="margin-top:10px">Tout afficher</button>'+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqTcClose" style="margin-top:10px">Annuler</button>'+
      '</div>';
    document.querySelector('.eq-app').appendChild(ov);
    var close=function(){ if(ov.parentNode) ov.parentNode.removeChild(ov); };
    document.getElementById('eqTcOv').addEventListener('click', close);
    document.getElementById('eqTcClose').addEventListener('click', close);

    ov.querySelectorAll('[data-tc]').forEach(function(b){
      b.addEventListener('click', function(){ this.classList.toggle('on'); });
    });
    document.getElementById('eqTcAll').addEventListener('click', function(){
      setHiddenTeams([]); close();
      if(STATE.calFilter!=='all'){ STATE.calFilter='all'; loadEvents().then(renderCalendar); }
      else renderCalendar();
    });
    document.getElementById('eqTcSave').addEventListener('click', function(){
      var cachees=[];
      ov.querySelectorAll('[data-tc]').forEach(function(b){
        if(!b.classList.contains('on')) cachees.push(b.getAttribute('data-tc'));
      });
      setHiddenTeams(cachees);
      close();
      // Si la catégorie filtrée vient d'être masquée, on revient à
      // « Toutes » plutôt que d'afficher un agenda vide sans explication.
      if(STATE.calFilter!=='all' && cachees.indexOf(STATE.calFilter)!==-1){
        STATE.calFilter='all';
        loadEvents().then(renderCalendar).catch(function(){ renderCalendar(); });
      } else renderCalendar();
    });
  }

  function renderCalendar(){
    var body=document.getElementById('eqBody');
    var staff=(PROFILE.role==='educateur'||PROFILE.role==='admin');
    // équipes présentes dans les événements (pour construire le filtre)
    // Les chips se construisaient à partir des événements chargés. Depuis
    // que le filtre s'applique côté serveur, sélectionner M10 ne charge
    // plus que du M10 : il ne restait qu'une catégorie, la barre entière
    // disparaissait, et avec elle « Toutes » et la roue dentée. On
    // mémorise donc la liste complète au premier chargement non filtré.
    if(STATE.calFilter==='all'){
      var vues=[];
      STATE.events.forEach(function(e){
        evTeams(e).forEach(function(tid){ if(vues.indexOf(tid)===-1) vues.push(tid); });
      });
      // Les catégories déjà connues ne disparaissent pas si elles n'ont
      // plus d'événement dans la fenêtre affichée.
      (STATE.calTeamIds||[]).forEach(function(tid){ if(vues.indexOf(tid)===-1) vues.push(tid); });
      STATE.calTeamIds=vues;
    }
    var filterTeamIds=(STATE.calTeamIds||[]).slice();
    // Sécurité : la catégorie actuellement filtrée figure toujours dans
    // la barre, même si la mémoire était vide au premier affichage.
    if(STATE.calFilter!=='all' && filterTeamIds.indexOf(STATE.calFilter)===-1){
      filterTeamIds.push(STATE.calFilter);
    }
    // barre de filtre (seulement si au moins 2 équipes différentes)
    var filterBar='';
    if(filterTeamIds.length>1){
      // tri des équipes selon l'ordre de STATE.teams
      var masquees=staff?hiddenTeams():[];
      var orderedTeams=STATE.teams.filter(function(t){
        return filterTeamIds.indexOf(t.id)!==-1 && masquees.indexOf(t.id)===-1;
      });
      filterBar='<div class="eq-calfilter" id="eqCalFilter">';
      filterBar+='<button class="eq-calfilter-chip'+(STATE.calFilter==='all'?' on':'')+'" data-f="all" type="button">Toutes</button>';
      orderedTeams.forEach(function(t){
        filterBar+='<button class="eq-calfilter-chip'+(STATE.calFilter===t.id?' on':'')+'" data-f="'+t.id+'" type="button">'+esc(t.name)+'</button>';
      });
      // Réglage des catégories affichées, réservé au staff : un parent
      // n'a de toute façon que les catégories de ses enfants.
      if(staff){
        filterBar+='<button type="button" class="eq-calfilter-chip eq-calfilter-cfg" '+
          'id="eqTeamsCfg" title="Choisir les catégories affichées">⚙</button>';
      }
      filterBar+='</div>';
    }
    // Filtre par type. Construit à partir des types réellement présents :
    // afficher « Tournoi » quand il n'y en a aucun ferait une chip morte.
    var TYPE_LABELS={entrainement:'Entraînement',match:'Match',
                     tournoi:'Tournoi',benevolat:'Bénévolat',autre:'Événement'};
    var presentTypes=[];
    STATE.events.forEach(function(e){
      if(e.type && presentTypes.indexOf(e.type)===-1) presentTypes.push(e.type);
    });
    presentTypes.sort(function(a,b){
      // Le bénévolat vient juste après les entraînements : c'est un
      // appel à l'aide, il doit se voir.
      var order=['entrainement','benevolat','match','tournoi','autre'];
      return order.indexOf(a)-order.indexOf(b);
    });
    var typeBar='';
    if(presentTypes.length>1){
      typeBar='<div class="eq-calfilter eq-calfilter--type" id="eqCalType">';
      typeBar+='<button class="eq-calfilter-chip'+(STATE.calType==='all'?' on':'')+
               '" data-t="all" type="button">Tous les types</button>';
      presentTypes.forEach(function(ty){
        typeBar+='<button class="eq-calfilter-chip'+(STATE.calType===ty?' on':'')+
                 '" data-t="'+ty+'" type="button">'+esc(TYPE_LABELS[ty]||ty)+'</button>';
      });
      typeBar+='</div>';
    }
    // Sélecteur de période : uniquement sur ordinateur et pour le staff.
    // Sur mobile il reste masqué, la fenêtre courte étant nécessaire à la
    // stabilité de la WebView.
    var rangeBar='', rangeNote='';
    if(staff){
      var full=agendaFull();
      // Sans libellé, en sélecteur compact : il rejoint la rangée des
      // types au lieu d'occuper une ligne entière.
      rangeBar='<div class="eq-calrange">'+
        '<button type="button" class="eq-calrange-chip'+(full?'':' on')+'" data-r="short">2 mois</button>'+
        '<button type="button" class="eq-calrange-chip'+(full?' on':'')+'" data-r="full">Saison</button>'+
        '</div>';
      if(full && !isDesktop()){
        rangeNote='<div class="eq-calrange-note">Affichage limité aux '+
          AGENDA_FULL_MAX_MOBILE+' prochains rendez-vous sur téléphone</div>';
      }
    }
    // Haut de page resserré : le sous-titre ne reste que pour les
    // familles, à qui il rappelle quoi faire ; les types et la période
    // partagent une seule rangée. Avant, quatre rangées empilées
    // prenaient la moitié de l'écran d'un téléphone.
    body.innerHTML='<div class="eq-h eq-h--cal"><div class="eq-h-title">Agenda</div><div class="eq-badge">'+STATE.events.length+'</div></div>'+
      (staff?'':'<div class="eq-h-sub eq-h-sub--cal">Indique ta présence pour chaque rendez-vous.</div>')+
      filterBar+
      ((typeBar||rangeBar)?'<div class="eq-calrow2">'+typeBar+rangeBar+'</div>':'')+
      rangeNote+
      '<div id="eqCalList" class="eq-callist">'+loadingHTML()+'</div>';

    // handlers du sélecteur de période
    var rangeEl=body.querySelector('.eq-calrange');
    if(rangeEl){
      var chips=rangeEl.querySelectorAll('.eq-calrange-chip');
      for(var ri=0; ri<chips.length; ri++){
        chips[ri].addEventListener('click', function(){
          var wantFull=(this.getAttribute('data-r')==='full');
          if(wantFull===agendaFull()) return;
          setAgendaFull(wantFull);
          var list=document.getElementById('eqCalList');
          if(list) list.innerHTML=loadingHTML();
          loadEvents().then(function(){ renderCalendar(); });
        });
      }
    }
    // handlers filtre
    var fchips=body.querySelectorAll('#eqCalFilter .eq-calfilter-chip');
    for(var fi=0;fi<fchips.length;fi++){ fchips[fi].addEventListener('click', function(){
      var f=this.getAttribute('data-f');
      var avant=STATE.calFilter;
      STATE.calFilter=(f==='all'?'all':f);
      // Le périmètre de la requête change avec le filtre : on recharge
      // au lieu de simplement masquer, sinon l'horizon élargi ne sert
      // à rien.
      if(avant!==STATE.calFilter) loadEvents().then(renderCalendar).catch(function(){ renderCalendar(); });
      else renderCalendar();
    }); }
    var cfg=body.querySelector('#eqTeamsCfg');
    if(cfg) cfg.addEventListener('click', openTeamsConfig);

    var tchips=body.querySelectorAll('#eqCalType .eq-calfilter-chip');
    for(var ti=0;ti<tchips.length;ti++){ tchips[ti].addEventListener('click', function(){ STATE.calType=this.getAttribute('data-t'); renderCalendar(); }); }
    var ids=STATE.events.map(function(e){return e.id;});
    var teamIds=[];
    STATE.events.forEach(function(e){ evTeams(e).forEach(function(tid){ if(teamIds.indexOf(tid)===-1) teamIds.push(tid); }); });
    Promise.all([loadAtt(ids), loadTeamMembers(teamIds)]).then(function(res){
      var atts=res[0]||[];
      var members=res[1]||[];
      var list=document.getElementById('eqCalList');
      // filtrage par équipe sélectionnée
      var shownEvents=STATE.events;
      if(STATE.calFilter && STATE.calFilter!=='all'){
        shownEvents=shownEvents.filter(function(e){ return evTeams(e).indexOf(STATE.calFilter)!==-1; });
      }
      // Les deux filtres se combinent : « M10 » + « Match » donne les
      // matchs des M10, pas l'union des deux.
      if(STATE.calType && STATE.calType!=='all'){
        shownEvents=shownEvents.filter(function(e){ return e.type===STATE.calType; });
      }
      // Catégories masquées : on les retire aussi de la liste, pas
      // seulement des chips de filtre.
      var cachees=staff?hiddenTeams():[];
      if(cachees.length && STATE.calFilter==='all'){
        shownEvents=shownEvents.filter(function(e){
          return evTeams(e).some(function(tid){ return cachees.indexOf(tid)===-1; });
        });
      }
      if(!STATE.events.length){
        list.innerHTML='<div class="eq-empty"><div class="eq-empty-ic">📅</div><div class="eq-empty-t">Aucun événement à venir</div><div class="eq-empty-d">'+(staff?'Touche le bouton + pour créer un entraînement, un match ou un tournoi.':'Rejoins une ou plusieurs équipes dans l\'onglet Équipes pour voir leur agenda.')+'</div></div>';
        return;
      }
      if(!shownEvents.length){
        list.innerHTML='<div class="eq-empty"><div class="eq-empty-ic">🔍</div>'+
          '<div class="eq-empty-t">Aucun événement pour ce filtre</div>'+
          '<div class="eq-empty-d">Rien ne correspond à cette combinaison. '+
          'Touche « Toutes » et « Tous les types » pour tout revoir.</div>'+
          '<button type="button" class="eq-btn eq-btn-ghost" id="eqResetFilters" '+
          'style="margin-top:14px">Réinitialiser les filtres</button></div>';
        var rf=document.getElementById('eqResetFilters');
        if(rf) rf.addEventListener('click', function(){
          STATE.calFilter='all'; STATE.calType='all'; renderCalendar();
        });
        return;
      }
      var html='';
      // carte vedette : le tout prochain événement (accroche visuelle)
      if(shownEvents.length){ html+=heroHTML(shownEvents[0]); }
      if(shownEvents.length){ html+='<div class="eq-section-label">'+(shownEvents.length>1?'Tous les rendez-vous':'Détail')+'</div>'; }
      shownEvents.forEach(function(ev,evIdx){
        var tn=teamLabel(ev);
        var tl={entrainement:'Entraînement',match:'Match',tournoi:'Tournoi',benevolat:'Bénévolat',autre:'Événement'}[ev.type]||ev.type;
        html+='<div class="eq-ev t-'+ev.type+'">';
        html+='<div class="eq-ev-top">';
        html+='<div class="eq-ev-date"><span class="eq-ev-date-d">'+fmtD(ev.start_at)+'</span><span class="eq-ev-date-m">'+fmtM(ev.start_at)+'</span></div>';
        html+='<div class="eq-ev-main"><div class="eq-ev-title">'+esc(ev.title)+(staff&&ev.restricted?' <span class="eq-ev-restricted">🔒 Réservé</span>':'')+'</div><div class="eq-ev-team">'+esc(tn)+'</div></div>';
        html+='<span class="eq-ev-type">'+tl+'</span></div>';
        html+='<div class="eq-ev-meta">';
        html+='<div class="eq-ev-meta-row">'+IC.clock+' '+fmtTime(ev.start_at)+(ev.end_at?' → '+fmtEndTime(ev.end_at):'')+'</div>';
        if(ev.location) html+='<div class="eq-ev-meta-row">'+IC.pin+' '+esc(ev.location)+'</div>';
        if(ev.notes) html+='<div class="eq-ev-meta-row">'+IC.note+' '+esc(ev.notes)+'</div>';
        var creator = ev.profiles && ev.profiles.full_name ? ev.profiles.full_name : '';
        if(creator) html+='<div class="eq-ev-meta-row eq-ev-creator">'+IC.whistle+' Créé par '+esc(creator)+'</div>';
        // date limite d'inscription
        var deadlineClosed=false;
        if(ev.signup_deadline){
          var dl=new Date(ev.signup_deadline);
          deadlineClosed = Date.now() > dl.getTime();
          var dlTxt=dl.toLocaleDateString('fr-FR',{day:'numeric',month:'long'})+' à '+('0'+dl.getHours()).slice(-2)+'h'+('0'+dl.getMinutes()).slice(-2);
          html+='<div class="eq-ev-meta-row '+(deadlineClosed?'eq-dl-closed':'eq-dl-open')+'">'+IC.clock+' '+(deadlineClosed?'Inscriptions closes depuis le ':'Réponse avant le ')+dlTxt+'</div>';
        }
        html+='</div>';

        // ---- Vote : pour TOUS (parent/éduc/admin) qui ont un enfant inscrit dans CETTE catégorie ----
        var evTids=evTeams(ev);
        var mine=STATE.myTeams.filter(function(tm){return evTids.indexOf(tm.team_id)!==-1 && tm.status==='valide';});
        mine.forEach(function(child){
          var cn=child.child_name||'Mon enfant';
          var ownerId=child.owner_id||USER.id;
          var v=atts.filter(function(a){return a.event_id===ev.id&&a.profile_id===ownerId&&a.child_name===cn;})[0];
          var st=v?v.status:'';
          html+='<div class="eq-child-label">'+esc(cn)+(child.linked?' <span class="eq-linked-tag">famille</span>':'')+'</div>';
          if(deadlineClosed){
            var stLabel = st==='present'?'✓ Présent':(st==='peut_etre'?'? Peut-être':(st==='absent'?'✕ Absent':'Pas de réponse'));
            html+='<div class="eq-vote-closed">🔒 Inscriptions closes · '+stLabel+'</div>';
          } else {
            html+='<div class="eq-vote" data-ev="'+ev.id+'" data-child="'+esc(cn)+'" data-owner="'+ownerId+'">';
            // Deux réponses seulement. « Peut-être » ne sert à rien pour
            // préparer une séance : un éducateur ne peut ni compter
            // dessus, ni l'ignorer. Les réponses déjà enregistrées en
            // « peut-être » restent affichées telles quelles, on ne
            // réécrit pas le passé.
            html+='<button type="button" data-st="present" class="'+(st==='present'?'on-present':'')+'">✓ Présent</button>';
            html+='<button type="button" data-st="absent" class="'+(st==='absent'?'on-absent':'')+'">✕ Absent</button>';
            html+='</div>';
          }
        });

        // ---- Présences : compteurs cliquables -> liste dépliable (tout le monde) ----
        var ea=atts.filter(function(a){return a.event_id===ev.id;});
        var teamMembers=members.filter(function(m){return evTids.indexOf(m.team_id)!==-1;});
        var nP=0,nA=0,nM=0;
        ea.forEach(function(a){ if(a.status==='present')nP++; else if(a.status==='absent')nA++; else nM++; });
        // qui n'a pas répondu : membres de l'équipe sans vote
        var noResp=[];
        teamMembers.forEach(function(m){
          var voted=ea.filter(function(a){return a.profile_id===m.profile_id&&a.child_name===m.child_name;}).length>0;
          if(!voted) noResp.push(nomComplet(m.child_first_name, m.child_name));
        });

        // Le bloc des présences n'était plus rendu : les compteurs et la
        // liste étaient calculés puis abandonnés. Le staff n'avait donc
        // aucun moyen de savoir qui vient — indispensable pour préparer
        // un entraînement ou inscrire une équipe à un tournoi.
        //
        // hide_attendance masque le détail AUX PARENTS seulement (anti
        // effet boule de neige sur les désistements) ; le staff voit
        // toujours tout, comme annoncé dans le formulaire de création.
        var voitPresences = staff || !ev.hide_attendance;
        if(voitPresences && (ea.length || noResp.length)){
          html+='<div class="eq-pres">'+
            '<button class="eq-pres-toggle" type="button" data-ev="'+ev.id+'">'+
              '<span class="eq-pres-counts">'+
                '<span class="eq-pres-c eq-chip-p">'+IC.check+' '+nP+'</span>'+
                '<span class="eq-pres-c eq-chip-m">'+IC.help+' '+nM+'</span>'+
                '<span class="eq-pres-c eq-chip-a">'+IC.cross+' '+nA+'</span>'+
                (noResp.length?'<span class="eq-pres-c">'+IC.dots+' '+noResp.length+'</span>':'')+
              '</span>'+
              '<span class="eq-pres-chev">'+IC.chev+'</span>'+
            '</button>'+
            '<div class="eq-pres-panel" data-panel="'+ev.id+'">'+
              presenceList(ea, noResp, teamMembers)+
            '</div>'+
          '</div>';
        }

        // ---- Boutons staff (éduc/admin) : relancer (principal) + modifier/annuler ----
        if(staff){
          var remindedRecently = ev.last_reminded_at && (Date.now()-new Date(ev.last_reminded_at).getTime() < RELANCE_DELAI);
          var tidsCsv = evTeams(ev).join(',');
          html+='<div class="eq-ev-actions">';
          // bouton convocation si pas encore envoyée (manuel ou programmé)
          if(ev.convocation==='manual' || ev.convocation==='scheduled'){
            var convocTxt = ev.convocation==='scheduled'
              ? 'Convocation programmée'+(ev.convocation_at?' · '+fmtTime(ev.convocation_at):'')+' — Envoyer maintenant'
              : 'Envoyer la convocation';
            html+='<button class="eq-ev-convoc" data-convoc="'+ev.id+'" data-teams="'+tidsCsv+'" data-title="'+esc(ev.title)+'" type="button">'+IC.send+' '+convocTxt+'</button>';
          }
          html+='<button class="eq-ev-remind'+(remindedRecently?' done':'')+'" data-remind="'+ev.id+'" data-teams="'+tidsCsv+'" data-title="'+esc(ev.title)+'" type="button">'+IC.whistle+' '+(remindedRecently?'Absents déjà relancés':'Relancer les absents')+'</button>';
          html+='<div class="eq-ev-actions-row">';
          html+='<button class="eq-ev-sec edit" data-edit="'+ev.id+'" type="button">'+IC.edit+' Modifier</button>';
          html+='<button class="eq-ev-sec" data-dup="'+ev.id+'" type="button">'+IC.plus+' Dupliquer</button>';
          html+='<button class="eq-ev-sec del" data-del="'+ev.id+'" data-teams="'+tidsCsv+'" data-title="'+esc(ev.title)+'" type="button">'+IC.trash+' Annuler</button>';
          html+='</div>';
          if(ev.type!=='entrainement'){
            html+='<button class="eq-ev-compo" data-compo="'+ev.id+'" type="button">'+IC.clipboard+' Composition d\'équipe</button>';
          }
          html+='</div>';
        }

        html+='</div>';
      });
      list.innerHTML=html;
      // scroll interne seulement au-delà de 4 événements
      if(STATE.events.length>4){ list.classList.add('scrollable'); } else { list.classList.remove('scrollable'); }

      // votes
      var votes=list.querySelectorAll('.eq-vote');
      for(var i=0;i<votes.length;i++){(function(row){
        var bs=row.querySelectorAll('button');
        for(var j=0;j<bs.length;j++){ bs[j].addEventListener('click', function(){ vote(row.getAttribute('data-ev'),row.getAttribute('data-child'),this.getAttribute('data-st'),row,row.getAttribute('data-owner')); }); }
      })(votes[i]);}

      // toggles de la liste de présence
      var toggles=list.querySelectorAll('.eq-pres-toggle');
      for(var t=0;t<toggles.length;t++){
        toggles[t].addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          var ev=this.getAttribute('data-ev');
          var panel=list.querySelector('.eq-pres-panel[data-panel="'+ev+'"]');
          // Sans ce garde-fou, un panneau introuvable lève une exception
          // qui interrompt la pose de tous les écouteurs suivants.
          if(!panel) return;
          var open=this.classList.toggle('open');
          if(open){ panel.style.maxHeight=panel.scrollHeight+'px'; panel.classList.add('open'); }
          else { panel.style.maxHeight='0px'; panel.classList.remove('open'); }
        });
      }

      // boutons annuler (staff)
      var dels=list.querySelectorAll('.eq-ev-sec.del');
      for(var d=0;d<dels.length;d++){
        dels[d].addEventListener('click', function(){
          var tids=(this.getAttribute('data-teams')||'').split(',').filter(Boolean);
          deleteEvent(this.getAttribute('data-del'), this.getAttribute('data-title'), tids);
        });
      }

      // boutons modifier (staff)
      var dups=list.querySelectorAll('[data-dup]');
      for(var du=0;du<dups.length;du++){
        dups[du].addEventListener('click', function(){
          var id=this.getAttribute('data-dup');
          var ev=STATE.events.filter(function(e){return e.id===id;})[0];
          if(!ev) return;
          // Copie décalée d'une semaine : c'est le cas de loin le plus
          // fréquent, un entraînement reconduit. La date reste modifiable.
          var copie={};
          for(var k in ev) copie[k]=ev[k];
          if(copie.start_at) copie.start_at=new Date(new Date(copie.start_at).getTime()+7*86400000).toISOString();
          if(copie.end_at)   copie.end_at  =new Date(new Date(copie.end_at).getTime()+7*86400000).toISOString();
          // La date de convocation et la relance ne se recopient pas :
          // elles appartiennent à la séance d'origine.
          copie.convocation_at=null; copie.last_reminded_at=null;
          if(copie.signup_deadline) copie.signup_deadline=new Date(new Date(copie.signup_deadline).getTime()+7*86400000).toISOString();
          openEvModal(copie, true);
        });
      }

      var eds=list.querySelectorAll('.eq-ev-sec.edit');
      for(var ee=0;ee<eds.length;ee++){
        eds[ee].addEventListener('click', function(){
          var id=this.getAttribute('data-edit');
          var ev=STATE.events.filter(function(e){return e.id===id;})[0];
          if(ev) openEvModal(ev);
        });
      }

      // boutons relancer les absents (staff)
      var rems=list.querySelectorAll('.eq-ev-remind');
      for(var rr=0;rr<rems.length;rr++){
        rems[rr].addEventListener('click', function(){
          var tids=(this.getAttribute('data-teams')||'').split(',').filter(Boolean);
          remindAbsents(this.getAttribute('data-remind'), tids, this.getAttribute('data-title'), this);
        });
      }

      // boutons composition (staff)
      var compos=list.querySelectorAll('.eq-ev-compo');
      for(var cc=0;cc<compos.length;cc++){
        compos[cc].addEventListener('click', function(){
          var id=this.getAttribute('data-compo');
          var ev=STATE.events.filter(function(e){return e.id===id;})[0];
          if(ev) openCompoModal(ev);
        });
      }

      // boutons envoyer la convocation (staff)
      var convocs=list.querySelectorAll('.eq-ev-convoc');
      for(var cv=0;cv<convocs.length;cv++){
        convocs[cv].addEventListener('click', function(){
          var tids=(this.getAttribute('data-teams')||'').split(',').filter(Boolean);
          sendConvocation(this.getAttribute('data-convoc'), tids, this.getAttribute('data-title'), this);
        });
      }
    });
  }

  function sendConvocation(eventId, teamIds, title, btn){
    var ev=STATE.events.filter(function(e){return e.id===eventId;})[0];
    if(!teamIds || !teamIds.length){ teamIds = ev ? evTeams(ev) : []; }
    if(!confirm('Envoyer la convocation aux parents maintenant ?')) return;
    var teamLbl = teamIds.length>1 ? 'le club' : ((STATE.teams.filter(function(t){return t.id===teamIds[0];})[0]||{}).name||'ton équipe');
    var typeLabel={entrainement:'Entraînement',match:'Match',tournoi:'Tournoi',benevolat:'Bénévolat',autre:'Événement'}[ev?ev.type:'']||'Événement';
    if(btn){ btn.disabled=true; btn.innerHTML=IC.send+' Envoi…'; }
    sendPush({ mode:'new_event', team_ids:teamIds,
      event_id: ev ? ev.id : null,
      title:'USV '+teamLbl+' · '+typeLabel,
      body:title+(ev?' — '+fmtTime(ev.start_at):'') })
    .then(function(res){
      // marque la convocation comme envoyée
      api('/rest/v1/events?id=eq.'+eventId,{ method:'PATCH', body:{ convocation:'sent' }, prefer:'return=minimal' }).catch(function(){});
      if(ev) ev.convocation='sent';
      var n=(res&&typeof res.sent==='number')?res.sent:null;
      if(n!==null) alert('Convocation envoyée à '+n+' parent'+(n>1?'s':'')+'. 📣');
      else alert('Convocation envoyée. 📣');
      return loadEvents();
    })
    .then(function(){ renderCalendar(); })
    .catch(function(e){
      if(btn){ btn.disabled=false; btn.innerHTML=IC.send+' Envoyer la convocation'; }
      alert('Erreur : '+(e&&e.message?e.message:e));
    });
  }

  function remindAbsents(eventId, teamIds, title, btn){
    var ev=STATE.events.filter(function(e){return e.id===eventId;})[0];
    if(!teamIds || !teamIds.length){ teamIds = ev ? evTeams(ev) : []; }
    // anti-spam : une seule relance par tranche de 4h
    if(ev && ev.last_reminded_at){
      var elapsed=Date.now()-new Date(ev.last_reminded_at).getTime();
      var sixH=RELANCE_DELAI;
      if(elapsed<sixH){
        var mins=Math.round((sixH-elapsed)/60000);
        var wait = mins>60 ? Math.round(mins/60)+'h' : mins+' min';
        alert('Cet événement a déjà été relancé récemment. 🔔\n\nPour éviter de spammer les parents, tu pourras relancer à nouveau dans '+wait+'.');
        return;
      }
    }
    if(!confirm('Envoyer une notification de rappel aux parents qui n\'ont pas encore répondu ?')) return;
    var teamLbl = teamIds.length>1 ? 'le club' : ((STATE.teams.filter(function(t){return t.id===teamIds[0];})[0]||{}).name||'ton équipe');
    if(btn){ btn.disabled=true; btn.innerHTML=IC.whistle+' Envoi…'; }
    sendPush({ mode:'remind', team_ids:teamIds, event_id:eventId,
      title:'USV '+teamLbl+' · Rappel',
      body:'N\'oublie pas d\'indiquer ta présence : '+title })
    .then(function(res){
      var n=(res&&typeof res.sent==='number')?res.sent:null;
      var nowIso=new Date().toISOString();
      api('/rest/v1/events?id=eq.'+eventId,{ method:'PATCH', body:{ last_reminded_at:nowIso }, prefer:'return=minimal' }).catch(function(){});
      if(ev) ev.last_reminded_at=nowIso;
      if(btn){ btn.innerHTML=IC.whistle+' Déjà relancé'; btn.classList.add('done'); }
      if(n===0) alert('Tout le monde a déjà répondu — aucun rappel à envoyer. 👍');
      else if(n!==null) alert('Rappel envoyé à '+n+' parent'+(n>1?'s':'')+'. 🔔');
      else alert('Rappel envoyé.');
    })
    .catch(function(e){
      if(btn){ btn.disabled=false; btn.innerHTML=IC.whistle+' Relancer les absents'; }
      alert('Erreur : '+(e&&e.message?e.message:e));
    });
  }

  function deleteEvent(eventId, title, teamIds){
    if(!confirm('Annuler l\'événement "'+title+'" ?\n\nLes parents concernés recevront une notification d\'annulation, et toutes les présences associées seront supprimées. Cette action est définitive.')) return;
    var ev=STATE.events.filter(function(e){return e.id===eventId;})[0];
    if(!teamIds || !teamIds.length){ teamIds = ev ? evTeams(ev) : []; }
    var teamLbl = teamIds.length>1 ? 'le club' : ((STATE.teams.filter(function(t){return t.id===teamIds[0];})[0]||{}).name||'ton équipe');
    var doDelete=function(){
      return api('/rest/v1/events?id=eq.'+eventId, { method:'DELETE', prefer:'return=minimal' })
        .then(function(){ return loadEvents(); })
        .then(function(){ renderCalendar(); });
    };
    if(teamIds.length){
      sendPush({ mode:'new_event', team_ids:teamIds,
        // L'envoi se fait AVANT la suppression : la liste des joueurs
        // convoqués est donc encore lisible.
        event_id: eventId || null,
        title:'USV '+teamLbl+' · Annulation',
        body:'Annulé : '+title })
      .then(doDelete).catch(function(){ doDelete(); });
    } else {
      doDelete().catch(function(e){ alert('Erreur : '+e.message); });
    }
  }

  /* ============================================================
     COMPOSITION D'ÉQUIPE (staff uniquement, invisible aux parents)
     ============================================================ */
  var COMPO_EV=null;       // event courant
  var COMPO_PLAYERS=[];    // joueurs présents avec leur statut

  function openCompoModal(ev){
    COMPO_EV=ev;
    var m=document.createElement('div'); m.className='eq-modal'; m.id='eqCompoModal';
    m.innerHTML='<div class="eq-modal-ov" id="eqCompoOv"></div><div class="eq-modal-card eq-compo-card">'+
      '<div class="eq-modal-grab"></div>'+
      '<div class="eq-modal-title">Composition</div>'+
      '<div class="eq-h-sub" style="margin:0 0 4px">'+esc(ev.title)+' · '+esc(teamLabel(ev))+'</div>'+
      '<div id="eqCompoMsg"></div>'+
      '<div id="eqCompoBody">'+loadingHTML()+'</div>'+
      '</div>';
    document.querySelector('.eq-app').appendChild(m);
    document.getElementById('eqCompoOv').addEventListener('click', closeCompoModal);

    var evTids=evTeams(ev);
    Promise.all([
      loadAtt([ev.id]),
      loadTeamMembers(evTids),
      api('/rest/v1/compositions?event_id=eq.'+ev.id+'&select=*')
    ]).then(function(res){
      var atts=res[0]||[];
      var members=res[1]||[];
      var existing=(res[2]&&res[2][0])?res[2][0]:null;
      var presentAtts=atts.filter(function(a){ return a.event_id===ev.id && a.status==='present'; });
      var savedMap={};
      if(existing && existing.players){ existing.players.forEach(function(p){ savedMap[p.profile_id+'|'+p.child_name]=p.status; }); }
      COMPO_PLAYERS=presentAtts.map(function(a){
        var mem=members.filter(function(mm){return mm.profile_id===a.profile_id && mm.child_name===a.child_name;})[0]||{};
        var fullName=((mem.child_first_name||a.child_first_name||'')+' '+(a.child_name||'')).trim()||a.child_name||'Joueur';
        var key=a.profile_id+'|'+a.child_name;
        return { key:key, profile_id:a.profile_id, child_name:a.child_name,
          child_first_name:mem.child_first_name||a.child_first_name||'',
          team_id:mem.team_id||evTids[0], name:fullName,
          status: savedMap[key] || 'titulaire' };
      });
      COMPO_PLAYERS.sort(function(x,y){ return x.name.localeCompare(y.name); });
      paintCompo();
    }).catch(function(e){
      var b=document.getElementById('eqCompoBody');
      if(b) b.innerHTML='<div class="eq-empty"><div class="eq-empty-d">Erreur : '+esc(e.message)+'</div></div>';
    });
  }
  function closeCompoModal(){ var m=document.getElementById('eqCompoModal'); if(m) m.parentNode.removeChild(m); COMPO_EV=null; COMPO_PLAYERS=[]; }

  function paintCompo(){
    var b=document.getElementById('eqCompoBody'); if(!b) return;
    if(!COMPO_PLAYERS.length){
      b.innerHTML='<div class="eq-empty"><div class="eq-empty-ic">📋</div><div class="eq-empty-t">Aucun présent</div><div class="eq-empty-d">La compo se base sur les joueurs ayant indiqué « présent » à cet événement. Personne n\'a encore confirmé sa présence.</div></div>'+
        '<button type="button" class="eq-btn eq-btn-ghost" id="eqCompoClose" style="margin-top:14px">Fermer</button>';
      var cb=document.getElementById('eqCompoClose'); if(cb) cb.addEventListener('click', closeCompoModal);
      return;
    }
    var tit=COMPO_PLAYERS.filter(function(p){return p.status==='titulaire';});
    var rem=COMPO_PLAYERS.filter(function(p){return p.status==='remplacant';});
    var out=COMPO_PLAYERS.filter(function(p){return p.status==='retire';});
    function row(p){
      return '<div class="eq-compo-row" data-key="'+esc(p.key)+'">'+
        '<span class="eq-compo-name">'+esc(p.name)+'</span>'+
        '<div class="eq-compo-btns">'+
          '<button type="button" class="eq-compo-b tit'+(p.status==='titulaire'?' on':'')+'" data-key="'+esc(p.key)+'" data-st="titulaire">Titu</button>'+
          '<button type="button" class="eq-compo-b rem'+(p.status==='remplacant'?' on':'')+'" data-key="'+esc(p.key)+'" data-st="remplacant">Rempl.</button>'+
          '<button type="button" class="eq-compo-b out'+(p.status==='retire'?' on':'')+'" data-key="'+esc(p.key)+'" data-st="retire">✕</button>'+
        '</div></div>';
    }
    var html='';
    html+='<div class="eq-compo-sec"><div class="eq-compo-head"><span>Titulaires</span><span class="eq-compo-cnt">'+tit.length+'</span></div>'+(tit.length?tit.map(row).join(''):'<div class="eq-compo-vide">Personne</div>')+'</div>';
    html+='<div class="eq-compo-sec"><div class="eq-compo-head"><span>Remplaçants</span><span class="eq-compo-cnt">'+rem.length+'</span></div>'+(rem.length?rem.map(row).join(''):'<div class="eq-compo-vide">Personne</div>')+'</div>';
    if(out.length){ html+='<div class="eq-compo-sec eq-compo-outsec"><div class="eq-compo-head"><span>Non retenus</span><span class="eq-compo-cnt">'+out.length+'</span></div>'+out.map(row).join('')+'</div>'; }
    html+='<button type="button" class="eq-btn" id="eqCompoSave">Enregistrer la compo</button>';
    html+='<button type="button" class="eq-btn eq-btn-ghost" id="eqCompoClose" style="margin-top:10px">Fermer</button>';
    b.innerHTML=html;
    var btns=b.querySelectorAll('.eq-compo-b');
    for(var i=0;i<btns.length;i++){
      btns[i].addEventListener('click', function(){
        var key=this.getAttribute('data-key'); var st=this.getAttribute('data-st');
        var pl=COMPO_PLAYERS.filter(function(p){return p.key===key;})[0];
        if(pl){ pl.status=st; paintCompo(); }
      });
    }
    document.getElementById('eqCompoSave').addEventListener('click', saveCompo);
    document.getElementById('eqCompoClose').addEventListener('click', closeCompoModal);
  }

  function saveCompo(){
    if(!COMPO_EV) return;
    var btn=document.getElementById('eqCompoSave'); if(btn){ btn.disabled=true; btn.textContent='Enregistrement…'; }
    var players=COMPO_PLAYERS.map(function(p){ return { profile_id:p.profile_id, child_name:p.child_name, child_first_name:p.child_first_name, team_id:p.team_id, status:p.status }; });
    var body={ event_id:COMPO_EV.id, players:players, updated_by:USER.id, updated_at:new Date().toISOString() };
    api('/rest/v1/compositions?on_conflict=event_id',{ method:'POST', prefer:'resolution=merge-duplicates,return=minimal', body:body })
    .then(function(){
      var msg=document.getElementById('eqCompoMsg');
      if(msg) msg.innerHTML='<div class="eq-msg eq-msg-ok"><span class="eq-msg-ic">✅</span><span>Compo enregistrée.</span></div>';
      if(btn){ btn.disabled=false; btn.textContent='Enregistrer la compo'; }
    })
    .catch(function(e){
      var msg=document.getElementById('eqCompoMsg');
      if(msg) msg.innerHTML='<div class="eq-msg eq-msg-err"><span class="eq-msg-ic">⚠️</span><span>'+esc(e.message)+'</span></div>';
      if(btn){ btn.disabled=false; btn.textContent='Enregistrer la compo'; }
    });
  }

  /* ============================================================
     MESSAGERIE — chapeau : Catégories (canaux) vs Privés (DM)
     ============================================================ */
  /* ============================================================
     MESSAGERIE — refonte : vue LISTE (façon WhatsApp)
     Catégories / Privés → liste de conversations → on entre dedans
     ============================================================ */
  function renderMessages(){
    // si une conversation est ouverte, on l'affiche en plein écran
    if(STATE.msgMode==='dm' && STATE.dmThread){ return; } // géré par openDMThread
    if(STATE.msgMode==='cat' && STATE.chatOpen){ openCatThread(STATE.chatTeam); return; }
    renderMsgList();
  }

  /* ============================================================
     MESSAGERIE — mise en page
     ============================================================ */

  /* Regroupe les messages consécutifs d'une même personne, à moins de
     cinq minutes d'écart : le nom et l'avatar ne s'affichent qu'une
     fois, comme dans toutes les messageries. Répétés sur chaque bulle,
     ils alourdissaient le fil au point de le rendre difficile à suivre.
     Un séparateur de jour coupe naturellement le groupe. */
  function groupFeed(feed){
    if(!feed) return;
    if(feed.id==='eqChatFeed' && STATE.chatOpen) markCatRead();
    var prev=null;
    Array.prototype.forEach.call(feed.children, function(el){
      if(!el.classList || !el.classList.contains('eq-chat-msg')){ prev=null; return; }
      var who=el.getAttribute('data-who'), ts=+el.getAttribute('data-ts')||0;
      if(prev && who && prev.who===who && ts-prev.ts < 300000){
        el.classList.add('grouped');
        prev.el.classList.add('has-next');
      }
      prev={ el:el, who:who, ts:ts };
    });
  }

  /* Hauteur du fil calculée d'après l'écran réel, au lieu d'une valeur
     fixe. L'ancienne formule retranchait 350 px quoi qu'il arrive : selon
     qu'un sondage, des onglets ou le bandeau Éducateurs étaient présents,
     le fil était trop court ou la zone de saisie passait sous la barre du
     bas. On mesure ce qui est réellement au-dessus et en dessous. */
  function fitChat(){
    var feed=document.getElementById('eqChatFeed')||document.getElementById('eqDMFeed');
    if(!feed) return;
    var comp=feed.nextElementSibling;
    var vh=(window.visualViewport?window.visualViewport.height:window.innerHeight);
    var bottom=vh;
    var nav=document.querySelector('.eq-nav');
    if(nav){
      var nr=nav.getBoundingClientRect();
      if(nr.height && nr.top>0 && nr.top<vh) bottom=nr.top;
    }
    var top=feed.getBoundingClientRect().top;
    var h=bottom-top-(comp?comp.offsetHeight:60)-22;
    // Plancher : sur un très petit écran, on préfère laisser la page
    // défiler plutôt que d'écraser le fil.
    feed.style.height=Math.max(260, Math.round(h))+'px';
    feed.scrollTop=feed.scrollHeight;
  }

  /* À l'ouverture d'une conversation, on amène son en-tête en haut de
     l'écran : c'est ce qui permet au fil d'occuper toute la hauteur. */
  function focusChat(){
    var body=document.getElementById('eqBody');
    if(!body) return;
    body.classList.add('eq-chatmode');
    var y=body.getBoundingClientRect().top+window.pageYOffset-8;
    try{ window.scrollTo({ top:Math.max(0,y), behavior:'instant' }); }
    catch(e){ window.scrollTo(0, Math.max(0,y)); }
    fitChat();
    setTimeout(fitChat, 250);
  }

  if(!STATE._fitBound){
    STATE._fitBound=true;
    window.addEventListener('resize', fitChat);
    // Le clavier du téléphone réduit la zone visible sans déclencher de
    // « resize » sur iOS : seul visualViewport le signale.
    if(window.visualViewport) window.visualViewport.addEventListener('resize', fitChat);
  }

  function renderMsgList(){
    var bodyEl=document.getElementById('eqBody');
    if(bodyEl) bodyEl.classList.remove('eq-chatmode');
    var body=document.getElementById('eqBody');
    body.innerHTML='<div class="eq-h"><div class="eq-h-title">Messages</div></div>'+
      msgModeSeg()+
      '<div id="eqMsgList">'+loadingHTML()+'</div>';
    bindMsgModeSeg();
    if(STATE.msgMode==='dm'){ paintDMThreadList(); }
    else { paintCatList(); }
  }

  /* ---- liste des catégories (style conversations) ---- */
  function paintCatList(){
    var isAdmin=(PROFILE.role==='admin');
    var avail;
    if(isAdmin){ avail=STATE.teams.slice(); }
    else { avail=STATE.teams.filter(function(t){ return STATE.myGroups.indexOf(t.id)!==-1; }); }
    var list=document.getElementById('eqMsgList'); if(!list) return;
    if(!avail.length){
      list.innerHTML='<div class="eq-empty" style="padding:30px 16px"><div class="eq-empty-ic">💬</div><div class="eq-empty-t">Aucune catégorie</div><div class="eq-empty-d">Tu n\'es dans aucun groupe. Tu peux écrire en privé via l\'onglet « Privés ».</div></div>';
      return;
    }
    // on charge le dernier message de chaque catégorie pour l'aperçu
    var ids=avail.map(function(t){return t.id;});
    // Plafond : on ne veut que le dernier message de chaque catégorie.
    // Sans limite, la requête ramenait tout l'historique du club.
    api('/rest/v1/messages?select=team_id,body,image_url,created_at,author_name&team_id=in.('+ids.join(',')+')&staff_only=eq.false&order=created_at.desc&limit=300').then(function(msgs){
      var lastByTeam={};
      (msgs||[]).forEach(function(m){ if(!lastByTeam[m.team_id]) lastByTeam[m.team_id]=m; });
      var html='<div class="eq-conv-list">';
      avail.forEach(function(t){
        var last=lastByTeam[t.id];
        var preview='Aucun message';
        if(last){ preview=(last.image_url?'📷 Photo':esc(last.body||'')); if(preview.length>42) preview=preview.slice(0,42)+'…'; }
        var time=last?convListTime(last.created_at):'';
        html+='<button class="eq-conv-row" data-team="'+t.id+'" type="button">'+
          '<div class="eq-conv-av eq-conv-av-cat">'+esc(t.name)+'</div>'+
          '<div class="eq-conv-mid">'+
            '<div class="eq-conv-top"><span class="eq-conv-name">'+esc(t.name)+'</span><span class="eq-conv-time">'+time+'</span></div>'+
            '<div class="eq-conv-prev">'+preview+'</div>'+
          '</div>'+
        '</button>';
      });
      html+='</div>';
      list.innerHTML=html;
      paintUnread();
      var rows=list.querySelectorAll('.eq-conv-row');
      for(var i=0;i<rows.length;i++){ rows[i].addEventListener('click', function(){ openCatThread(this.getAttribute('data-team')); }); }
    }).catch(function(e){
      // fallback : liste sans aperçu
      var html='<div class="eq-conv-list">';
      avail.forEach(function(t){
        html+='<button class="eq-conv-row" data-team="'+t.id+'" type="button">'+
          '<div class="eq-conv-av eq-conv-av-cat">'+esc(t.name)+'</div>'+
          '<div class="eq-conv-mid"><div class="eq-conv-top"><span class="eq-conv-name">'+esc(t.name)+'</span></div><div class="eq-conv-prev">Ouvrir la discussion</div></div>'+
        '</button>';
      });
      html+='</div>';
      list.innerHTML=html;
      paintUnread();
      var rows=list.querySelectorAll('.eq-conv-row');
      for(var i=0;i<rows.length;i++){ rows[i].addEventListener('click', function(){ openCatThread(this.getAttribute('data-team')); }); }
    });
  }

  /* Création d'un groupe : un nom, puis les personnes. La liste des
     contacts est celle des messages privés — on ne crée pas un annuaire
     parallèle, ce serait deux sources à maintenir. */
  function openGroupCreate(){
    var chosen={};
    var m=document.createElement('div'); m.className='eq-modal'; m.id='eqGrpNew';
    m.innerHTML='<div class="eq-modal-ov" id="eqGnOv"></div><div class="eq-modal-card">'+
      '<div class="eq-modal-grab"></div>'+
      '<div class="eq-modal-title">Nouveau groupe</div>'+
      '<div class="eq-modal-sub">Une conversation à plusieurs, séparée des catégories</div>'+
      '<div id="eqGnMsg"></div>'+
      '<div class="eq-field"><label>Nom du groupe</label>'+
        '<input class="eq-input" id="eqGnTitle" type="text" placeholder="Ex. Éducateurs école de rugby" maxlength="60"></div>'+
      '<div class="eq-field"><label>Participants</label>'+
        '<input class="eq-input eq-grp-search" id="eqGnSearch" type="search" '+
          'placeholder="Chercher par nom ou prénom…" autocomplete="off">'+
        '<div id="eqGnCount" class="eq-grp-count"></div>'+
        '<div id="eqGnList" class="eq-grp-list">'+loadingHTML()+'</div></div>'+
      '<button type="button" class="eq-btn" id="eqGnSave">Créer le groupe</button>'+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqGnCancel" style="margin-top:10px">Annuler</button>'+
      '</div>';
    document.querySelector('.eq-app').appendChild(m);
    var close=function(){ if(m.parentNode) m.parentNode.removeChild(m); };
    document.getElementById('eqGnOv').addEventListener('click', close);
    document.getElementById('eqGnCancel').addEventListener('click', close);

    var say=function(t,err){
      document.getElementById('eqGnMsg').innerHTML='<div class="eq-msg eq-msg-'+(err?'err':'ok')+
        '"><span class="eq-msg-ic">'+(err?'⚠️':'⏳')+'</span><span>'+esc(t)+'</span></div>';
    };

    var allContacts=[];
    // Normalisation : la recherche doit trouver « Tedeschi » quand on
    // tape « tedeschi », et « Gaëtan » quand on tape « gaetan ».
    var norm=function(t){
      return String(t||'').toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();
    };

    var paintContacts=function(){
      var box=document.getElementById('eqGnList'); if(!box) return;
      var q=norm((document.getElementById('eqGnSearch')||{}).value||'');
      var shown=allContacts.filter(function(r){
        return !q || norm(r.full_name).indexOf(q)!==-1;
      });
      // Les personnes déjà cochées restent visibles même hors recherche :
      // sinon on croit les avoir perdues en tapant dans le champ.
      allContacts.forEach(function(r){
        if(chosen[r.id] && shown.indexOf(r)===-1) shown.push(r);
      });

      var cnt=document.getElementById('eqGnCount');
      var nbSel=Object.keys(chosen).length;
      if(cnt) cnt.textContent=(nbSel?nbSel+' sélectionné'+(nbSel>1?'s':'')+' · ':'')+
        shown.length+' contact'+(shown.length>1?'s':'');

      if(!shown.length){
        box.innerHTML='<div class="eq-chat-empty">Aucun contact ne correspond.</div>';
        return;
      }
      box.innerHTML=shown.map(function(r){
        var rl=(r.role==='admin'?'Admin':(r.role==='educateur'?'Éducateur':'Membre'));
        return '<button type="button" class="eq-grp-row'+(chosen[r.id]?' on':'')+'" data-p="'+r.id+'">'+
          '<span class="eq-grp-check"></span>'+
          '<span class="eq-grp-name">'+esc(r.full_name||'Membre')+
          '<small>'+rl+'</small></span></button>';
      }).join('');
      var rws=box.querySelectorAll('.eq-grp-row');
      for(var i=0;i<rws.length;i++){
        rws[i].addEventListener('click', function(){
          var id=this.getAttribute('data-p');
          if(chosen[id]){ delete chosen[id]; this.classList.remove('on'); }
          else { chosen[id]=1; this.classList.add('on'); }
          var cnt2=document.getElementById('eqGnCount');
          var nb2=Object.keys(chosen).length;
          if(cnt2) cnt2.textContent=(nb2?nb2+' sélectionné'+(nb2>1?'s':'')+' · ':'')+
            rws.length+' contact'+(rws.length>1?'s':'');
        });
      }
    };

    dmContacts().then(function(rows){
      allContacts=(rows||[]).filter(function(r){ return r.id!==USER.id; })
        .sort(function(a,b){ return norm(a.full_name).localeCompare(norm(b.full_name)); });
      if(!allContacts.length){
        var box=document.getElementById('eqGnList');
        if(box) box.innerHTML='<div class="eq-chat-empty">Aucun contact disponible.</div>';
        return;
      }
      paintContacts();
      var sf=document.getElementById('eqGnSearch');
      if(sf) sf.addEventListener('input', paintContacts);
    }).catch(function(e){
      var box=document.getElementById('eqGnList');
      if(box) box.innerHTML='<div class="eq-chat-empty">'+esc(e.message)+'</div>';
    });

    document.getElementById('eqGnSave').addEventListener('click', function(){
      var title=document.getElementById('eqGnTitle').value.trim();
      var ids=Object.keys(chosen);
      if(!title){ say('Donne un nom au groupe.', true); return; }
      if(!ids.length){ say('Choisis au moins une personne.', true); return; }
      var b=this; b.disabled=true; say('Création…');
      dmCreateGroup(title, ids)
        .then(function(tid){
          close();
          STATE.msgMode='dm';
          openDMThread(tid, title);
        })
        .catch(function(e){ b.disabled=false; say(e.message, true); });
    });
  }

  /* Sélecteur de personne avec recherche. Remplace le prompt numéroté :
     avec cinquante contacts, taper un numéro dans une liste défilante
     est inutilisable. */
  function openPeoplePicker(titre, people, onPick){
    var norm=function(t){
      return String(t||'').toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();
    };
    people=(people||[]).slice().sort(function(a,b){
      return norm(a.full_name).localeCompare(norm(b.full_name));
    });
    var m=document.createElement('div'); m.className='eq-modal'; m.id='eqPick';
    m.innerHTML='<div class="eq-modal-ov" id="eqPkOv"></div><div class="eq-modal-card">'+
      '<div class="eq-modal-grab"></div>'+
      '<div class="eq-modal-title">'+esc(titre)+'</div>'+
      '<input class="eq-input eq-grp-search" id="eqPkSearch" type="search" '+
        'placeholder="Chercher par nom ou prénom…" autocomplete="off">'+
      '<div id="eqPkList" class="eq-grp-list"></div>'+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqPkClose" style="margin-top:12px">Fermer</button>'+
      '</div>';
    document.querySelector('.eq-app').appendChild(m);
    var close=function(){ if(m.parentNode) m.parentNode.removeChild(m); };
    document.getElementById('eqPkOv').addEventListener('click', close);
    document.getElementById('eqPkClose').addEventListener('click', close);

    var paint=function(){
      var q=norm(document.getElementById('eqPkSearch').value);
      var shown=people.filter(function(r){ return !q || norm(r.full_name).indexOf(q)!==-1; });
      var box=document.getElementById('eqPkList');
      if(!shown.length){ box.innerHTML='<div class="eq-chat-empty">Aucun résultat.</div>'; return; }
      box.innerHTML=shown.map(function(r){
        var rl=(r.role==='admin'?'Admin':(r.role==='educateur'?'Éducateur':'Membre'));
        return '<button type="button" class="eq-grp-row" data-p="'+r.id+'">'+
          '<span class="eq-grp-name">'+esc(r.full_name||'Membre')+
          '<small>'+rl+'</small></span></button>';
      }).join('');
      var rws=box.querySelectorAll('.eq-grp-row');
      for(var i=0;i<rws.length;i++){
        rws[i].addEventListener('click', function(){
          var id=this.getAttribute('data-p');
          var p=people.filter(function(x){ return x.id===id; })[0];
          close(); if(p) onPick(p);
        });
      }
    };
    paint();
    document.getElementById('eqPkSearch').addEventListener('input', paint);
  }

  /* Gestion d'un groupe : renommer, ajouter, retirer, quitter. */
  function openGroupManage(tid, title){
    var m=document.createElement('div'); m.className='eq-modal'; m.id='eqGrpMan';
    m.innerHTML='<div class="eq-modal-ov" id="eqGmOv"></div><div class="eq-modal-card">'+
      '<div class="eq-modal-grab"></div>'+
      '<div class="eq-modal-title">Gérer le groupe</div>'+
      '<div class="eq-modal-sub">'+esc(title||'Groupe')+'</div>'+
      '<div id="eqGmMsg"></div>'+
      '<div class="eq-field"><label>Nom du groupe</label>'+
        '<input class="eq-input" id="eqGmTitle" type="text" value="'+esc(title||'')+'" maxlength="60">'+
        '<button type="button" class="eq-btn eq-btn-ghost eq-btn-sm" id="eqGmRename" style="margin-top:8px">Renommer</button></div>'+
      '<div class="eq-field"><label>Membres</label><div id="eqGmList">'+loadingHTML()+'</div></div>'+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqGmAdd">Ajouter quelqu\'un</button>'+
      '<button type="button" class="eq-btn eq-btn-ghost eq-btn-danger" id="eqGmLeave" style="margin-top:10px">Quitter le groupe</button>'+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqGmClose" style="margin-top:10px">Fermer</button>'+
      '</div>';
    document.querySelector('.eq-app').appendChild(m);
    var close=function(){ if(m.parentNode) m.parentNode.removeChild(m); };
    document.getElementById('eqGmOv').addEventListener('click', close);
    document.getElementById('eqGmClose').addEventListener('click', close);
    var say=function(t,err){
      document.getElementById('eqGmMsg').innerHTML='<div class="eq-msg eq-msg-'+(err?'err':'ok')+
        '"><span class="eq-msg-ic">'+(err?'⚠️':'✅')+'</span><span>'+esc(t)+'</span></div>';
    };

    var paint=function(){
      dmGroupMembers(tid).then(function(rows){
        var box=document.getElementById('eqGmList'); if(!box) return;
        box.innerHTML=(rows||[]).map(function(r){
          var rl=(r.role==='admin'?'Admin':(r.role==='educateur'?'Éducateur':'Membre'));
          var moi=(r.profile_id===USER.id);
          return '<div class="eq-grp-row eq-grp-row--static">'+
            '<span class="eq-grp-name">'+esc(r.full_name||'Membre')+
            '<small>'+rl+(r.is_admin?' · responsable':'')+(moi?' · toi':'')+'</small></span>'+
            (moi?'':'<button type="button" class="eq-grp-rm" data-rm="'+r.profile_id+'" '+
              'title="Retirer du groupe">×</button>')+
            '</div>';
        }).join('');
        var rm=box.querySelectorAll('[data-rm]');
        for(var i=0;i<rm.length;i++){
          rm[i].addEventListener('click', function(){
            var pid=this.getAttribute('data-rm');
            if(!confirm('Retirer cette personne du groupe ?')) return;
            dmRemoveMember(tid,pid).then(paint).catch(function(e){ say(e.message,true); });
          });
        }
      }).catch(function(e){
        var box=document.getElementById('eqGmList');
        if(box) box.innerHTML='<div class="eq-chat-empty">'+esc(e.message)+'</div>';
      });
    };
    paint();

    document.getElementById('eqGmRename').addEventListener('click', function(){
      var t=document.getElementById('eqGmTitle').value.trim();
      if(!t){ say('Le nom ne peut pas être vide.', true); return; }
      dmRenameGroup(tid,t).then(function(){ say('Nom mis à jour.'); })
        .catch(function(e){ say(e.message,true); });
    });

    document.getElementById('eqGmAdd').addEventListener('click', function(){
      dmContacts().then(function(rows){
        return dmGroupMembers(tid).then(function(cur){
          var deja={}; (cur||[]).forEach(function(c){ deja[c.profile_id]=1; });
          var dispo=(rows||[]).filter(function(r){ return !deja[r.id]; });
          if(!dispo.length){ say('Tout le monde est déjà dans le groupe.', true); return; }
          openPeoplePicker('Ajouter au groupe', dispo, function(p){
            dmAddMember(tid,p.id).then(function(){ say((p.full_name||'Membre')+' ajouté.'); paint(); })
              .catch(function(e){ say(e.message,true); });
          });
        });
      }).catch(function(e){ say(e.message,true); });
    });

    document.getElementById('eqGmLeave').addEventListener('click', function(){
      if(!confirm('Quitter ce groupe ?\n\nTu ne verras plus ses messages.')) return;
      dmRemoveMember(tid, USER.id).then(function(){
        close(); STATE.dmThread=null; renderMsgList();
      }).catch(function(e){ say(e.message,true); });
    });
  }

  /* ---- liste des conversations privées (style conversations) ---- */
  function paintDMThreadList(){
    var list=document.getElementById('eqMsgList'); if(!list) return;
    dmMyThreads().then(function(threads){
      STATE.dmThreads=threads||[];
      var staffHere=(PROFILE.role==='educateur'||PROFILE.role==='admin');
      var html='<div class="eq-dm-actions">'+
        '<button class="eq-dm-new" id="eqDMNew" type="button">'+IC.plus+' Nouveau message</button>'+
        (staffHere?'<button class="eq-dm-new eq-dm-new--group" id="eqDMNewGroup" type="button">'+IC.users+' Nouveau groupe</button>':'')+
        '</div>';
      if(!STATE.dmThreads.length){
        html+='<div class="eq-empty" style="padding:24px 16px"><div class="eq-empty-ic">✉️</div><div class="eq-empty-t">Aucune conversation</div><div class="eq-empty-d">Touche « Nouveau message » pour écrire à un éducateur du club.</div></div>';
      } else {
        html+='<div class="eq-conv-list">';
        STATE.dmThreads.forEach(function(t){
          var isGroup=(t.kind==='group');
          var nom=(isGroup?(t.title||'Groupe'):(t.other_name||'Membre'));
          var initial=nom.trim().charAt(0).toUpperCase();
          // Un groupe affiche son nombre de membres là où un fil direct
          // affiche le rôle de l'interlocuteur : même emplacement, même
          // fonction — savoir à qui on parle.
          var roleLbl=isGroup
            ? (t.members||0)+' membres'
            : (t.other_role==='admin'?'Admin':(t.other_role==='educateur'?'Éducateur':'Membre'));
          var preview=t.last_body?esc(t.last_body):'—';
          if(preview.length>42) preview=preview.slice(0,42)+'…';
          var time=t.last_message_at?convListTime(t.last_message_at):'';
          html+='<button class="eq-conv-row'+(t.unread?' unread':'')+'" data-tid="'+t.thread_id+'" '+
            'data-name="'+esc(nom)+'" data-kind="'+esc(t.kind||'direct')+'" type="button">'+
            '<div class="eq-conv-av'+(isGroup?' eq-conv-av--group':'')+'">'+(isGroup?IC.users:initial)+'</div>'+
            '<div class="eq-conv-mid">'+
              '<div class="eq-conv-top"><span class="eq-conv-name">'+esc(nom)+' <span class="eq-conv-role">'+roleLbl+'</span></span><span class="eq-conv-time">'+time+'</span></div>'+
              '<div class="eq-conv-prev">'+preview+'</div>'+
            '</div>'+
            (t.unread?'<span class="eq-conv-dot"></span>':'')+
          '</button>';
        });
        html+='</div>';
      }
      list.innerHTML=html;
      var nb=document.getElementById('eqDMNew');
      if(nb) nb.addEventListener('click', openDMContacts);
      var ng=document.getElementById('eqDMNewGroup');
      if(ng) ng.addEventListener('click', openGroupCreate);
      var rows=list.querySelectorAll('.eq-conv-row');
      for(var i=0;i<rows.length;i++){ rows[i].addEventListener('click', function(){ openDMThread(this.getAttribute('data-tid'), this.getAttribute('data-name'), this.getAttribute('data-kind')); }); }
    }).catch(function(e){
      list.innerHTML='<div class="eq-chat-empty">Erreur de chargement.<br>'+esc(e&&e.message?e.message:'')+'</div>';
    });
  }

  function convListTime(iso){
    var d=new Date(iso), now=new Date();
    if(d.toDateString()===now.toDateString()){ return ('0'+d.getHours()).slice(-2)+'h'+('0'+d.getMinutes()).slice(-2); }
    var y=new Date(now.getTime()-86400000);
    if(d.toDateString()===y.toDateString()) return 'Hier';
    return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2);
  }

  /* ---- choisir un contact ----
     Éducateurs et administrateurs, puis les membres des équipes que l'on
     partage (un parent de M10 peut écrire aux autres parents de M10).
     Un administrateur voit tout le monde. La règle est appliquée par le
     serveur (dm_contacts / dm_open_thread), l'écran ne fait qu'afficher. */
  function openDMContacts(){
    var list=document.getElementById('eqMsgList'); if(!list) return;
    list.innerHTML=loadingHTML();
    var ROLE_LBL={ admin:'Admin', educateur:'Éducateur', parent:'Parent' };
    function sansAccent(t){ return String(t||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,''); }
    dmContacts().then(function(contacts){
      STATE.dmContacts=(contacts||[]).filter(function(c){ return c.id!==USER.id; });
      var html='<button class="eq-dm-back" id="eqDMBack" type="button">'+IC.back+' Retour</button>'+
        '<div class="eq-dm-sectitle">Nouveau message</div>'+
        '<div style="padding:0 14px 10px"><input id="eqDMSearch" class="eq-input" type="search" autocomplete="off" '+
          'placeholder="Rechercher un nom ou une équipe…" style="width:100%;font-size:16px"></div>'+
        '<div id="eqDMContactList"></div>';
      list.innerHTML=html;

      function rowHTML(c){
        var initial=(c.full_name||'?').trim().charAt(0).toUpperCase();
        var av=c.avatar_url
          ? '<div class="eq-conv-av" style="background:url(\''+esc(c.avatar_url)+'\') center/cover"></div>'
          : '<div class="eq-conv-av">'+initial+'</div>';
        var sub=[ROLE_LBL[c.role]||'Membre'];
        if(c.teams) sub.push(c.teams);
        return '<button class="eq-conv-row" data-uid="'+c.id+'" data-name="'+esc(c.full_name||'')+'" type="button">'+av+
          '<div class="eq-conv-mid"><div class="eq-conv-top"><span class="eq-conv-name">'+esc(c.full_name||'Membre')+'</span></div>'+
          '<div class="eq-conv-prev">'+esc(sub.join(' · '))+'</div></div></button>';
      }
      function paint(){
        var q=sansAccent((document.getElementById('eqDMSearch')||{}).value||'').trim();
        var rows=STATE.dmContacts.filter(function(c){
          return !q || sansAccent((c.full_name||'')+' '+(c.teams||'')).indexOf(q)>=0;
        });
        var staff=rows.filter(function(c){ return c.role==='admin' || c.role==='educateur'; });
        var membres=rows.filter(function(c){ return !(c.role==='admin' || c.role==='educateur'); });
        var h='';
        if(staff.length) h+='<div class="eq-dm-sectitle" style="font-size:12px;opacity:.75">Éducateurs et encadrement</div>'+
          '<div class="eq-conv-list">'+staff.map(rowHTML).join('')+'</div>';
        if(membres.length) h+='<div class="eq-dm-sectitle" style="font-size:12px;opacity:.75">'+
          (PROFILE && PROFILE.role==='admin' ? 'Membres du club' : 'Membres de mes équipes')+'</div>'+
          '<div class="eq-conv-list">'+membres.map(rowHTML).join('')+'</div>';
        if(!rows.length) h='<div class="eq-chat-empty">'+(q?'Aucun contact ne correspond.':'Aucun contact disponible pour le moment.')+'</div>';
        var box=document.getElementById('eqDMContactList'); if(!box) return;
        box.innerHTML=h;
        var th=box.querySelectorAll('.eq-conv-row');
        for(var i=0;i<th.length;i++){ th[i].addEventListener('click', function(){
          var uid=this.getAttribute('data-uid'); var name=this.getAttribute('data-name');
          dmOpenThread(uid).then(function(tid){ openDMThread(tid, name); })
            .catch(function(e){ alert(e&&e.message?e.message:'Erreur'); });
        }); }
      }
      paint();
      var sf=document.getElementById('eqDMSearch'); if(sf) sf.addEventListener('input', paint);
      var bk=document.getElementById('eqDMBack'); if(bk) bk.addEventListener('click', renderMsgList);
    }).catch(function(e){
      var l=document.getElementById('eqMsgList'); if(l) l.innerHTML='<div class="eq-chat-empty">Erreur.<br>'+esc(e&&e.message?e.message:'')+'</div>';
    });
  }

  /* ---- vue conversation (messages d'un thread privé) ---- */
  /* ============================================================
     LIEN DIRECT — ouvrir la bonne conversation depuis une notification
     ============================================================
     Cibles : « cat:<catégorie>:<0|1> » (1 = canal Éducateurs),
     « dm:<fil> », « valid », « event:<id> ».
     Toucher une notification ouvrait seulement la page Connect : il
     fallait ensuite chercher le message soi-même, ce qui décourageait
     tout le monde, parents en premier. */
  function lireCible(){
    var m=(window.location.hash||'').match(/open=([^&]+)/);
    if(!m) return STATE.pendingOpen||null;
    try{ history.replaceState(null,'',window.location.pathname+window.location.search); }catch(e){}
    return decodeURIComponent(m[1]);
  }
  function openTarget(t){
    if(!t) return false;
    STATE.pendingOpen=null;
    var p=String(t).split(':');
    if(p[0]==='cat' && p[1]){
      STATE.msgMode='cat';
      STATE.chatChannel=(p[2]==='1')?'staff':'general';
      switchTab('chat');
      openCatThread(p[1]);
      return true;
    }
    if(p[0]==='dm' && p[1]){
      STATE.msgMode='dm';
      switchTab('chat');
      openDMThread(p[1], 'Conversation');
      return true;
    }
    if(p[0]==='valid'){ switchTab('valid'); return true; }
    if(p[0]==='event'){ switchTab('cal'); return true; }
    return false;
  }
  // Point d'entrée pour l'application : elle l'appelle quand on touche une
  // notification alors que la page est déjà ouverte.
  window.usvOpen=function(t){
    // Tant que les catégories ne sont pas chargées, on met la demande de
    // côté : le démarrage la reprendra. (STATE.teams vaut une liste vide
    // dès le départ, il ne peut pas servir de témoin.)
    if(!USER || !STATE._ready){ STATE.pendingOpen=t; return; }
    openTarget(t);
  };
  if(!STATE._hashBound){
    STATE._hashBound=true;
    window.addEventListener('hashchange', function(){
      var c=lireCible(); if(c && USER && STATE._ready) openTarget(c);
    });
  }

  function openDMThread(threadId, otherName, kind){
    STATE.dmThread=threadId;
    // Le type du fil vient de la liste ; s'il manque (ouverture directe
    // après création), on le retrouve dans l'état déjà chargé.
    if(!kind){
      var known=STATE.dmThreads.filter(function(t){ return t.thread_id===threadId; })[0];
      kind=known?known.kind:'direct';
    }
    var isGroup=(kind==='group');
    STATE.dmThreadKind=kind;
    var body=document.getElementById('eqBody');
    body.innerHTML='<div class="eq-h eq-conv-head"><button class="eq-dm-back" id="eqDMBack2" type="button">'+IC.back+'</button>'+
        '<div class="eq-conv-htitle"><div class="eq-conv-hname">'+esc(otherName||'Conversation')+'</div>'+
        '<div class="eq-conv-hsub">'+(isGroup?'Groupe privé':'Message privé')+'</div></div>'+
        (isGroup?'<button class="eq-conv-manage" id="eqDMManage" type="button" title="Gérer le groupe">'+IC.users+'</button>':'')+
        '</div>'+
      '<div class="eq-chat-feed" id="eqDMFeed">'+loadingHTML()+'</div>'+
      '<div class="eq-chat-compose">'+
        '<button class="eq-chat-photo" id="eqDMPhoto" type="button" title="Envoyer une photo">'+IC.camera+'</button>'+
        '<input type="file" id="eqDMFile" accept="image/*" lang="fr" title="Choisir une photo" style="display:none">'+
        '<textarea class="eq-chat-input" rows="1" id="eqDMInput" placeholder="Écris un message privé…" maxlength="800"></textarea>'+
        '<button class="eq-chat-send" id="eqDMSendBtn" type="button">'+IC.send+'</button>'+
      '</div>';
    document.getElementById('eqDMBack2').addEventListener('click', function(){ STATE.dmThread=null; renderMsgList(); });
    focusChat();
    var mg=document.getElementById('eqDMManage');
    if(mg) mg.addEventListener('click', function(){ openGroupManage(threadId, otherName); });
    var input=document.getElementById('eqDMInput');
    document.getElementById('eqDMSendBtn').addEventListener('click', function(){ sendDM(input); });
    input.addEventListener('keydown', function(e){
      // Entrée envoie, Maj+Entrée passe à la ligne.
      // Sur téléphone il n'y a pas de touche Maj : Entrée doit donc
      // insérer un retour à la ligne, et l'envoi se fait avec le bouton.
      // Sur ordinateur, on garde Entrée = envoyer, Maj+Entrée = nouvelle ligne.
      if(e.key==='Enter' && !e.shiftKey && !isTouch()){ e.preventDefault(); sendDM(input); }
    });
    input.addEventListener('input', function(){ autoGrow(this); });
    var dmPhoto=document.getElementById('eqDMPhoto');
    var dmFile=document.getElementById('eqDMFile');
    if(dmPhoto&&dmFile){
      dmPhoto.addEventListener('click', function(){ dmFile.click(); });
      dmFile.addEventListener('change', function(){
        var f=dmFile.files&&dmFile.files[0]; if(!f) return;
        sendDMPhoto(f, dmPhoto);
        dmFile.value='';
      });
    }
    loadDMFeed();
    dmMarkRead(threadId).then(function(){ refreshDMBadge(); }).catch(function(){});
  }

  // Noms des participants du fil courant, pour afficher l'auteur dans
  // un groupe. Chargés une fois par ouverture, pas à chaque message.
  var DM_NAMES={};

  function loadDMFeed(){
    var tid=STATE.dmThread;
    var namesReady = (STATE.dmThreadKind==='group')
      ? dmGroupMembers(tid).then(function(rows){
          DM_NAMES={};
          (rows||[]).forEach(function(r){ DM_NAMES[r.profile_id]=r.full_name; });
        }).catch(function(){ DM_NAMES={}; })
      : Promise.resolve();

    namesReady.then(function(){
    dmLoadMessages(tid).then(function(msgs){
      // Réactions chargées en un seul appel pour tout le fil, avant le
      // rendu : une requête par message ferait cinquante allers-retours.
      return loadReactions('dm', (msgs||[]).map(function(m){ return m.id; }))
        .then(function(){ return msgs; });
    }).then(function(msgs){
      var feed=document.getElementById('eqDMFeed'); if(!feed) return;
      if(!msgs||!msgs.length){ feed.innerHTML='<div class="eq-chat-empty">Aucun message.<br>Lance la conversation 👋</div>'; return; }
      var html='';
      // Dans un groupe, on affiche l'auteur : sans lui, trois personnes
      // qui écrivent deviennent indiscernables.
      var isGroup=(STATE.dmThreadKind==='group');
      var lastDay='';
      msgs.forEach(function(m){
        var mine=(m.sender_id===USER.id);
        var d=new Date(m.created_at);
        var dayKey=d.toDateString();
        if(dayKey!==lastDay){
          html+='<div class="eq-chat-day">'+chatDayLabel(d)+'</div>';
          lastDay=dayKey;
        }
        var time=('0'+d.getHours()).slice(-2)+'h'+('0'+d.getMinutes()).slice(-2);
        var auteur=DM_NAMES[m.sender_id]||'';

        html+='<div class="eq-chat-msg'+(mine?' mine':'')+'" data-who="'+esc(mine?'me':(m.sender_id||''))+'" data-ts="'+d.getTime()+'">';
        if(isGroup && !mine) html+='<div class="eq-chat-av">'+initials(auteur)+'</div>';
        html+='<div class="eq-chat-bubble-wrap">';
        if(isGroup && !mine && auteur) html+='<div class="eq-chat-author">'+esc(auteur)+'</div>';

        if(m.image_url){
          html+='<div class="eq-chat-bubble eq-chat-imgbubble">'+
            (m.body?'<div class="eq-chat-imgcaption">'+esc(m.body)+'</div>':'')+
            '<img class="eq-chat-img" src="'+esc(m.image_url)+'" alt="Photo" loading="lazy" data-full="'+esc(m.image_url)+'">'+
          '</div>';
        } else {
          html+='<div class="eq-chat-bubble">'+esc(m.body)+'</div>';
        }

        html+=reactionsHTML('dm', m.id);
        var edited = m.edited_at ? ' · <span class="eq-chat-edited">modifié</span>' : '';
        // Comme dans les catégories : une photo ne se modifie pas, on la
        // supprime et on la renvoie.
        var canEdit = mine && !m.image_url;
        html+='<div class="eq-chat-time">'+time+edited+
          (canEdit?' · <span class="eq-chat-edit" data-dmedit="'+m.id+'">Modifier</span>':'')+
          (mine?' · <span class="eq-chat-del" data-dmdel="'+m.id+'">Supprimer</span>':'')+'</div>';
        html+='</div></div>';
      });
      feed.innerHTML=html;
      groupFeed(feed); fitChat();

      bindReactions(feed, loadDMFeed);
      var dels=feed.querySelectorAll('[data-dmdel]');
      for(var k=0;k<dels.length;k++){
        dels[k].addEventListener('click', function(){ delDMMessage(this.getAttribute('data-dmdel')); });
      }
      var eds=feed.querySelectorAll('[data-dmedit]');
      for(var e3=0;e3<eds.length;e3++){
        eds[e3].addEventListener('click', function(){
          var id=this.getAttribute('data-dmedit');
          var msg=msgs.filter(function(x){ return String(x.id)===String(id); })[0];
          if(msg) startEditDM(id, msg.body||'');
        });
      }
      var imgs=feed.querySelectorAll('.eq-chat-img');
      for(var j=0;j<imgs.length;j++){ imgs[j].addEventListener('click', function(){ openPhotoViewer(this.getAttribute('data-full')); }); }
      feed.scrollTop=feed.scrollHeight;
    }).catch(function(e){
      var feed=document.getElementById('eqDMFeed'); if(feed) feed.innerHTML='<div class="eq-chat-empty">Erreur.<br>'+esc(e&&e.message?e.message:'')+'</div>';
    });
    });
  }

  function sendDMPhoto(file, btn){
    if(!file.type || file.type.indexOf('image/')!==0){ alert('Choisis une image.'); return; }
    if(btn){ btn.disabled=true; btn.classList.add('eq-uploading'); }
    uploadChatPhoto(file).then(function(url){
      return dmSend(STATE.dmThread, '', url);
    }).then(function(){
      if(btn){ btn.disabled=false; btn.classList.remove('eq-uploading'); }
      loadDMFeed();
    }).catch(function(e){
      if(btn){ btn.disabled=false; btn.classList.remove('eq-uploading'); }
      alert('Erreur envoi photo : '+(e&&e.message?e.message:e));
    });
  }

  function sendDM(input){
    var txt=input.value.trim(); if(!txt) return;
    input.value=''; resetGrow(input);
    dmSend(STATE.dmThread, txt)
    .then(function(){ loadDMFeed(); })
    .catch(function(e){ alert('Erreur : '+(e&&e.message?e.message:e)); input.value=txt; });
  }

  /* ---- sélecteur Catégories / Privés ---- */
  function msgModeSeg(){
    return '<div class="eq-chan-seg eq-msgmode">'+
      '<button class="eq-chan-opt '+(STATE.msgMode!=='dm'?'on':'')+'" data-mode="cat" type="button">'+IC.users+' Catégories</button>'+
      '<button class="eq-chan-opt '+(STATE.msgMode==='dm'?'on':'')+'" data-mode="dm" type="button">'+IC.chat+' Privés<span class="eq-dm-badge" id="eqDMBadgeSeg"></span></button>'+
    '</div>';
  }
  function bindMsgModeSeg(){
    var opts=document.querySelectorAll('.eq-msgmode .eq-chan-opt');
    for(var i=0;i<opts.length;i++){ opts[i].addEventListener('click', function(){ STATE.msgMode=(this.getAttribute('data-mode')==='dm'?'dm':'cat'); STATE.dmThread=null; STATE.chatOpen=false; renderMsgList(); }); }
    paintDMBadgeSeg();
  }
  function paintDMBadgeSeg(){
    var b=document.getElementById('eqDMBadgeSeg'); if(!b) return;
    var n=STATE.dmUnread||0;
    b.textContent=n>0?(n>9?'9+':String(n)):'';
    b.style.display=n>0?'inline-flex':'none';
  }
  /* ============================================================
     MESSAGES NON LUS — catégories + privés
     ============================================================
     Un seul total, affiché partout où il est utile : sur l'onglet
     Messages, sur chaque catégorie de la liste, sur chaque canal, et
     transmis à l'application pour la pastille de l'onglet Connect et de
     l'icône. Avant, seuls les messages privés étaient suivis, et par un
     simple point sans chiffre. */
  STATE.catUnread = STATE.catUnread || {};
  function catKey(team, staff){ return team+':'+(staff?1:0); }
  function catUnreadFor(team){
    return (STATE.catUnread[catKey(team,false)]||0)+(STATE.catUnread[catKey(team,true)]||0);
  }
  function totalUnread(){
    var t=STATE.dmUnread||0;
    for(var k in STATE.catUnread){ if(STATE.catUnread.hasOwnProperty(k)) t+=STATE.catUnread[k]||0; }
    return t;
  }
  function loadCatUnread(){
    return api('/rest/v1/rpc/cat_unread_counts',{ method:'POST', body:{} })
      .then(function(rows){
        var m={};
        (rows||[]).forEach(function(r){ m[catKey(r.team_id, r.staff_only)]=r.unread||0; });
        STATE.catUnread=m;
        paintUnread();
      })
      .catch(function(){ /* fonction absente tant que le SQL 81 n'est pas passé */ });
  }
  function badgeTxt(n){ return n>99 ? '99+' : String(n); }
  function setBadge(host, cls, count){
    if(!host) return;
    var b=host.querySelector('.'+cls);
    if(count>0){
      if(!b){ b=document.createElement('span'); b.className=cls; host.appendChild(b); }
      b.textContent=badgeTxt(count);
    } else if(b){ b.parentNode.removeChild(b); }
  }
  function paintUnread(){
    var total=totalUnread();

    // Onglet Messages de la barre du bas : un chiffre, plus un point.
    var nav=document.querySelector('#eqNav button[data-tab="chat"]');
    if(nav){
      var dot=nav.querySelector('.eq-nav-dmdot'); if(dot) dot.parentNode.removeChild(dot);
      setBadge(nav, 'eq-nav-count', total);
    }

    // Chaque catégorie de la liste.
    document.querySelectorAll('.eq-conv-row[data-team]').forEach(function(row){
      var c=catUnreadFor(row.getAttribute('data-team'));
      row.classList.toggle('unread', c>0);
      setBadge(row.querySelector('.eq-conv-top'), 'eq-conv-badge', c);
    });

    // Canaux Général / Éducateurs de la conversation ouverte.
    if(STATE.chatTeam){
      document.querySelectorAll('.eq-chan-opt[data-chan]').forEach(function(btn){
        var staff=(btn.getAttribute('data-chan')==='staff');
        setBadge(btn, 'eq-chan-badge', STATE.catUnread[catKey(STATE.chatTeam, staff)]||0);
      });
    }

    // L'application affiche la même pastille sur l'onglet Connect et sur
    // l'icône du téléphone.
    try{
      if(window.ReactNativeWebView)
        window.ReactNativeWebView.postMessage(JSON.stringify({ type:'unread', count: total }));
    }catch(e){}
  }

  // Marque comme lu le canal ouvert : à l'ouverture et à chaque
  // rafraîchissement du fil pendant qu'il est à l'écran.
  function markCatRead(){
    if(!STATE.chatTeam) return;
    var staff=(STATE.chatChannel==='staff');
    var k=catKey(STATE.chatTeam, staff);
    if(STATE.catUnread[k]){ STATE.catUnread[k]=0; paintUnread(); }
    api('/rest/v1/rpc/cat_mark_read',{ method:'POST',
      body:{ p_team:STATE.chatTeam, p_staff_only:staff }, prefer:'return=minimal' })
      .catch(function(){});
  }

  function refreshDMBadge(){
    dmUnreadCount().then(function(n){ STATE.dmUnread=(typeof n==='number'?n:(n&&n.length?0:0)); paintDMBadgeSeg(); paintNavDMBadge(); }).catch(function(){});
  }
  // Le point des messages privés est remplacé par le total chiffré.
  function paintNavDMBadge(){ paintUnread(); }

  /* ============================================================
     MESSAGERIE — vue CONVERSATION d'une catégorie (plein écran)
     ============================================================ */
  function openCatThread(teamId){
    STATE.chatTeam=teamId;
    STATE.chatOpen=true;
    var body=document.getElementById('eqBody');
    var staff=(PROFILE.role==='educateur'||PROFILE.role==='admin');
    var team=STATE.teams.filter(function(t){return t.id===teamId;})[0]||{name:'Catégorie'};
    // sélecteur de canal (staff uniquement) : Général / Éducateurs
    var channelBar='';
    if(staff){
      channelBar='<div class="eq-chan-seg eq-chan-channel">'+
        '<button class="eq-chan-opt '+(STATE.chatChannel!=='staff'?'on':'')+'" data-chan="general" type="button">'+IC.users+' Général</button>'+
        '<button class="eq-chan-opt '+(STATE.chatChannel==='staff'?'on':'')+'" data-chan="staff" type="button">'+IC.whistle+' Éducateurs</button>'+
      '</div>';
    } else { STATE.chatChannel='general'; }
    var manageBtn = staff ? '<button class="eq-chat-manage" id="eqChatManage" type="button">'+IC.users+'</button>' : '';
    body.innerHTML='<div class="eq-h eq-conv-head"><button class="eq-dm-back" id="eqChatBack" type="button">'+IC.back+'</button>'+
        '<div class="eq-conv-htitle"><div class="eq-conv-hname">'+esc(team.name)+'</div><div class="eq-conv-hsub">Discussion de catégorie</div></div>'+
        manageBtn+'</div>'+
      channelBar+
      (STATE.chatChannel==='staff'?'<div id="eqChatStaffBar" class="eq-chan-bar"></div>':'')+
      '<div id="eqPolls" class="eq-polls"></div>'+
      '<div class="eq-chat-feed" id="eqChatFeed">'+loadingHTML()+'</div>'+
      '<div class="eq-chat-compose">'+
        '<button class="eq-chat-photo" id="eqChatPhoto" type="button" title="Envoyer une photo">'+IC.camera+'</button>'+
        '<input type="file" id="eqChatFile" accept="image/*" lang="fr" title="Choisir une photo" style="display:none">'+
        '<textarea class="eq-chat-input" rows="1" id="eqChatInput" placeholder="'+(STATE.chatChannel==='staff'?'Message aux éducateurs…':'Écris un message…')+'" maxlength="800"></textarea>'+
        '<button class="eq-chat-send" id="eqChatSend" type="button">'+IC.send+'</button>'+
      '</div>';
    document.getElementById('eqChatBack').addEventListener('click', function(){ STATE.chatOpen=false; renderMsgList(); });
    focusChat();
    var chanBtns=body.querySelectorAll('.eq-chan-channel .eq-chan-opt');
    for(var ch=0;ch<chanBtns.length;ch++){ chanBtns[ch].addEventListener('click', function(){ STATE.chatChannel=(this.getAttribute('data-chan')==='staff'?'staff':'general'); openCatThread(STATE.chatTeam); }); }
    var input=document.getElementById('eqChatInput');
    document.getElementById('eqChatSend').addEventListener('click', function(){ sendMessage(input); });
    input.addEventListener('keydown', function(e){
      if(e.key==='Enter' && !e.shiftKey && !isTouch()){ e.preventDefault(); sendMessage(input); }
    });
    input.addEventListener('input', function(){ autoGrow(this); });
    var photoBtn=document.getElementById('eqChatPhoto');
    var fileInput=document.getElementById('eqChatFile');
    if(photoBtn&&fileInput){
      photoBtn.addEventListener('click', function(){ fileInput.click(); });
      fileInput.addEventListener('change', function(){
        var f=fileInput.files&&fileInput.files[0]; if(!f) return;
        sendPhotoMessage(f, photoBtn);
        fileInput.value='';
      });
    }
    var manage=document.getElementById('eqChatManage');
    if(manage) manage.addEventListener('click', openGroupModal);

    // Dans le canal Éducateurs, on rappelle qui va lire le message.
    // Écrire sans savoir à qui on parle est la première source de
    // malentendu sur ce canal.
    if(STATE.chatChannel==='staff'){
      var bar0=document.getElementById('eqChatStaffBar');
      if(bar0) bar0.innerHTML='<span class="eq-chan-who">Chargement des destinataires…</span>';

      loadGroupRoster(STATE.chatTeam).then(function(roster){
        var educs=(roster||[]).filter(function(p){
          return p.in_group && (p.member_role==='educateur'||p.member_role==='admin');
        });
        var bar=document.getElementById('eqChatStaffBar');
        if(!bar) return;
        if(!educs.length){
          bar.innerHTML='<span class="eq-chan-warn">⚠️ Aucun éducateur dans ce groupe — '+
            'personne ne lira ce message. Touche l\'icône en haut à droite pour en ajouter.</span>';
          return;
        }
        setTimeout(fitChat, 0);
        bar.innerHTML='<span class="eq-chan-who">'+IC.whistle+' Lu par '+educs.length+
          ' éducateur'+(educs.length>1?'s':'')+' : '+
          esc(educs.map(function(p){
            return (p.member_name&&p.member_name.trim())?p.member_name:p.member_email.split('@')[0];
          }).join(', '))+'</span>';
      }).catch(function(e){
        // Un échec silencieux rendrait le bandeau invisible sans qu'on
        // sache pourquoi : on affiche l'erreur plutôt que de la taire.
        var bar=document.getElementById('eqChatStaffBar');
        if(bar) bar.innerHTML='<span class="eq-chan-warn">Destinataires indisponibles : '+
          esc((e&&e.message)||'erreur inconnue')+'</span>';
        console.error('group_roster :', e);
      });
    }

    loadChatFeed();
  }

  /* ============================================================
     SONDAGES
     ============================================================
     Épinglés au-dessus du fil plutôt qu'insérés dedans : un sondage qui
     remonte avec les messages disparaît de l'écran en une heure, et
     personne n'y répond. */
  function loadPolls(){
    var box=document.getElementById('eqPolls');
    if(!box) return;
    // Le canal fait partie de l'identité du sondage : sans lui, un
    // sondage du canal Éducateurs s'affichait aussi dans Général.
    api('/rest/v1/rpc/polls_for',{ method:'POST',
      body:{ p_team:STATE.chatTeam || null, p_thread:null,
             p_staff_only: STATE.chatChannel==='staff' } })
      .then(function(rows){ paintPolls(rows||[]); })
      .catch(function(){ box.innerHTML=''; });
  }

  function paintPolls(rows){
    var box=document.getElementById('eqPolls');
    if(!box) return;
    var staff=(PROFILE.role==='educateur'||PROFILE.role==='admin');

    var html='';
    if(staff){
      html+='<button type="button" class="eq-poll-new" id="eqPollNew">'+
            '📊 Créer un sondage</button>';
    }

    rows.forEach(function(p){
      var counts=p.counts||[], total=p.total||0, mine=p.mine||[];
      html+='<div class="eq-poll'+(p.closed?' closed':'')+'">'+
        '<div class="eq-poll-q">'+esc(p.question)+
          (p.closed?'<span class="eq-poll-tag">terminé</span>':'')+'</div>'+
        '<div class="eq-poll-meta">'+esc(p.auteur)+
          ' · '+total+' réponse'+(total>1?'s':'')+
          (p.multi?' · plusieurs choix possibles':'')+
          (p.anonymous?'':' · réponses visibles')+'</div>';

      (p.options||[]).forEach(function(o, i){
        var nb=counts[i]||0;
        var pct= total ? Math.round(nb*100/total) : 0;
        var chosen=(mine.indexOf(i)!==-1);
        html+='<button type="button" class="eq-poll-opt'+(chosen?' on':'')+'" '+
          'data-poll="'+p.id+'" data-opt="'+i+'"'+(p.closed?' disabled':'')+'>'+
          '<span class="eq-poll-fill" style="width:'+pct+'%"></span>'+
          '<span class="eq-poll-lab">'+esc(o)+'</span>'+
          '<span class="eq-poll-nb">'+nb+(total?' · '+pct+'%':'')+'</span>'+
          '</button>';
      });

      if(!p.anonymous && p.voters && p.voters.length){
        html+='<div class="eq-poll-voters">Ont répondu : '+
              esc(p.voters.join(', '))+'</div>';
      }
      if(staff){
        html+='<div class="eq-poll-acts">'+
          '<button type="button" class="eq-poll-act" data-pclose="'+p.id+'" '+
            'data-to="'+(p.closed?'0':'1')+'">'+
            (p.closed?'Rouvrir':'Clore')+'</button>'+
          '<button type="button" class="eq-poll-act danger" data-pdel="'+p.id+'">'+
            'Supprimer</button></div>';
      }
      html+='</div>';
    });
    box.innerHTML=html;

    var nb=document.getElementById('eqPollNew');
    if(nb) nb.addEventListener('click', openPollCreate);
    // Les sondages s'insèrent au-dessus du fil : sa hauteur change.
    fitChat();

    box.querySelectorAll('[data-opt]').forEach(function(b){
      b.addEventListener('click', function(){
        var pid=this.getAttribute('data-poll');
        var idx=parseInt(this.getAttribute('data-opt'),10);
        var p=rows.filter(function(x){ return x.id===pid; })[0];
        var sel=(p && p.multi) ? (p.mine||[]).slice() : [];
        if(p && p.multi){
          var k=sel.indexOf(idx);
          if(k>=0) sel.splice(k,1); else sel.push(idx);
        } else { sel=[idx]; }
        api('/rest/v1/rpc/poll_vote',{ method:'POST',
          body:{ p_poll:pid, p_options:sel }, prefer:'return=minimal' })
          .then(loadPolls).catch(function(e){ alert(e.message); });
      });
    });
    box.querySelectorAll('[data-pclose]').forEach(function(b){
      b.addEventListener('click', function(){
        api('/rest/v1/rpc/poll_close',{ method:'POST',
          body:{ p_poll:this.getAttribute('data-pclose'),
                 p_closed:this.getAttribute('data-to')==='1' },
          prefer:'return=minimal' })
          .then(loadPolls).catch(function(e){ alert(e.message); });
      });
    });
    box.querySelectorAll('[data-pdel]').forEach(function(b){
      b.addEventListener('click', function(){
        if(!confirm('Supprimer ce sondage et toutes ses réponses ?')) return;
        api('/rest/v1/rpc/poll_delete',{ method:'POST',
          body:{ p_poll:this.getAttribute('data-pdel') }, prefer:'return=minimal' })
          .then(loadPolls).catch(function(e){ alert(e.message); });
      });
    });
  }

  function openPollCreate(){
    var ov=document.createElement('div'); ov.className='eq-modal';
    ov.innerHTML='<div class="eq-modal-ov" id="eqPoOv"></div><div class="eq-modal-card">'+
      '<div class="eq-modal-grab"></div>'+
      '<div class="eq-modal-title">Nouveau sondage</div>'+
      '<div class="eq-modal-sub">'+
        (STATE.chatChannel==='staff'
          ? 'Visible des éducateurs de la catégorie uniquement'
          : 'Visible de toute la catégorie, parents compris')+'</div>'+
      '<div id="eqPoMsg"></div>'+
      '<div class="eq-field"><label>Question</label>'+
        '<input class="eq-input" id="eqPoQ" placeholder="Ex. Qui est dispo samedi ?" maxlength="140"></div>'+
      '<div class="eq-field"><label>Réponses</label><div id="eqPoOpts">'+
        '<input class="eq-input eq-po-opt" placeholder="Réponse 1">'+
        '<input class="eq-input eq-po-opt" placeholder="Réponse 2">'+
      '</div>'+
      '<button type="button" class="eq-poll-addopt" id="eqPoAdd">+ Ajouter une réponse</button></div>'+
      '<label class="eq-check"><input type="checkbox" id="eqPoMulti">'+
        '<span>Plusieurs réponses possibles</span></label>'+
      '<label class="eq-check"><input type="checkbox" id="eqPoNames">'+
        '<span>Voir qui a répondu quoi</span></label>'+
      '<div class="eq-note">Pour des disponibilités, coche « voir qui a répondu ». '+
        'Pour un avis, laisse anonyme : les gens répondent plus franchement.</div>'+
      '<button type="button" class="eq-btn" id="eqPoSave">Publier le sondage</button>'+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqPoCancel" style="margin-top:10px">Annuler</button>'+
      '</div>';
    document.querySelector('.eq-app').appendChild(ov);
    var close=function(){ if(ov.parentNode) ov.parentNode.removeChild(ov); };
    document.getElementById('eqPoOv').addEventListener('click', close);
    document.getElementById('eqPoCancel').addEventListener('click', close);
    var say=function(t){ document.getElementById('eqPoMsg').innerHTML=
      '<div class="eq-msg eq-msg-err"><span class="eq-msg-ic">⚠️</span><span>'+esc(t)+'</span></div>'; };

    document.getElementById('eqPoAdd').addEventListener('click', function(){
      var box=document.getElementById('eqPoOpts');
      if(box.querySelectorAll('.eq-po-opt').length>=8){ say('Huit réponses au maximum.'); return; }
      var i=document.createElement('input');
      i.className='eq-input eq-po-opt';
      i.placeholder='Réponse '+(box.querySelectorAll('.eq-po-opt').length+1);
      box.appendChild(i); i.focus();
    });

    document.getElementById('eqPoSave').addEventListener('click', function(){
      var q=document.getElementById('eqPoQ').value.trim();
      var opts=[];
      ov.querySelectorAll('.eq-po-opt').forEach(function(i){
        var v=i.value.trim(); if(v) opts.push(v);
      });
      if(!q){ say('Pose une question.'); return; }
      if(opts.length<2){ say('Il faut au moins deux réponses.'); return; }
      this.disabled=true;
      api('/rest/v1/rpc/poll_create',{ method:'POST', body:{
        p_team:STATE.chatTeam, p_thread:null, p_question:q, p_options:opts,
        p_multi:document.getElementById('eqPoMulti').checked,
        p_anonymous:!document.getElementById('eqPoNames').checked,
        p_staff_only: STATE.chatChannel==='staff'
      }})
      .then(function(){ close(); loadPolls(); })
      .catch(function(e){
        document.getElementById('eqPoSave').disabled=false; say(e.message);
      });
    });
  }

  function loadChatFeed(){
    loadPolls();
    loadMessages(STATE.chatTeam).then(function(msgs){
      return loadReactions('cat', (msgs||[]).map(function(m){ return m.id; }))
        .then(function(){ return msgs; });
    }).then(function(msgs){
      var feed=document.getElementById('eqChatFeed');
      if(!feed) return;
      if(!msgs||!msgs.length){
        feed.innerHTML='<div class="eq-chat-empty">Aucun message pour l\'instant.<br>Lance la discussion 👋</div>';
        return;
      }
      var html='';
      var lastDay='';
      msgs.forEach(function(m){
        var mine=(m.profile_id===USER.id);
        var d=new Date(m.created_at);
        var dayKey=d.toDateString();
        if(dayKey!==lastDay){
          html+='<div class="eq-chat-day">'+chatDayLabel(d)+'</div>';
          lastDay=dayKey;
        }
        var time=('0'+d.getHours()).slice(-2)+'h'+('0'+d.getMinutes()).slice(-2);
        var isStaffMsg=(m.author_role==='educateur'||m.author_role==='admin');
        html+='<div class="eq-chat-msg '+(mine?'mine':'')+'" data-who="'+esc(mine?'me':(m.profile_id||m.author_name||''))+'" data-ts="'+d.getTime()+'">';
        if(!mine) html+='<div class="eq-chat-av'+(isStaffMsg?' staff':'')+'">'+initials(m.author_name)+'</div>';
        html+='<div class="eq-chat-bubble-wrap">';
        if(!mine) html+='<div class="eq-chat-author">'+esc(m.author_name||'Membre')+(isStaffMsg?' <span class="eq-chat-badge" title="Staff du club">'+IC.whistle+'</span>':'')+'</div>';
        if(m.image_url){
          html+='<div class="eq-chat-bubble eq-chat-imgbubble'+(isStaffMsg&&!mine?' staff':'')+'">'+
            (m.body?'<div class="eq-chat-imgcaption">'+esc(m.body)+'</div>':'')+
            '<img class="eq-chat-img" src="'+esc(m.image_url)+'" alt="Photo" loading="lazy" data-full="'+esc(m.image_url)+'">'+
          '</div>';
        } else {
          html+='<div class="eq-chat-bubble'+(isStaffMsg&&!mine?' staff':'')+'">'+esc(m.body)+'</div>';
        }
        html+=reactionsHTML('cat', m.id);
        var edited = m.edited_at ? ' · <span class="eq-chat-edited">modifié</span>' : '';
        // Seul le texte est modifiable : retoucher la légende d'une photo
        // sans voir la photo prêterait à confusion.
        var canEdit = mine && !m.image_url;
        html+='<div class="eq-chat-time">'+time+edited+
          (canEdit?' · <span class="eq-chat-edit" data-edit="'+m.id+'">Modifier</span>':'')+
          (mine?' · <span class="eq-chat-del" data-del="'+m.id+'">Supprimer</span>':'')+'</div>';
        html+='</div></div>';
      });
      feed.innerHTML=html;
      groupFeed(feed); fitChat();
      feed.scrollTop=feed.scrollHeight;
      bindReactions(feed, loadChatFeed);
      var dels=feed.querySelectorAll('.eq-chat-del');
      for(var i=0;i<dels.length;i++){ dels[i].addEventListener('click', function(){ delMessage(this.getAttribute('data-del')); }); }
      var eds=feed.querySelectorAll('.eq-chat-edit');
      for(var e2=0;e2<eds.length;e2++){
        eds[e2].addEventListener('click', function(){
          var id=this.getAttribute('data-edit');
          var msg=msgs.filter(function(x){ return String(x.id)===String(id); })[0];
          if(msg) startEditMessage(id, msg.body||'');
        });
      }
      var imgs=feed.querySelectorAll('.eq-chat-img');
      for(var j=0;j<imgs.length;j++){ imgs[j].addEventListener('click', function(){ openPhotoViewer(this.getAttribute('data-full')); }); }
    }).catch(function(e){
      var feed=document.getElementById('eqChatFeed');
      if(feed) feed.innerHTML='<div class="eq-chat-empty">Erreur : '+esc(e.message)+'</div>';
    });
  }

  function chatDayLabel(d){
    var now=new Date();
    var today=now.toDateString(), yest=new Date(now.getTime()-86400000).toDateString();
    if(d.toDateString()===today) return "Aujourd'hui";
    if(d.toDateString()===yest) return "Hier";
    var months=['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
    return d.getDate()+' '+months[d.getMonth()];
  }

  function openPhotoViewer(url){
    var ov=document.createElement('div');
    ov.className='eq-photoviewer';
    ov.innerHTML='<img src="'+esc(url)+'" alt="Photo"><button class="eq-photoviewer-close" type="button">✕</button>';
    ov.addEventListener('click', function(){ document.body.removeChild(ov); });
    document.body.appendChild(ov);
  }

  function sendMessage(input){
    var txt=input.value.trim();
    if(!txt) return;
    var authorName=(PROFILE.full_name&&PROFILE.full_name.trim())?PROFILE.full_name:(USER.email?USER.email.split('@')[0]:'Membre');
    var body={ team_id:STATE.chatTeam, profile_id:USER.id, author_name:authorName, author_role:PROFILE.role, body:txt, staff_only:(STATE.chatChannel==='staff') };
    input.value=''; resetGrow(input);
    api('/rest/v1/messages',{ method:'POST', body:body, prefer:'return=minimal' })
    .then(function(){
      // Notifie les membres de la catégorie (sauf l'expéditeur).
      try{
        var teamNm='USV';
        for(var ti=0; ti<STATE.teams.length; ti++){
          if(STATE.teams[ti].id===STATE.chatTeam){ teamNm=STATE.teams[ti].name||'USV'; break; }
        }
        var preview=txt.length>90?txt.slice(0,90)+'…':txt;
        sendPush({ mode:'group_msg', team_ids:[STATE.chatTeam], staff_only:(STATE.chatChannel==='staff'),
          title:teamNm+' · '+authorName, body:preview }).catch(function(){});
      }catch(e){}
      loadChatFeed();
    })
    .catch(function(e){ alert('Erreur : '+e.message); input.value=txt; });
  }

  function sendPhotoMessage(file, btn){
    if(!file.type || file.type.indexOf('image/')!==0){ alert('Choisis une image.'); return; }
    var authorName=(PROFILE.full_name&&PROFILE.full_name.trim())?PROFILE.full_name:(USER.email?USER.email.split('@')[0]:'Membre');
    if(btn){ btn.disabled=true; btn.classList.add('eq-uploading'); }
    uploadChatPhoto(file).then(function(url){
      var body={ team_id:STATE.chatTeam, profile_id:USER.id, author_name:authorName, author_role:PROFILE.role, body:'', image_url:url, staff_only:(STATE.chatChannel==='staff') };
      return api('/rest/v1/messages',{ method:'POST', body:body, prefer:'return=minimal' });
    }).then(function(){
      if(btn){ btn.disabled=false; btn.classList.remove('eq-uploading'); }
      try{
        var teamNm='USV';
        for(var ti=0; ti<STATE.teams.length; ti++){
          if(STATE.teams[ti].id===STATE.chatTeam){ teamNm=STATE.teams[ti].name||'USV'; break; }
        }
        sendPush({ mode:'group_msg', team_ids:[STATE.chatTeam], staff_only:(STATE.chatChannel==='staff'),
          title:teamNm+' · '+authorName, body:'📷 Photo' }).catch(function(){});
      }catch(e){}
      loadChatFeed();
    }).catch(function(e){
      if(btn){ btn.disabled=false; btn.classList.remove('eq-uploading'); }
      alert('Erreur envoi photo : '+(e&&e.message?e.message:e));
    });
  }

  /* ---------- Modifier un message ---------- */
  // On édite dans la bulle elle-même : le contexte reste visible, et on
  // évite d'ouvrir une fenêtre pour corriger deux mots.
  function startEditMessage(id, current){
    var span=document.querySelector('.eq-chat-edit[data-edit="'+id+'"]');
    if(!span) return;
    var wrap=span.closest('.eq-chat-bubble-wrap');
    if(!wrap) return;
    var bubble=wrap.querySelector('.eq-chat-bubble');
    if(!bubble || bubble.getAttribute('data-editing')==='1') return;
    bubble.setAttribute('data-editing','1');

    var before=bubble.innerHTML;
    bubble.classList.add('eq-chat-editing');
    bubble.innerHTML=
      '<textarea class="eq-chat-input" rows="2" style="width:100%;color:inherit" maxlength="800"></textarea>'+
      '<div class="eq-chat-editbar">'+
        '<button class="eq-chat-editbtn ok" type="button">Enregistrer</button>'+
        '<button class="eq-chat-editbtn no" type="button">Annuler</button>'+
      '</div>';

    var ta=bubble.querySelector('textarea');
    ta.value=current;
    ta.focus();
    ta.setSelectionRange(ta.value.length, ta.value.length);
    autoGrow(ta);
    ta.addEventListener('input', function(){ autoGrow(this); });

    var btns=bubble.querySelectorAll('.eq-chat-editbtn');
    var cancel=function(){
      bubble.classList.remove('eq-chat-editing');
      bubble.removeAttribute('data-editing');
      bubble.innerHTML=before;
    };
    var save=function(){
      var txt=ta.value.trim();
      if(!txt){ ta.focus(); return; }
      if(txt===current){ cancel(); return; }
      btns[0].disabled=true;
      api('/rest/v1/messages?id=eq.'+id,{ method:'PATCH', body:{ body:txt } })
        .then(function(){
          bubble.removeAttribute('data-editing');
          loadChatFeed();   // même rechargement que la suppression
        })
        .catch(function(e){ btns[0].disabled=false; alert(e.message); });
    };
    btns[0].addEventListener('click', save);
    btns[1].addEventListener('click', cancel);
    ta.addEventListener('keydown', function(e){
      if(e.key==='Enter' && !e.shiftKey){ e.preventDefault(); save(); }
      if(e.key==='Escape'){ e.preventDefault(); cancel(); }
    });
  }

  /* Édition d'un message privé. Même geste que dans les catégories :
     la bulle se transforme en champ de saisie, sur place. */
  function startEditDM(id, current){
    var span=document.querySelector('.eq-chat-edit[data-dmedit="'+id+'"]');
    if(!span) return;
    var wrap=span.closest('.eq-chat-bubble-wrap'); if(!wrap) return;
    var bubble=wrap.querySelector('.eq-chat-bubble');
    if(!bubble || bubble.getAttribute('data-editing')==='1') return;
    bubble.setAttribute('data-editing','1');

    var before=bubble.innerHTML;
    bubble.classList.add('eq-chat-editing');
    bubble.innerHTML=
      '<textarea class="eq-chat-input" rows="2" style="width:100%;color:inherit" maxlength="800"></textarea>'+
      '<div class="eq-chat-editbar">'+
        '<button class="eq-chat-editbtn ok" type="button">Enregistrer</button>'+
        '<button class="eq-chat-editbtn no" type="button">Annuler</button>'+
      '</div>';

    var ta=bubble.querySelector('textarea');
    ta.value=current; ta.focus();
    ta.setSelectionRange(ta.value.length, ta.value.length);
    autoGrow(ta);
    ta.addEventListener('input', function(){ autoGrow(this); });

    var btns=bubble.querySelectorAll('.eq-chat-editbtn');
    var cancel=function(){
      bubble.classList.remove('eq-chat-editing');
      bubble.removeAttribute('data-editing');
      bubble.innerHTML=before;
    };
    var save=function(){
      var txt=ta.value.trim();
      if(!txt){ ta.focus(); return; }
      if(txt===current){ cancel(); return; }
      btns[0].disabled=true;
      dmEditMessage(id, txt)
        .then(function(){ bubble.removeAttribute('data-editing'); loadDMFeed(); })
        .catch(function(e){ btns[0].disabled=false; alert(e.message); });
    };
    btns[0].addEventListener('click', save);
    btns[1].addEventListener('click', cancel);
    ta.addEventListener('keydown', function(e){
      if(e.key==='Enter' && !e.shiftKey){ e.preventDefault(); save(); }
      if(e.key==='Escape'){ e.preventDefault(); cancel(); }
    });
  }

  function delDMMessage(id){
    if(!confirm('Supprimer ce message ?')) return;
    dmDeleteMessage(id)
      .then(function(){ loadDMFeed(); })
      .catch(function(e){ alert('Erreur : '+e.message); });
  }

  function delMessage(id){
    if(!confirm('Supprimer ce message ?')) return;
    api('/rest/v1/messages?id=eq.'+id,{ method:'DELETE', prefer:'return=minimal' })
    .then(function(){ loadChatFeed(); })
    .catch(function(e){ alert('Erreur : '+e.message); });
  }

  /* ---------- Gestion des membres du groupe (staff) ---------- */
  var GROUP_ROSTER=[];
  var GROUP_QUERY='';
  function openGroupModal(){
    var teamName=(STATE.teams.filter(function(t){return t.id===STATE.chatTeam;})[0]||{}).name||'';
    var m=document.createElement('div'); m.className='eq-modal'; m.id='eqGroupModal';
    m.innerHTML='<div class="eq-modal-ov" id="eqGroupOv"></div><div class="eq-modal-card">'+
      '<div class="eq-modal-grab"></div>'+
      '<div class="eq-modal-title">Membres du groupe '+esc(teamName)+'</div>'+
      '<div class="eq-search"><span class="eq-search-ic">'+IC.search+'</span><input class="eq-search-input" id="eqGroupSearch" type="text" placeholder="Rechercher une personne…"></div>'+
      '<div id="eqGroupList">'+loadingHTML()+'</div>'+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqGroupClose" style="margin-top:12px">Fermer</button>'+
      '</div>';
    document.querySelector('.eq-app').appendChild(m);
    document.getElementById('eqGroupOv').addEventListener('click', closeGroupModal);
    document.getElementById('eqGroupClose').addEventListener('click', closeGroupModal);
    GROUP_QUERY='';
    var s=document.getElementById('eqGroupSearch');
    s.addEventListener('input', function(){ GROUP_QUERY=this.value; paintGroupRoster(); });
    loadGroupRoster(STATE.chatTeam).then(function(roster){ GROUP_ROSTER=roster||[]; paintGroupRoster(); })
      .catch(function(e){ document.getElementById('eqGroupList').innerHTML='<div class="eq-empty"><div class="eq-empty-d">Erreur : '+esc(e.message)+'</div></div>'; });
  }
  function closeGroupModal(){ var m=document.getElementById('eqGroupModal'); if(m) m.parentNode.removeChild(m); }

  function paintGroupRoster(){
    var box=document.getElementById('eqGroupList');
    if(!box) return;
    var q=(GROUP_QUERY||'').toLowerCase().trim();
    var list=GROUP_ROSTER;
    if(q){ list=GROUP_ROSTER.filter(function(p){ var n=(p.member_name||'').toLowerCase(),e=(p.member_email||'').toLowerCase(); return n.indexOf(q)!==-1||e.indexOf(q)!==-1; }); }
    if(!list.length){ box.innerHTML='<div class="eq-empty"><div class="eq-empty-d">Aucun résultat.</div></div>'; return; }
    // membres du groupe en premier
    list = list.slice().sort(function(a,b){ return (b.in_group?1:0)-(a.in_group?1:0); });
    var html='';
    list.forEach(function(p){
      var dn=p.member_name&&p.member_name.trim()?p.member_name:p.member_email.split('@')[0];
      var staffTag = (p.member_role==='educateur'||p.member_role==='admin') ? '<span class="eq-roster-staff">'+IC.whistle+'</span>' : '';
      html+='<div class="eq-roster"><div class="eq-roster-l">'+
        '<div class="eq-roster-av">'+initials(dn)+'</div>'+
        '<div style="min-width:0"><div class="eq-roster-name">'+esc(dn)+staffTag+'</div><div class="eq-roster-email">'+esc(p.member_email)+'</div></div>'+
        '</div>';
      if(p.in_group){
        html+='<button type="button" class="eq-roster-btn out" data-out="'+p.member_id+'">Exclure</button>';
      } else {
        html+='<button type="button" class="eq-roster-btn in" data-in="'+p.member_id+'">Inviter</button>';
      }
      html+='</div>';
    });
    box.innerHTML=html;
    var ins=box.querySelectorAll('[data-in]'); for(var i=0;i<ins.length;i++){ ins[i].addEventListener('click', function(){ inviteToGroup(this.getAttribute('data-in')); }); }
    var outs=box.querySelectorAll('[data-out]'); for(var j=0;j<outs.length;j++){ outs[j].addEventListener('click', function(){ removeFromGroup(this.getAttribute('data-out')); }); }
  }

  function inviteToGroup(uid){
    api('/rest/v1/group_members',{ method:'POST', body:{ team_id:STATE.chatTeam, profile_id:uid, added_by:USER.id }, prefer:'return=minimal' })
    .then(function(){ for(var i=0;i<GROUP_ROSTER.length;i++){ if(GROUP_ROSTER[i].member_id===uid){ GROUP_ROSTER[i].in_group=true; break; } } paintGroupRoster(); })
    .catch(function(e){ alert('Erreur : '+e.message); });
  }
  function removeFromGroup(uid){
    api('/rest/v1/group_members?team_id=eq.'+STATE.chatTeam+'&profile_id=eq.'+uid,{ method:'DELETE', prefer:'return=minimal' })
    .then(function(){ for(var i=0;i<GROUP_ROSTER.length;i++){ if(GROUP_ROSTER[i].member_id===uid){ GROUP_ROSTER[i].in_group=false; break; } } paintGroupRoster(); })
    .catch(function(e){ alert('Erreur : '+e.message); });
  }

  // Construit la liste nominative groupée par statut
  /* Nom complet d'un enfant. La table attendances ne porte que
     child_name (le nom de famille) : le prénom vit dans team_members.
     On les rapproche, comme le fait déjà la composition d'équipe. */
  function nomComplet(prenom, nom){
    // Les espaces en trop viennent des saisies : « Lou  » + «  Majal »
    // donnerait trois espaces au milieu si on se contentait de trim().
    var t=((prenom||'')+' '+(nom||'')).replace(/\s+/g,' ').trim();
    return t || (nom||'').trim() || '—';
  }

  function presenceList(ea, noResp, membres){
    membres = membres || [];
    var prenomDe = function(profileId, childName){
      var m = membres.filter(function(x){
        return x.profile_id===profileId && x.child_name===childName;
      })[0];
      return m ? (m.child_first_name||'') : '';
    };
    var groups=[
      { key:'present', label:'Présents', cls:'st-present', ic:IC.check },
      { key:'peut_etre', label:'Peut-être', cls:'st-maybe', ic:IC.help },
      { key:'absent', label:'Absents', cls:'st-absent', ic:IC.cross }
    ];
    var html='';
    groups.forEach(function(g){
      var rows=ea.filter(function(a){return a.status===g.key;});
      if(!rows.length) return;
      html+='<div class="eq-pres-group"><div class="eq-pres-gt '+g.cls+'">'+g.ic+' '+g.label+' · '+rows.length+'</div>';
      rows.forEach(function(a){
        var nc=nomComplet(a.child_first_name || prenomDe(a.profile_id, a.child_name), a.child_name);
        html+='<div class="eq-pres-row"><span class="eq-pres-av">'+initials(nc)+'</span><span class="eq-pres-name">'+esc(nc)+'</span></div>';
      });
      html+='</div>';
    });
    if(noResp.length){
      html+='<div class="eq-pres-group"><div class="eq-pres-gt st-none">'+IC.dots+' Pas encore répondu · '+noResp.length+'</div>';
      noResp.forEach(function(n){
        html+='<div class="eq-pres-row eq-pres-row-faint"><span class="eq-pres-av">'+initials(n)+'</span><span class="eq-pres-name">'+esc(n)+'</span></div>';
      });
      html+='</div>';
    }
    if(!html) html='<div class="eq-pres-empty">Personne n\'a encore répondu.</div>';
    return html;
  }

  function vote(eventId,childName,status,row,ownerId){
    var pid = ownerId || USER.id; // enfant lié -> on écrit sur le parent principal (vote partagé)
    var body={ event_id:eventId, profile_id:pid, child_name:childName, status:status, updated_at:new Date().toISOString() };
    // feedback immédiat sur les boutons
    var bs=row.querySelectorAll('button');
    for(var k=0;k<bs.length;k++){ var s=bs[k].getAttribute('data-st'); bs[k].className=(s===status)?(s==='present'?'on-present':(s==='absent'?'on-absent':'on-maybe')):''; }
    api('/rest/v1/attendances?on_conflict=event_id,profile_id,child_name',{ method:'POST', body:body, prefer:'resolution=merge-duplicates,return=minimal' })
    .then(function(){ renderCalendar(); })
    .catch(function(e){ alert('Erreur : '+e.message); });
  }

  /* ============================================================
     ÉQUIPES / MES ENFANTS (parent)
     ============================================================ */
  function renderTeams(){
    var body=document.getElementById('eqBody');
    var staff=(PROFILE.role==='educateur'||PROFILE.role==='admin');
    var staffBtn = staff ? '<button type="button" class="eq-btn eq-btn-ghost" id="eqRoster" style="margin-top:10px">'+IC.users+' Liste des enfants du club</button>'+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqStats" style="margin-top:10px">'+IC.chart+' Stats de présence</button>' : '';
    body.innerHTML='<div class="eq-h"><div class="eq-h-title">Mes enfants</div></div>'+
      '<div class="eq-h-sub">Inscris tes enfants au club. Chaque demande est validée par un éducateur avant d\'être active.</div>'+
      '<button type="button" class="eq-btn" id="eqAddChild">+ Inscrire mon enfant</button>'+
      staffBtn+
      '<div id="eqChildren" style="margin-top:20px"></div>';
    document.getElementById('eqAddChild').addEventListener('click', openSignupModal);
    var rb=document.getElementById('eqRoster');
    if(rb) rb.addEventListener('click', openRosterModal);
    var sb=document.getElementById('eqStats');
    if(sb) sb.addEventListener('click', openStatsModal);
    renderChildren();
  }

  function renderChildren(){
    var box=document.getElementById('eqChildren'); if(!box) return;
    if(!STATE.myTeams.length){
      box.innerHTML='<div class="eq-empty"><div class="eq-empty-ic">🏉</div><div class="eq-empty-t">Aucun enfant inscrit</div><div class="eq-empty-d">Clique sur « Inscrire mon enfant » pour commencer.</div></div>';
      return;
    }
    var html='';
    STATE.myTeams.forEach(function(tm){
      var team=STATE.teams.filter(function(t){return t.id===tm.team_id;})[0];
      var fullName=((tm.child_first_name||'')+' '+(tm.child_name||'')).trim()||'(enfant)';
      var statusTag='';
      if(tm.status==='en_attente') statusTag='<span class="eq-status-tag pending">⏳ En attente</span>';
      else if(tm.status==='refuse') statusTag='<span class="eq-status-tag refused">✕ Refusé</span>';
      else statusTag='<span class="eq-status-tag valid">✓ Validé</span>';
      html+='<div class="eq-child"><div class="eq-child-info">'+
        '<div class="eq-child-av">'+initials(fullName)+'</div>'+
        '<div style="min-width:0"><div class="eq-child-name">'+esc(fullName)+'</div><div class="eq-child-team">'+esc(team?team.name:'')+' · '+statusTag+'</div></div>'+
        '</div><button type="button" class="eq-btn eq-btn-ghost eq-btn-sm" data-rm="'+tm.id+'">Retirer</button></div>';
    });
    box.innerHTML=html;
    var rm=box.querySelectorAll('[data-rm]');
    for(var i=0;i<rm.length;i++){ rm[i].addEventListener('click', function(){ removeChild(this.getAttribute('data-rm')); }); }
  }

  /* ---------- Annuaire des enfants par catégorie (staff) ---------- */
  var ROSTER_DATA=[];
  var ROSTER_QUERY='';
  function openRosterModal(){
    var m=document.createElement('div'); m.className='eq-modal'; m.id='eqRosterModal';
    m.innerHTML='<div class="eq-modal-ov" id="eqRosterOv"></div><div class="eq-modal-card">'+
      '<div class="eq-modal-grab"></div>'+
      '<div class="eq-modal-title">Enfants du club</div>'+
      '<div class="eq-search"><span class="eq-search-ic">'+IC.search+'</span><input class="eq-search-input" id="eqRosterSearch" type="text" placeholder="Rechercher un enfant, un parent…"></div>'+
      '<div id="eqRosterList">'+loadingHTML()+'</div>'+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqRosterClose" style="margin-top:12px">Fermer</button>'+
      '</div>';
    document.querySelector('.eq-app').appendChild(m);
    document.getElementById('eqRosterOv').addEventListener('click', closeRosterModal);
    document.getElementById('eqRosterClose').addEventListener('click', closeRosterModal);
    ROSTER_QUERY='';
    document.getElementById('eqRosterSearch').addEventListener('input', function(){ ROSTER_QUERY=this.value; paintRoster(); });
    api('/rest/v1/rpc/roster_children',{ method:'POST', body:{} }).then(function(rows){
      ROSTER_DATA=rows||[]; paintRoster();
    }).catch(function(e){ document.getElementById('eqRosterList').innerHTML='<div class="eq-empty"><div class="eq-empty-d">Erreur : '+esc(e.message)+'</div></div>'; });
  }
  /* ---------- Modification d'une fiche enfant (admin) ---------- */
  /* Cherche un enfant déjà enregistré sous les mêmes nom et prénom.
     On ne bloque jamais : deux cousins homonymes existent, et un
     blocage sec obligerait à contourner l'outil. On montre ce qui
     existe, l'utilisateur tranche. */
  // Câblage des boutons de rattachement, après affichage de l'avertissement.
  function bindLinkButtons(scope){
    var bs=(scope||document).querySelectorAll('[data-linkreq]');
    for(var i=0;i<bs.length;i++){
      bs[i].addEventListener('click', function(){
        askChildLink(this.getAttribute('data-linkreq'), this.getAttribute('data-linkname'));
      });
    }
  }

  function checkDuplicate(first, last, birth, excludeId){
    if(!first || !last) return Promise.resolve([]);
    return api('/rest/v1/rpc/find_child_duplicates',{ method:'POST', body:{
      p_first:first, p_last:last, p_birth:birth||null, p_exclude:excludeId||null
    }}).catch(function(){ return []; });
  }

  /* Demande de rattachement. Le cas des parents séparés : le second
     parent voit que l'enfant existe déjà, mais n'a aujourd'hui que le
     choix de créer un doublon ou d'abandonner. */
  function askChildLink(memberId, label){
    var msg = prompt('Demander à être rattaché à ' + (label||'cet enfant') + ' ?\n\n' +
      'Ta demande sera transmise au club, qui vérifiera avant de valider.\n\n' +
      'Tu peux préciser qui tu es (facultatif) :', '');
    if(msg === null) return;
    api('/rest/v1/rpc/request_child_link',{ method:'POST',
      body:{ p_member_id:memberId, p_message:msg || null } })
      .then(function(r){
        var e = (r && r.enfant) ? r.enfant : (label||'cet enfant');
        alert('Demande envoyée pour ' + e + '.\n\n' +
              'Le club va la vérifier. Tu recevras l\'accès dès qu\'elle sera validée.');
        try{
          sendPush({ mode:'signup',
                     title:'Demande de rattachement',
                     body:'Un parent demande à être rattaché à ' + e });
        }catch(x){}
      })
      .catch(function(e){ alert(e.message); });
  }

  function duplicateWarningHTML(rows){
    if(!rows || !rows.length) return '';
    var exact=rows.filter(function(r){ return r.same_birthdate; });
    var titre = exact.length
      ? 'Cet enfant est déjà inscrit'
      : (rows.length>1 ? 'Des enfants portent déjà ce nom'
                       : 'Un enfant porte déjà ce nom');
    var h='<div class="eq-dup"><div class="eq-dup-t">⚠️ '+titre+'</div>';
    rows.forEach(function(r){
      var d=(r.child_birthdate||'').slice(0,10).split('-').reverse().join('/');
      var nomComplet=((r.child_first_name||'')+' '+(r.child_name||'')).trim();
      h+='<div class="eq-dup-row">'+
         '<b>'+esc(nomComplet)+'</b>'+
         '<span>'+esc(r.team_name||'sans catégorie')+
         (d?' · né(e) le '+d:'')+
         (r.archived?' · archivé':'')+
         (r.status==='en_attente'?' · en attente':'')+
         '</span>'+
         (r.same_birthdate?'<em>même date de naissance</em>':'')+
         // Sortie n°2 pour un parent séparé : ce n'est pas un doublon,
         // c'est son enfant, et il demande l'accès.
         (r.archived ? '' :
           '<button type="button" class="eq-btn eq-btn-ghost eq-btn-sm eq-dup-link" '+
           'data-linkreq="'+r.id+'" data-linkname="'+esc(nomComplet)+'">'+
           'C\'est mon enfant, demander l\'accès</button>')+
         '</div>';
    });
    h+='<div class="eq-dup-f">'+(exact.length
        ? 'Même nom et même date de naissance : c\'est très probablement la même personne.'
        : 'Vérifie qu\'il ne s\'agit pas de la même personne avant de continuer.')+
       '</div></div>';
    return h;
  }

  function openChildEdit(row){
    var full=((row.child_first_name||'')+' '+(row.child_name||'')).trim();
    var opts=STATE.teams.map(function(t){
      return '<option value="'+t.id+'"'+(String(t.id)===String(row.team_id)?' selected':'')+'>'+esc(t.name)+'</option>';
    }).join('');
    var g=row.child_gender||'';
    var m=document.createElement('div'); m.className='eq-modal'; m.id='eqChildEdit';
    m.innerHTML='<div class="eq-modal-ov" id="eqCeOv"></div><div class="eq-modal-card">'+
      '<div class="eq-modal-grab"></div>'+
      '<div class="eq-modal-title">Modifier la fiche</div>'+
      '<div class="eq-modal-sub">'+esc(full||'Enfant')+'</div>'+
      '<div id="eqCeMsg"></div>'+
      '<div class="eq-field"><label>Prénom</label><input class="eq-input" id="eqCeFirst" type="text" value="'+esc(row.child_first_name||'')+'"></div>'+
      '<div class="eq-field"><label>Nom</label><input class="eq-input" id="eqCeLast" type="text" value="'+esc(row.child_name||'')+'"></div>'+
      '<div class="eq-field"><label>Date de naissance</label><input class="eq-input" id="eqCeBirth" type="date" value="'+esc((row.child_birthdate||'').slice(0,10))+'"></div>'+
      '<div class="eq-field"><label>Genre</label><select class="eq-input" id="eqCeGender">'+
        '<option value=""'+(g===''?' selected':'')+'>— À préciser —</option>'+
        '<option value="M"'+(g==='M'?' selected':'')+'>Garçon</option>'+
        '<option value="F"'+(g==='F'?' selected':'')+'>Fille</option>'+
      '</select></div>'+
      '<div class="eq-field"><label>Catégorie</label><select class="eq-input" id="eqCeTeam">'+opts+'</select>'+
        '<div id="eqCeHint"></div></div>'+
      '<div class="eq-field"><label>Téléphone du responsable</label><input class="eq-input" id="eqCePhone" type="tel" value="'+esc(row.parent_phone||'')+'"></div>'+
      '<div id="eqCeDup"></div>'+
      '<button type="button" class="eq-btn" id="eqCeSave">Enregistrer</button>'+
      (PROFILE.role==='admin' ? (row.archived_at
        ? '<button type="button" class="eq-btn eq-btn-ghost" id="eqCeRestore" style="margin-top:10px">Réactiver cet enfant</button>'
        : '<button type="button" class="eq-btn eq-btn-ghost eq-btn-danger" id="eqCeArchive" style="margin-top:10px">Archiver cet enfant</button>') : '')+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqCeCancel" style="margin-top:10px">Annuler</button>'+
      '</div>';
    document.querySelector('.eq-app').appendChild(m);

    var close=function(){ var x=document.getElementById('eqChildEdit'); if(x) x.parentNode.removeChild(x); };
    document.getElementById('eqCeOv').addEventListener('click', close);
    document.getElementById('eqCeCancel').addEventListener('click', close);

    // Rappelle la catégorie théorique sans jamais l'imposer : un admin
    // déplace parfois un enfant volontairement (niveau, effectif, fratrie).
    var hint=function(){
      var t=suggestTeam(document.getElementById('eqCeBirth').value,
                        document.getElementById('eqCeGender').value);
      var box=document.getElementById('eqCeHint');
      var cur=document.getElementById('eqCeTeam').value;
      if(!box) return;
      if(!t){ box.innerHTML=''; return; }
      box.innerHTML = (String(t.id)===String(cur))
        ? '<span class="eq-suggest">Catégorie conforme à l\'âge : <b>'+esc(t.name)+'</b></span>'
        : '<span class="eq-suggest eq-suggest-none">D\'après l\'âge, ce serait <b>'+esc(t.name)+'</b>. Le choix manuel est conservé.</span>';
    };
    document.getElementById('eqCeBirth').addEventListener('change', hint);
    document.getElementById('eqCeGender').addEventListener('change', hint);
    document.getElementById('eqCeTeam').addEventListener('change', hint);
    hint();

    document.getElementById('eqCeSave').addEventListener('click', function(){
      var first=document.getElementById('eqCeFirst').value.trim();
      var last=document.getElementById('eqCeLast').value.trim();
      var birth=document.getElementById('eqCeBirth').value;
      var team=document.getElementById('eqCeTeam').value;
      var msg=document.getElementById('eqCeMsg');
      var fail=function(t){ msg.innerHTML='<div class="eq-msg eq-msg-err"><span class="eq-msg-ic">⚠️</span><span>'+t+'</span></div>'; };
      if(!first||!last){ fail('Le prénom et le nom sont nécessaires.'); return; }
      if(!birth){ fail('La date de naissance est nécessaire.'); return; }
      if(!team){ fail('Choisis une catégorie.'); return; }
      var btn=this; btn.disabled=true;
      // Contrôle de doublon avant enregistrement, hors de la fiche
      // en cours d'édition elle-même.
      checkDuplicate(first, last, birth, row.id).then(function(dups){
        var box=document.getElementById('eqCeDup');
        if(dups && dups.length && !box.getAttribute('data-ack')){
          box.innerHTML=duplicateWarningHTML(dups)+
            '<button type="button" class="eq-btn eq-btn-ghost" id="eqCeForce" '+
            'style="margin-top:8px">Ce n\'est pas la même personne, enregistrer</button>';
          box.setAttribute('data-ack','1');
          bindLinkButtons(box);
          document.getElementById('eqCeForce').addEventListener('click', function(){
            document.getElementById('eqCeSave').click();
          });
          btn.disabled=false;
          box.scrollIntoView({behavior:'smooth', block:'nearest'});
          return;
        }
        saveChild();
      });

      function saveChild(){
      api('/rest/v1/team_members?id=eq.'+row.id,{ method:'PATCH', prefer:'return=minimal',
        body:{ child_first_name:first, child_name:last, child_birthdate:birth,
               child_gender:document.getElementById('eqCeGender').value||null,
               team_id:team, parent_phone:document.getElementById('eqCePhone').value.trim()||null } })
        .then(function(){
          close();
          return api('/rest/v1/rpc/roster_children',{ method:'POST', body:{} });
        })
        .then(function(rows){ ROSTER_DATA=rows||[]; paintRoster(); })
        .catch(function(e){ btn.disabled=false; fail(e.message); });
      }
    });

    // ── Archivage ──
    var arBtn=document.getElementById('eqCeArchive');
    if(arBtn) arBtn.addEventListener('click', function(){
      var motifs=[['arret','Arrêt du rugby'],['sans_licence','Licence non régularisée'],
                  ['depart','Départ du club'],['doublon','Doublon de saisie'],
                  ['autre','Autre']];
      var txt='Archiver '+(full||'cet enfant')+' ?\n\n'+
        'Il sort des listes, des convocations et des effectifs, mais son '+
        'historique est conservé et tu pourras le réactiver.\n\nMotif :\n'+
        motifs.map(function(m,i){ return (i+1)+' — '+m[1]; }).join('\n')+
        '\n\nTape le numéro du motif :';
      var rep=prompt(txt, '1');
      if(rep===null) return;
      var idx=parseInt(rep,10)-1;
      var motif=(motifs[idx]||motifs[4])[0];
      var b=this; b.disabled=true; b.textContent='Archivage…';
      api('/rest/v1/rpc/archive_child',{ method:'POST', body:{ p_id:row.id, p_reason:motif } })
        .then(function(){ close(); return api('/rest/v1/rpc/roster_children',{ method:'POST', body:{} }); })
        .then(function(rows){ ROSTER_DATA=rows||[]; paintRoster(); })
        .catch(function(e){ b.disabled=false; b.textContent='Archiver cet enfant'; fail(e.message); });
    });

    // ── Réactivation ──
    var reBtn=document.getElementById('eqCeRestore');
    if(reBtn) reBtn.addEventListener('click', function(){
      var b=this; b.disabled=true; b.textContent='Réactivation…';
      api('/rest/v1/rpc/restore_child',{ method:'POST', body:{ p_id:row.id } })
        .then(function(){ close(); return api('/rest/v1/rpc/roster_children',{ method:'POST', body:{} }); })
        .then(function(rows){ ROSTER_DATA=rows||[]; paintRoster(); })
        .catch(function(e){ b.disabled=false; b.textContent='Réactiver cet enfant'; fail(e.message); });
    });
  }

  function closeRosterModal(){ var m=document.getElementById('eqRosterModal'); if(m) m.parentNode.removeChild(m); }

  function paintRoster(){
    var box=document.getElementById('eqRosterList'); if(!box) return;
    var q=(ROSTER_QUERY||'').toLowerCase().trim();
    var rows=ROSTER_DATA;
    if(q){
      rows=ROSTER_DATA.filter(function(r){
        var hay=((r.child_first_name||'')+' '+(r.child_name||'')+' '+(r.parent_name||'')+' '+(r.parent_email||'')+' '+(r.parent_phone||'')).toLowerCase();
        return hay.indexOf(q)!==-1;
      });
    }
    if(!rows.length){
      box.innerHTML='<div class="eq-empty"><div class="eq-empty-ic">🔍</div><div class="eq-empty-t">Aucun enfant</div><div class="eq-empty-d">'+(q?'Aucun résultat pour cette recherche.':'Aucun enfant validé pour le moment.')+'</div></div>';
      return;
    }
    // groupe par catégorie
    var groups={}; var order=[];
    rows.forEach(function(r){ if(!groups[r.team_name]){ groups[r.team_name]=[]; order.push(r.team_name); } groups[r.team_name].push(r); });
    var html='';
    order.forEach(function(tn){
      var list=groups[tn];
      html+='<div class="eq-roster-cat"><span>'+esc(tn)+'</span><span class="eq-roster-count">'+list.length+'</span></div>';
      list.forEach(function(r){
        var full=((r.child_first_name||'')+' '+(r.child_name||'')).trim()||'(enfant)';
        var age='';
        if(r.child_birthdate){ var a=Math.floor((Date.now()-new Date(r.child_birthdate).getTime())/31557600000); age=a+' ans'; }
        var phone=r.parent_phone||'';
        html+='<div class="eq-rc">'+
          '<div class="eq-rc-top"><div class="eq-roster-av">'+initials(full)+'</div>'+
          '<div style="min-width:0;flex:1"><div class="eq-rc-name">'+esc(full)+(age?' <span class="eq-rc-age">· '+age+'</span>':'')+'</div>'+
          '<div class="eq-rc-parent">'+esc(r.parent_name||r.parent_email||'')+'</div></div></div>';
        if(phone){
          html+='<a class="eq-rc-call" href="tel:'+esc(phone.replace(/\s/g,''))+'">'+IC.phone+' '+esc(phone)+'</a>';
        }
        if(r.second_parents){
          html+='<div class="eq-rc-2nd">'+IC.users+' 2e parent : '+esc(r.second_parents)+'</div>';
        }
        html+='<button class="eq-rc-addparent" data-owner="'+r.owner_id+'" data-child="'+esc(r.child_name||'')+'" data-team="'+r.team_id+'" data-name="'+esc(full)+'" type="button">+ Ajouter un 2e parent</button>';
        // La modification de la fiche est réservée aux administrateurs :
        // changer d'équipe ou corriger une date engage l'effectif du club.
        if(PROFILE.role==='admin'){
          html+='<button class="eq-rc-edit" data-edit="'+r.id+'" type="button">'+IC.edit+' Modifier la fiche</button>';
        }
        html+='</div>';
      });
    });
    box.innerHTML=html;
    // handlers boutons 2e parent
    var eds=box.querySelectorAll('.eq-rc-edit');
    for(var e2=0;e2<eds.length;e2++){
      eds[e2].addEventListener('click', function(){
        var id=this.getAttribute('data-edit');
        var row=ROSTER_DATA.filter(function(x){ return String(x.id)===String(id); })[0];
        if(row) openChildEdit(row);
      });
    }
    var aps=box.querySelectorAll('.eq-rc-addparent');
    for(var i=0;i<aps.length;i++){
      aps[i].addEventListener('click', function(){
        linkSecondParent(this.getAttribute('data-owner'), this.getAttribute('data-child'), this.getAttribute('data-team'), this.getAttribute('data-name'));
      });
    }
  }

  function linkSecondParent(ownerId, childName, teamId, childLabel){
    var email=prompt('Rattacher un 2e parent à '+childLabel+'.\n\nEntre l\'adresse email du compte du 2e parent (il doit déjà avoir un compte cashless USV) :');
    if(!email) return;
    email=email.trim(); if(!email) return;
    api('/rest/v1/rpc/link_second_parent',{ method:'POST', body:{ p_owner_id:ownerId, p_child_name:childName, p_team_id:teamId, p_email:email } })
    .then(function(res){
      var code=(typeof res==='string')?res:(res&&res[0]?res[0]:res);
      if(code==='OK'){ alert('2e parent rattaché ! 👨‍👩‍👧 Il verra l\'enfant et recevra les convocations.'); ROSTER_QUERY=ROSTER_QUERY; // refresh
        api('/rest/v1/rpc/roster_children',{ method:'POST', body:{} }).then(function(rows){ ROSTER_DATA=rows||[]; paintRoster(); }); }
      else if(code==='NOT_FOUND'){ alert('Aucun compte trouvé avec cet email. Le 2e parent doit d\'abord créer son compte (identifiants cashless USV), puis tu pourras le rattacher.'); }
      else if(code==='SAME_AS_OWNER'){ alert('C\'est déjà le parent principal de cet enfant.'); }
      else { alert('Rattachement effectué.'); }
    })
    .catch(function(e){ alert('Erreur : '+(e&&e.message?e.message:e)); });
  }

  /* ---------- Stats de présence par enfant (staff) ---------- */
  var STATS_DATA=[];
  var STATS_QUERY='';
  function openStatsModal(){
    var m=document.createElement('div'); m.className='eq-modal'; m.id='eqStatsModal';
    m.innerHTML='<div class="eq-modal-ov" id="eqStatsOv"></div><div class="eq-modal-card">'+
      '<div class="eq-modal-grab"></div>'+
      '<div class="eq-modal-title">Assiduité de la saison</div>'+
      '<div class="eq-h-sub" style="margin:0 0 6px">Taux de présence : nombre de fois « présent » sur le nombre de fois où le parent a répondu.</div>'+
      '<div class="eq-search"><span class="eq-search-ic">'+IC.search+'</span><input class="eq-search-input" id="eqStatsSearch" type="text" placeholder="Rechercher un enfant…"></div>'+
      '<div id="eqStatsList">'+loadingHTML()+'</div>'+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqStatsClose" style="margin-top:12px">Fermer</button>'+
      '</div>';
    document.querySelector('.eq-app').appendChild(m);
    document.getElementById('eqStatsOv').addEventListener('click', closeStatsModal);
    document.getElementById('eqStatsClose').addEventListener('click', closeStatsModal);
    STATS_QUERY='';
    document.getElementById('eqStatsSearch').addEventListener('input', function(){ STATS_QUERY=this.value; paintStats(); });
    api('/rest/v1/rpc/attendance_stats',{ method:'POST', body:{} }).then(function(rows){
      STATS_DATA=rows||[]; paintStats();
    }).catch(function(e){ document.getElementById('eqStatsList').innerHTML='<div class="eq-empty"><div class="eq-empty-d">Erreur : '+esc(e.message)+'</div></div>'; });
  }
  function closeStatsModal(){ var m=document.getElementById('eqStatsModal'); if(m) m.parentNode.removeChild(m); }

  function paintStats(){
    var box=document.getElementById('eqStatsList'); if(!box) return;
    var q=(STATS_QUERY||'').toLowerCase().trim();
    var rows=STATS_DATA;
    if(q){
      rows=STATS_DATA.filter(function(r){
        var hay=((r.child_first_name||'')+' '+(r.child_name||'')).toLowerCase();
        return hay.indexOf(q)!==-1;
      });
    }
    if(!rows.length){
      box.innerHTML='<div class="eq-empty"><div class="eq-empty-ic">📊</div><div class="eq-empty-t">Aucune donnée</div><div class="eq-empty-d">'+(q?'Aucun résultat pour cette recherche.':'Aucun enfant validé pour le moment.')+'</div></div>';
      return;
    }
    // groupe par catégorie
    var groups={}; var order=[];
    rows.forEach(function(r){ if(!groups[r.team_name]){ groups[r.team_name]=[]; order.push(r.team_name); } groups[r.team_name].push(r); });
    var html='';
    order.forEach(function(tn){
      var list=groups[tn];
      html+='<div class="eq-roster-cat"><span>'+esc(tn)+'</span><span class="eq-roster-count">'+list.length+'</span></div>';
      list.forEach(function(r){
        var full=((r.child_first_name||'')+' '+(r.child_name||'')).trim()||'(enfant)';
        var replied=r.replied||0, present=r.present||0;
        var pct = replied>0 ? Math.round(present/replied*100) : null;
        var barCls = pct===null ? '' : (pct>=75?'hi':(pct>=50?'mid':'lo'));
        var pctLabel = pct===null ? '—' : pct+'%';
        html+='<div class="eq-stat">'+
          '<div class="eq-stat-top"><span class="eq-stat-name">'+esc(full)+'</span><span class="eq-stat-pct '+barCls+'">'+pctLabel+'</span></div>'+
          '<div class="eq-stat-bar"><span class="eq-stat-fill '+barCls+'" style="width:'+(pct===null?0:pct)+'%"></span></div>'+
          '<div class="eq-stat-detail">'+present+' présence'+(present>1?'s':'')+' sur '+replied+' réponse'+(replied>1?'s':'')+(replied===0?' — pas encore de données':'')+'</div>'+
          '</div>';
      });
    });
    box.innerHTML=html;
  }

  /* ---------- Catégorie déduite de la date de naissance ---------- */
  // La règle vit dans la table teams (birth_year_min / birth_year_max) :
  // le club peut la modifier sans toucher au code.
  function suggestTeam(birthISO, gender){
    if(!birthISO) return null;
    var y=parseInt(String(birthISO).slice(0,4),10);
    if(!y) return null;
    var ok=STATE.teams.filter(function(t){
      // Une catégorie réservée à un genre n'est jamais proposée à l'autre :
      // c'est ce qui envoie une fille née en 2012 en M14F15 et un garçon
      // de la même année en M16.
      if(gender==='F' && t.gender==='M') return false;
      if(gender==='M' && t.gender==='F') return false;

      // Certaines catégories accordent une année de plus aux filles
      // (M14F15 : 2012 à 2014). On applique alors les bornes dédiées.
      var lo=t.birth_year_min, hi=t.birth_year_max;
      if(gender==='F' && t.birth_year_min_f && t.birth_year_max_f){
        lo=t.birth_year_min_f; hi=t.birth_year_max_f;
      }
      if(!lo || !hi) return false;
      if(y<lo || y>hi) return false;
      // Les Baby sont bornés à une date précise (31 août) et non à
      // l'année entière : un enfant né en septembre est trop jeune.
      if(t.birth_date_max && String(birthISO) > String(t.birth_date_max)) return false;
      return true;
    });
    if(!ok.length) return null;
    // Priorité à une équipe explicitement féminine si elle existe.
    if(gender==='F'){
      var f=ok.filter(function(t){ return t.gender==='F'; });
      if(f.length) return f[0];
    }
    return ok[0];
  }

  function applySuggestion(){
    var b=document.getElementById('eqSuBirth');
    var g=document.getElementById('eqSuGender');
    var sel=document.getElementById('eqSuTeam');
    var hint=document.getElementById('eqSuHint');
    if(!b||!sel) return;
    var t=suggestTeam(b.value, g?g.value:'');
    if(t){
      // On ne réécrit pas un choix fait à la main.
      if(!sel.getAttribute('data-touched')) sel.value=t.id;
      if(hint) hint.innerHTML='<span class="eq-suggest">Catégorie proposée : <b>'+esc(t.name)+'</b>'+
        (sel.value===t.id?'':' — vous avez choisi une autre catégorie')+'</span>';
    } else if(hint && b.value){
      hint.innerHTML='<span class="eq-suggest eq-suggest-none">Aucune catégorie ne correspond à cette année de naissance, choisis-la manuellement.</span>';
    } else if(hint){ hint.innerHTML=''; }
  }

  function openSignupModal(){
    var opts='<option value="">— Choisir la catégorie —</option>'+STATE.teams.map(function(t){ return '<option value="'+t.id+'">'+esc(t.name)+'</option>'; }).join('');
    var m=document.createElement('div'); m.className='eq-modal'; m.id='eqSignupModal';
    m.innerHTML='<div class="eq-modal-ov" id="eqSignupOv"></div><div class="eq-modal-card">'+
      '<div class="eq-modal-grab"></div>'+
      '<div class="eq-modal-title">Inscrire mon enfant</div>'+
      '<div id="eqSignupMsg"></div>'+
      '<div class="eq-field"><label>Prénom de l\'enfant</label><input class="eq-input" id="eqSuFirst" type="text" placeholder="Ex: Lucas"></div>'+
      '<div class="eq-field"><label>Nom de l\'enfant</label><input class="eq-input" id="eqSuLast" type="text" placeholder="Ex: Martin"></div>'+
      '<div class="eq-field"><label>Date de naissance</label><input class="eq-input" id="eqSuBirth" type="date"></div>'+
      '<div class="eq-field"><label>Genre</label><select class="eq-input" id="eqSuGender">'+
        '<option value="">— À préciser —</option>'+
        '<option value="M">Garçon</option>'+
        '<option value="F">Fille</option>'+
      '</select></div>'+
      '<div class="eq-field"><label>Catégorie</label><select class="eq-input" id="eqSuTeam">'+opts+'</select>'+
        '<div id="eqSuHint"></div></div>'+
      '<div class="eq-field"><label>Téléphone du responsable</label><input class="eq-input" id="eqSuPhone" type="tel" placeholder="06 12 34 56 78"></div>'+
      '<button type="button" class="eq-btn" id="eqSuSave">Envoyer la demande</button>'+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqSuCancel" style="margin-top:10px">Annuler</button>'+
      '</div>';
    document.querySelector('.eq-app').appendChild(m);
    document.getElementById('eqSignupOv').addEventListener('click', closeSignupModal);
    document.getElementById('eqSuCancel').addEventListener('click', closeSignupModal);
    document.getElementById('eqSuSave').addEventListener('click', submitSignup);
    // La catégorie se met à jour dès que la date ou le genre change.
    var bEl=document.getElementById('eqSuBirth');
    var gEl=document.getElementById('eqSuGender');
    var tEl=document.getElementById('eqSuTeam');
    if(bEl) bEl.addEventListener('change', applySuggestion);
    if(gEl) gEl.addEventListener('change', applySuggestion);
    // Dès que le parent choisit lui-même, on cesse d'imposer la proposition.
    if(tEl) tEl.addEventListener('change', function(){
      this.setAttribute('data-touched','1'); applySuggestion();
    });
  }
  function closeSignupModal(){ var m=document.getElementById('eqSignupModal'); if(m) m.parentNode.removeChild(m); }

  function submitSignup(){
    var first=document.getElementById('eqSuFirst').value.trim();
    var last=document.getElementById('eqSuLast').value.trim();
    var birth=document.getElementById('eqSuBirth').value;
    var team=document.getElementById('eqSuTeam').value;
    var phone=document.getElementById('eqSuPhone').value.trim();
    var msg=document.getElementById('eqSignupMsg');
    function err(t){ msg.innerHTML='<div class="eq-msg eq-msg-err"><span class="eq-msg-ic">⚠️</span><span>'+t+'</span></div>'; }
    if(!first){ err('Indique le prénom de l\'enfant.'); return; }
    if(!last){ err('Indique le nom de l\'enfant.'); return; }
    if(!birth){ err('Indique la date de naissance.'); return; }
    if(!team){ err('Choisis une catégorie.'); return; }
    if(!phone){ err('Indique un téléphone de responsable.'); return; }
    var genderEl=document.getElementById('eqSuGender');
    var body={ team_id:team, profile_id:USER.id, child_first_name:first, child_name:last,
      child_birthdate:birth, child_gender:(genderEl&&genderEl.value)||null,
      parent_phone:phone, status:'en_attente', created_at_req:new Date().toISOString() };
    var btn=document.getElementById('eqSuSave'); btn.disabled=true;

    // Contrôle de doublon avant envoi : mieux vaut prévenir le parent
    // maintenant que faire trancher un admin trois jours plus tard.
    var box=document.getElementById('eqSignupMsg');
    checkDuplicate(first, last, birth, null).then(function(dups){
      if(dups && dups.length && !box.getAttribute('data-ack')){
        box.innerHTML=duplicateWarningHTML(dups)+
          '<button type="button" class="eq-btn eq-btn-ghost" id="eqSuForce" '+
          'style="margin-top:8px">Ce n\'est pas la même personne, envoyer quand même</button>';
        box.setAttribute('data-ack','1');
        bindLinkButtons(box);
        document.getElementById('eqSuForce').addEventListener('click', function(){
          document.getElementById('eqSuSave').click();
        });
        btn.disabled=false;
        return;
      }
      submitSignup();
    });

    function submitSignup(){
    api('/rest/v1/team_members',{ method:'POST', body:body, prefer:'return=minimal' })
    .then(function(){
      // Prévient les administrateurs. Non bloquant : si la notification
      // échoue, la demande est déjà enregistrée.
      try{
        sendPush({ mode:'signup',
                   title:'Nouvelle demande d\'inscription',
                   body:(first+' '+last).trim()+' souhaite rejoindre le club'
                 }).catch(function(){});
      }catch(e){}
      closeSignupModal(); return loadMyTeams(); })
    .then(function(){ renderTeams();
      var b=document.getElementById('eqBody');
      var note=document.createElement('div'); note.className='eq-msg eq-msg-ok'; note.style.marginTop='14px';
      note.innerHTML='<span class="eq-msg-ic">✅</span><span>Demande envoyée ! Un éducateur va la valider prochainement.</span>';
      b.appendChild(note);
    })
    .catch(function(e){ err(e.message); btn.disabled=false; });
    }
  }

  function removeChild(id){
    if(!confirm('Retirer cette inscription ?')) return;
    api('/rest/v1/team_members?id=eq.'+id,{ method:'DELETE', prefer:'return=minimal' })
    .then(function(){ return loadMyTeams(); }).then(renderTeams).catch(function(e){ alert('Erreur : '+e.message); });
  }

  /* ============================================================
     VALIDATION DES INSCRIPTIONS (staff)
     ============================================================ */
  /* Demandes de rattachement à un enfant existant. Affichées au-dessus
     des inscriptions : elles concernent souvent une famille séparée et
     méritent d'être vues, pas noyées en bas de page. */
  function renderLinkRequests(){
    api('/rest/v1/rpc/list_child_link_requests',{ method:'POST', body:{} })
      .then(function(rows){
        var box=document.getElementById('eqLinkList');
        if(!box) return;
        if(!rows || !rows.length){ box.innerHTML=''; return; }

        box.innerHTML='<div class="eq-linkreq-head">'+
          '<div class="eq-linkreq-t">Demandes de rattachement</div>'+
          '<div class="eq-linkreq-d">Un parent demande l\'accès à un enfant déjà inscrit. '+
          'Vérifie qu\'il a bien le droit d\'y accéder avant de valider.</div></div>'+
          rows.map(function(r){
            var d=r.birthdate ? new Date(r.birthdate).toLocaleDateString('fr-FR') : '—';
            return '<div class="eq-linkreq">'+
              '<div class="eq-linkreq-child">'+esc(r.enfant)+
                '<span>'+esc(r.categorie||'sans catégorie')+' · né(e) le '+d+'</span></div>'+
              '<div class="eq-linkreq-row"><span>Demande faite par</span>'+
                '<b>'+esc(r.demandeur)+'</b></div>'+
              '<div class="eq-linkreq-row"><span></span>'+
                '<a href="mailto:'+esc(r.demandeur_email||'')+'">'+esc(r.demandeur_email||'—')+'</a></div>'+
              '<div class="eq-linkreq-row"><span>Parent déjà rattaché</span>'+
                '<b>'+esc(r.parent_actuel)+'</b></div>'+
              '<div class="eq-linkreq-row"><span></span>'+
                '<a href="mailto:'+esc(r.parent_actuel_email||'')+'">'+esc(r.parent_actuel_email||'—')+'</a></div>'+
              (r.message?'<div class="eq-linkreq-msg">« '+esc(r.message)+' »</div>':'')+
              '<div class="eq-dossier-acts">'+
                '<button type="button" class="eq-btn eq-dossier-ok" data-lrok="'+r.id+'">✓ Rattacher</button>'+
                '<button type="button" class="eq-btn eq-dossier-no" data-lrno="'+r.id+'">✕ Refuser</button>'+
              '</div></div>';
          }).join('');

        var run=function(id, accept, btn){
          var q = accept
            ? 'Rattacher ce parent à l\'enfant ?\n\nIl verra l\'enfant, son agenda et recevra les convocations.'
            : 'Refuser cette demande ?';
          if(!confirm(q)) return;
          btn.disabled=true;
          api('/rest/v1/rpc/review_child_link',{ method:'POST',
            body:{ p_id:id, p_accept:accept }, prefer:'return=minimal' })
            .then(function(){ renderLinkRequests(); })
            .catch(function(e){ btn.disabled=false; alert(e.message); });
        };
        var ok=box.querySelectorAll('[data-lrok]');
        for(var i=0;i<ok.length;i++) ok[i].addEventListener('click', function(){
          run(this.getAttribute('data-lrok'), true, this); });
        var no=box.querySelectorAll('[data-lrno]');
        for(var j=0;j<no.length;j++) no[j].addEventListener('click', function(){
          run(this.getAttribute('data-lrno'), false, this); });
      })
      .catch(function(){ /* la table n'existe pas encore : on n'affiche rien */ });
  }

  function renderValidation(){
    var body=document.getElementById('eqBody');
    body.innerHTML='<div class="eq-h"><div class="eq-h-title">Validation</div></div>'+
      '<div class="eq-h-sub">Les demandes d\'inscription en attente. Vérifie les infos puis valide ou refuse.</div>'+
      '<div id="eqLinkList"></div>'+
      '<div id="eqValidList">'+loadingHTML()+'</div>';

    renderLinkRequests();
    api('/rest/v1/rpc/pending_signups',{ method:'POST', body:{} }).then(function(rows){
      var box=document.getElementById('eqValidList');
      if(!rows||!rows.length){
        box.innerHTML='<div class="eq-empty"><div class="eq-empty-ic">✅</div><div class="eq-empty-t">Aucune demande en attente</div><div class="eq-empty-d">Toutes les inscriptions sont traitées.</div></div>';
        return;
      }
      var html='';
      rows.forEach(function(r){
        var childFull=((r.child_first_name||'')+' '+(r.child_name||'')).trim();
        var birth = r.child_birthdate ? new Date(r.child_birthdate).toLocaleDateString('fr-FR') : '—';
        var age='';
        if(r.child_birthdate){ var a=Math.floor((Date.now()-new Date(r.child_birthdate).getTime())/31557600000); age=' ('+a+' ans)'; }
        html+='<div class="eq-dossier">'+
          '<div class="eq-dossier-head"><div class="eq-dossier-av">'+initials(childFull)+'</div>'+
          '<div style="min-width:0"><div class="eq-dossier-name">'+esc(childFull)+'</div><div class="eq-dossier-cat">'+esc(r.team_name)+'</div></div></div>'+
          '<div class="eq-dossier-rows">'+
            '<div class="eq-dossier-row"><span>Naissance</span><strong>'+birth+age+'</strong></div>'+
            '<div class="eq-dossier-row"><span>Responsable</span><strong>'+esc(r.parent_name||r.parent_email)+'</strong></div>'+
            '<div class="eq-dossier-row"><span>Téléphone</span><strong>'+esc(r.parent_phone||'—')+'</strong></div>'+
            '<div class="eq-dossier-row"><span>Email</span><strong>'+esc(r.parent_email)+'</strong></div>'+
          '</div>'+
          '<div class="eq-dossier-actions">'+
            '<button type="button" class="eq-btn eq-dossier-ok" data-ok="'+r.reg_id+'">✓ Valider</button>'+
            '<button type="button" class="eq-btn eq-btn-ghost eq-dossier-no" data-no="'+r.reg_id+'">✕ Refuser</button>'+
          '</div>'+
        '</div>';
      });
      box.innerHTML=html;
      var oks=box.querySelectorAll('[data-ok]'); for(var i=0;i<oks.length;i++){ oks[i].addEventListener('click', function(){ reviewSignup(this.getAttribute('data-ok'),'valide'); }); }
      var nos=box.querySelectorAll('[data-no]'); for(var j=0;j<nos.length;j++){ nos[j].addEventListener('click', function(){ reviewSignup(this.getAttribute('data-no'),'refuse'); }); }
    }).catch(function(e){ document.getElementById('eqValidList').innerHTML='<div class="eq-empty"><div class="eq-empty-d">Erreur : '+esc(e.message)+'</div></div>'; });
  }

  function reviewSignup(id, decision){
    if(decision==='refuse' && !confirm('Refuser cette inscription ?')) return;
    api('/rest/v1/team_members?id=eq.'+id,{ method:'PATCH', body:{ status:decision, reviewed_by:USER.id }, prefer:'return=minimal' })
    .then(function(){ renderValidation(); })
    .catch(function(e){ alert('Erreur : '+e.message); });
  }

  /* ============================================================
     COACH
     ============================================================ */
  function renderStaff(){
    var body=document.getElementById('eqBody');
    body.innerHTML='<div class="eq-h"><div class="eq-h-title">Espace Coach</div></div>'+
      '<div class="eq-h-sub">Crée des événements pour tes catégories. Le suivi des présences apparaît sur chaque événement dans l\'agenda.</div>'+
      '<button type="button" class="eq-btn" id="eqNewEv">+ Créer un événement</button>'+
      '<div style="margin-top:18px" id="eqStaffStat"></div>';
    document.getElementById('eqNewEv').addEventListener('click', function(){ openEvModal(); });
    var s=document.getElementById('eqStaffStat');
    if(!STATE.events.length){ s.innerHTML='<div class="eq-empty"><div class="eq-empty-ic">📋</div><div class="eq-empty-t">Aucun événement</div><div class="eq-empty-d">Crée ton premier événement ci-dessus.</div></div>'; }
    else { s.innerHTML='<div class="eq-h-sub" style="margin-top:0">'+STATE.events.length+' événement(s) à venir. Le détail des présences est dans l\'onglet Agenda.</div>'; }
  }

  function openEvModal(existing, dup){
    // « isEdit » servait à la fois à préremplir les champs ET à décider
    // d'une mise à jour plutôt qu'une création. Pour dupliquer, il faut
    // séparer les deux : on préremplit tout, mais on crée du neuf.
    var prefill = !!(existing && existing.start_at);
    var isEdit  = prefill && !!existing.id && !dup;
    var curType = prefill ? (existing.type||'entrainement') : 'entrainement';
    function seg(t,label){ return '<button type="button" data-t="'+t+'" class="'+(curType===t?'on':'')+'">'+label+'</button>'; }
    // équipes pré-cochées en édition (team_ids si dispo, sinon team_id)
    var selTeams = [];
    if(prefill){
      if(existing.team_ids && existing.team_ids.length) selTeams = existing.team_ids.slice();
      else if(existing.team_id) selTeams = [existing.team_id];
    }
    var teamChips=STATE.teams.map(function(t){
      var on = selTeams.indexOf(t.id)!==-1 ? ' on' : '';
      return '<button type="button" class="eq-teamsel'+on+'" data-team="'+t.id+'">'+esc(t.name)+'</button>';
    }).join('');
    // valeurs pré-remplies en édition
    function localDT(iso){ if(!iso) return ''; var d=new Date(iso); var p=function(n){return ('0'+n).slice(-2);}; return d.getFullYear()+'-'+p(d.getMonth()+1)+'-'+p(d.getDate())+'T'+p(d.getHours())+':'+p(d.getMinutes()); }
    var vTitle = prefill ? esc(existing.title||'') : '';
    var vStart = prefill ? localDT(existing.start_at) : '';
    function localTime(iso){ if(!iso) return ''; var d=new Date(iso); var p=function(n){return ('0'+n).slice(-2);}; return p(d.getHours())+':'+p(d.getMinutes()); }
    var vEnd = prefill ? localTime(existing.end_at) : '';
    var vLoc = prefill ? esc(existing.location||'') : 'Stade Robert Vieux Melchior';
    var vNote = prefill ? esc(existing.notes||'') : '';
    var vDeadline = prefill ? localDT(existing.signup_deadline) : '';
    var vHide = prefill ? !!existing.hide_attendance : false;
    var vConvoc = prefill ? (existing.convocation||'sent') : 'sent';
    var vRestrict = prefill ? !!existing.restricted : false;
    var vConvocAt = prefill ? localDT(existing.convocation_at) : '';
    var m=document.createElement('div'); m.className='eq-modal'; m.id='eqModal';
    m.innerHTML='<div class="eq-modal-ov" id="eqModalOv"></div><div class="eq-modal-card">'+
      '<div class="eq-modal-grab"></div>'+
      '<div class="eq-modal-title">'+(isEdit?'Modifier l\'événement':(dup?'Dupliquer l\'événement':'Nouvel événement'))+'</div>'+
      '<div id="eqEvMsg"></div>'+
      '<div class="eq-field"><label>Catégorie(s) concernée(s)</label><div class="eq-teamsel-grid" id="eqEvTeams">'+teamChips+'</div><div class="eq-field-hint">Touche une ou plusieurs catégories (ex: pour une kermesse, sélectionne tout le club).</div></div>'+
      '<div class="eq-field"><label>Type</label><div class="eq-seg eq-seg-wrap" id="eqEvType">'+
        seg('entrainement','Entraînement')+seg('match','Match')+seg('tournoi','Tournoi')+seg('benevolat','Bénévolat')+seg('autre','Événement')+'</div></div>'+
      '<div class="eq-field"><label>Titre</label><input class="eq-input" id="eqEvTitle" value="'+vTitle+'" placeholder="Ex: Entraînement hebdo"></div>'+
      '<div class="eq-field"><label>Date & heure</label><input class="eq-input" type="datetime-local" id="eqEvStart" value="'+vStart+'"></div>'+
      '<div class="eq-field"><label>Heure de fin (optionnel)</label><input class="eq-input" type="time" id="eqEvEnd" value="'+vEnd+'"><div class="eq-field-hint">Laisse vide si tu ne connais pas l\'heure de fin.</div></div>'+
      (isEdit?'':'<div class="eq-field eq-recur"><label class="eq-recur-toggle"><input type="checkbox" id="eqEvRecur"><span>Répéter chaque semaine</span></label><div id="eqRecurOpts" class="eq-recur-opts eq-hidden"><div class="eq-field-hint" style="margin:0 0 8px">Crée le même créneau toutes les semaines (ex: tous les mardis) jusqu\'à la date choisie. Chaque séance reste indépendante : tu pourras en supprimer une pendant les vacances.</div><label>Répéter jusqu\'au</label><input class="eq-input" type="date" id="eqEvUntil"></div></div>')+
      '<div class="eq-field"><label>Lieu</label><input class="eq-input" id="eqEvLoc" value="'+vLoc+'"></div>'+
      '<div class="eq-field"><label>Note (optionnel)</label><input class="eq-input" id="eqEvNote" value="'+vNote+'" placeholder="Prévoir crampons, eau…"></div>'+
      '<div class="eq-field"><label>Date limite d\'inscription (optionnel)</label><input class="eq-input" type="datetime-local" id="eqEvDeadline" value="'+vDeadline+'"><div class="eq-field-hint">Après cette date, les parents ne peuvent plus voter la présence.</div></div>'+
      '<div class="eq-field eq-recur"><label>Convocation des parents</label>'+
        '<div class="eq-convoc" id="eqConvoc">'+
          '<button type="button" class="eq-convoc-opt'+(vConvoc==='sent'?' on':'')+'" data-c="sent"><span class="eq-convoc-t">Envoyer maintenant</span><span class="eq-convoc-d">La notification part dès la création</span></button>'+
          '<button type="button" class="eq-convoc-opt'+(vConvoc==='scheduled'?' on':'')+'" data-c="scheduled"><span class="eq-convoc-t">Programmer</span><span class="eq-convoc-d">Choisis quand la notification partira</span></button>'+
          '<button type="button" class="eq-convoc-opt'+(vConvoc==='manual'?' on':'')+'" data-c="manual"><span class="eq-convoc-t">Manuel</span><span class="eq-convoc-d">Rien n\'est envoyé, tu déclenches toi-même</span></button>'+
        '</div>'+
        '<div id="eqConvocAtWrap" class="eq-convoc-at '+(vConvoc==='scheduled'?'':'eq-hidden')+'">'+
          '<div id="eqConvocDateBlk"><label style="margin-top:12px">Date d\'envoi de la convocation</label><input class="eq-input" type="datetime-local" id="eqEvConvocAt" value="'+vConvocAt+'"></div>'+
          '<div id="eqConvocDelayBlk" class="eq-hidden"><label style="margin-top:12px">Envoyer la convocation</label><select class="eq-input" id="eqEvConvocDelay"><option value="1">1 jour avant chaque séance</option><option value="2" selected>2 jours avant chaque séance</option><option value="3">3 jours avant chaque séance</option><option value="4">4 jours avant chaque séance</option><option value="5">5 jours avant chaque séance</option><option value="7">1 semaine avant chaque séance</option></select><div class="eq-field-hint" style="margin-top:8px">Chaque séance recevra sa convocation automatiquement, le bon nombre de jours avant sa propre date.</div></div>'+
        '</div>'+
      '</div>'+
      '<div class="eq-field eq-recur"><label class="eq-recur-toggle"><input type="checkbox" id="eqEvHide"'+(vHide?' checked':'')+'><span>Masquer les présents aux parents</span></label><div class="eq-field-hint" style="margin-top:8px">Les parents ne verront ni le nombre ni les noms des inscrits (anti effet « boule de neige » sur les désistements). Le staff voit toujours tout.</div></div>'+
      '<div class="eq-field eq-recur"><label class="eq-recur-toggle"><input type="checkbox" id="eqEvRestrict"'+(vRestrict?' checked':'')+'><span>Réserver à certains joueurs</span></label><div class="eq-field-hint" style="margin-top:8px">Seuls les joueurs sélectionnés verront l\'événement (ex: tournoi féminin, sélection). Les autres ne le voient pas du tout.</div>'+
        '<div id="eqRestrictBox" class="eq-restrict-box '+(vRestrict?'':'eq-hidden')+'">'+
          '<div class="eq-search" style="margin-bottom:10px"><span class="eq-search-ic">'+IC.search+'</span><input class="eq-search-input" id="eqRestrictSearch" type="text" placeholder="Rechercher un joueur…"></div>'+
          '<div class="eq-restrict-actions"><button type="button" class="eq-restrict-all" id="eqRestrictAll">Tout cocher</button><button type="button" class="eq-restrict-none" id="eqRestrictNone">Tout décocher</button><span class="eq-restrict-count" id="eqRestrictCount">0 sélectionné</span></div>'+
          '<div id="eqRestrictList" class="eq-restrict-list">'+loadingHTML()+'</div>'+
        '</div>'+
      '</div>'+
      '<button type="button" class="eq-btn" id="eqEvSave">'+(isEdit?'Enregistrer les modifications':(dup?'Créer la copie':'Créer l\'événement'))+'</button>'+
      '<button type="button" class="eq-btn eq-btn-ghost" id="eqEvCancel" style="margin-top:10px">Annuler</button>'+
      '</div>';
    document.querySelector('.eq-app').appendChild(m);
    STATE.evType=curType;
    STATE.editingEvent = isEdit ? existing.id : null;
    // sélection multiple des catégories
    var tsel=document.getElementById('eqEvTeams').querySelectorAll('.eq-teamsel');
    for(var ti=0;ti<tsel.length;ti++){ tsel[ti].addEventListener('click', function(){ this.classList.toggle('on'); }); }
    var segs=document.getElementById('eqEvType').querySelectorAll('button');
    for(var i=0;i<segs.length;i++){ segs[i].addEventListener('click', function(){ STATE.evType=this.getAttribute('data-t'); for(var k=0;k<segs.length;k++) segs[k].className=(segs[k]===this)?'on':''; }); }
    var recurChk=document.getElementById('eqEvRecur');
    // bascule l'affichage date <-> délai selon que la récurrence est active
    function syncConvocFields(){
      var rec = recurChk && recurChk.checked;
      var dateBlk=document.getElementById('eqConvocDateBlk');
      var delayBlk=document.getElementById('eqConvocDelayBlk');
      if(dateBlk) dateBlk.classList.toggle('eq-hidden', rec);
      if(delayBlk) delayBlk.classList.toggle('eq-hidden', !rec);
    }
    if(recurChk){ recurChk.addEventListener('change', function(){ var o=document.getElementById('eqRecurOpts'); if(o) o.classList.toggle('eq-hidden', !this.checked); syncConvocFields(); }); }
    // options de convocation (radio)
    STATE.convocMode = (prefill ? (existing.convocation||'sent') : 'sent');
    var convocBtns=document.getElementById('eqConvoc').querySelectorAll('.eq-convoc-opt');
    for(var ci=0;ci<convocBtns.length;ci++){
      convocBtns[ci].addEventListener('click', function(){
        STATE.convocMode=this.getAttribute('data-c');
        for(var k=0;k<convocBtns.length;k++) convocBtns[k].className='eq-convoc-opt'+(convocBtns[k]===this?' on':'');
        var w=document.getElementById('eqConvocAtWrap'); if(w) w.classList.toggle('eq-hidden', STATE.convocMode!=='scheduled');
        syncConvocFields();
      });
    }
    // ---- Réservation à certains joueurs ----
    var restrictChk=document.getElementById('eqEvRestrict');
    var restrictBox=document.getElementById('eqRestrictBox');
    var ALL_CHILDREN=[];        // {owner_id, child_name, child_first_name, team_id, team_name}
    var SELECTED_PLAYERS={};    // clé "owner|child" -> true
    var restrictLoaded=false;
    function playerKey(o,c){ return o+'|'+c; }
    function paintRestrictList(){
      var box=document.getElementById('eqRestrictList'); if(!box) return;
      var q=(document.getElementById('eqRestrictSearch').value||'').toLowerCase().trim();
      var rows=ALL_CHILDREN.filter(function(ch){
        if(!q) return true;
        var hay=((ch.child_first_name||'')+' '+(ch.child_name||'')+' '+(ch.team_name||'')).toLowerCase();
        return hay.indexOf(q)!==-1;
      });
      if(!rows.length){ box.innerHTML='<div class="eq-restrict-empty">Aucun joueur trouvé.</div>'; updateRestrictCount(); return; }
      var html='';
      rows.forEach(function(ch){
        var k=playerKey(ch.owner_id, ch.child_name);
        var full=((ch.child_first_name||'')+' '+(ch.child_name||'')).trim()||ch.child_name||'Joueur';
        html+='<label class="eq-restrict-item"><input type="checkbox" data-k="'+esc(k)+'"'+(SELECTED_PLAYERS[k]?' checked':'')+'>'+
          '<span class="eq-restrict-av">'+initials(full)+'</span>'+
          '<span class="eq-restrict-info"><span class="eq-restrict-name">'+esc(full)+'</span><span class="eq-restrict-team">'+esc(ch.team_name||'')+'</span></span>'+
        '</label>';
      });
      box.innerHTML=html;
      var cbs=box.querySelectorAll('input[type="checkbox"]');
      for(var i=0;i<cbs.length;i++){ cbs[i].addEventListener('change', function(){ var k=this.getAttribute('data-k'); if(this.checked) SELECTED_PLAYERS[k]=true; else delete SELECTED_PLAYERS[k]; updateRestrictCount(); }); }
      updateRestrictCount();
    }
    function updateRestrictCount(){
      var n=0; for(var k in SELECTED_PLAYERS){ if(SELECTED_PLAYERS[k]) n++; }
      var el=document.getElementById('eqRestrictCount'); if(el) el.textContent=n+' sélectionné'+(n>1?'s':'');
    }
    function loadRestrictChildren(){
      if(restrictLoaded) return;
      restrictLoaded=true;
      api('/rest/v1/rpc/all_children_for_selection',{ method:'POST', body:{} }).then(function(rows){
        ALL_CHILDREN=rows||[];
        // en édition d'un event déjà restreint : pré-cocher les joueurs autorisés
        if(prefill && vRestrict){
          api('/rest/v1/rpc/get_event_players',{ method:'POST', body:{ p_event_id:existing.id } }).then(function(sel){
            (sel||[]).forEach(function(p){ SELECTED_PLAYERS[playerKey(p.owner_id,p.child_name)]=true; });
            paintRestrictList();
          }).catch(function(){ paintRestrictList(); });
        } else {
          paintRestrictList();
        }
      }).catch(function(e){
        var box=document.getElementById('eqRestrictList'); if(box) box.innerHTML='<div class="eq-restrict-empty">Erreur : '+esc(e.message)+'</div>';
      });
    }
    if(restrictChk){
      restrictChk.addEventListener('change', function(){
        restrictBox.classList.toggle('eq-hidden', !this.checked);
        if(this.checked){
          loadRestrictChildren();
          // un événement réservé est ponctuel : on désactive la récurrence
          if(recurChk){ recurChk.checked=false; var o=document.getElementById('eqRecurOpts'); if(o) o.classList.add('eq-hidden'); recurChk.disabled=true; }
        } else {
          if(recurChk){ recurChk.disabled=false; }
        }
      });
      if(vRestrict){ loadRestrictChildren(); if(recurChk) recurChk.disabled=true; }
    }
    var rSearch=document.getElementById('eqRestrictSearch');
    if(rSearch){ rSearch.addEventListener('input', paintRestrictList); }
    var rAll=document.getElementById('eqRestrictAll');
    if(rAll){ rAll.addEventListener('click', function(){ ALL_CHILDREN.forEach(function(ch){ SELECTED_PLAYERS[playerKey(ch.owner_id,ch.child_name)]=true; }); paintRestrictList(); }); }
    var rNone=document.getElementById('eqRestrictNone');
    if(rNone){ rNone.addEventListener('click', function(){ SELECTED_PLAYERS={}; paintRestrictList(); }); }
    // expose pour saveEvent
    STATE._getRestrict=function(){ return { on: restrictChk && restrictChk.checked, players: SELECTED_PLAYERS }; };

    document.getElementById('eqModalOv').addEventListener('click', closeEvModal);
    document.getElementById('eqEvCancel').addEventListener('click', closeEvModal);
    document.getElementById('eqEvSave').addEventListener('click', saveEvent);
  }
  function closeEvModal(){ var m=document.getElementById('eqModal'); if(m) m.parentNode.removeChild(m); STATE.editingEvent=null; }
  function saveEvent(){
    var title=document.getElementById('eqEvTitle').value.trim();
    var start=document.getElementById('eqEvStart').value;
    var msg=document.getElementById('eqEvMsg');
    // équipes cochées
    var selBtns=document.getElementById('eqEvTeams').querySelectorAll('.eq-teamsel.on');
    var teamIds=[]; for(var s=0;s<selBtns.length;s++){ teamIds.push(selBtns[s].getAttribute('data-team')); }
    if(!teamIds.length){ msg.innerHTML='<div class="eq-msg eq-msg-err"><span class="eq-msg-ic">⚠️</span><span>Choisis au moins une catégorie.</span></div>'; return; }
    if(!title){ msg.innerHTML='<div class="eq-msg eq-msg-err"><span class="eq-msg-ic">⚠️</span><span>Donne un titre.</span></div>'; return; }
    if(!start){ msg.innerHTML='<div class="eq-msg eq-msg-err"><span class="eq-msg-ic">⚠️</span><span>Choisis une date.</span></div>'; return; }
    var deadline=document.getElementById('eqEvDeadline').value;
    var endTime=document.getElementById('eqEvEnd')?document.getElementById('eqEvEnd').value:'';
    // calcule end_at (ISO) à partir d'une date de début + l'heure de fin "HH:MM"
    function computeEnd(startDate){
      if(!endTime) return null;
      var parts=endTime.split(':'); if(parts.length<2) return null;
      var e=new Date(startDate.getTime());
      e.setHours(parseInt(parts[0],10), parseInt(parts[1],10), 0, 0);
      if(e<=startDate){ e.setDate(e.getDate()+1); } // fin le lendemain si avant le début
      return e.toISOString();
    }
    var teamId=teamIds[0]; // équipe principale (compat)
    var loc=document.getElementById('eqEvLoc').value.trim();
    var note=document.getElementById('eqEvNote').value.trim();
    var hide=document.getElementById('eqEvHide')?document.getElementById('eqEvHide').checked:false;
    var convocMode=STATE.convocMode||'sent';
    var isRecur=document.getElementById('eqEvRecur') && document.getElementById('eqEvRecur').checked;
    var convocAtVal=document.getElementById('eqEvConvocAt')?document.getElementById('eqEvConvocAt').value:'';
    // en récurrence, la convocation se règle par délai (pas de date fixe) -> on n'exige pas la date
    if(convocMode==='scheduled' && !isRecur && !convocAtVal){ msg.innerHTML='<div class="eq-msg eq-msg-err"><span class="eq-msg-ic">⚠️</span><span>Choisis la date d\'envoi de la convocation.</span></div>'; return; }
    var convocAt = (convocMode==='scheduled' && convocAtVal) ? new Date(convocAtVal).toISOString() : null;
    var btn=document.getElementById('eqEvSave'); btn.disabled=true;
    var teamLabel = teamIds.length>1 ? 'le club' : ((STATE.teams.filter(function(t){return t.id===teamId;})[0]||{}).name||'ton équipe');
    var typeLabel={entrainement:'Entraînement',match:'Match',tournoi:'Tournoi',benevolat:'Bénévolat',autre:'Événement'}[STATE.evType]||'Événement';
    var editId=STATE.editingEvent;
    var restrictInfo = STATE._getRestrict ? STATE._getRestrict() : { on:false, players:{} };
    var restrictOn = !!restrictInfo.on;
    // liste des joueurs sélectionnés au format [{owner_id, child_name}]
    var restrictPlayers=[];
    if(restrictOn){ for(var pk in restrictInfo.players){ if(restrictInfo.players[pk]){ var pp=pk.split('|'); restrictPlayers.push({ owner_id:pp[0], child_name:pp.slice(1).join('|') }); } } }
    if(restrictOn && !restrictPlayers.length){ msg.innerHTML='<div class="eq-msg eq-msg-err"><span class="eq-msg-ic">⚠️</span><span>Sélectionne au moins un joueur, ou décoche « Réserver ».</span></div>'; return; }
    if(editId){
      // ÉDITION : PATCH
      var body={ team_id:teamId, team_ids:teamIds, type:STATE.evType, title:title,
        start_at:new Date(start).toISOString(), end_at:computeEnd(new Date(start)), location:loc, notes:note,
        signup_deadline: deadline ? new Date(deadline).toISOString() : null,
        hide_attendance:hide, convocation:convocMode, convocation_at:convocAt, restricted:restrictOn };
      api('/rest/v1/events?id=eq.'+editId,{ method:'PATCH', body:body, prefer:'return=minimal' })
      .then(function(){
        // met à jour la liste des joueurs autorisés
        return api('/rest/v1/rpc/set_event_players',{ method:'POST', body:{ p_event_id:editId, p_players: restrictOn ? restrictPlayers : [] }, prefer:'return=minimal' }).catch(function(){});
      })
      .then(function(){
        // en édition, on notifie seulement si convocation immédiate
        if(convocMode==='sent'){
          sendPush({ mode:'new_event', team_ids:teamIds,
            event_id: editId || null,
            title:'USV '+teamLabel+' · '+typeLabel+' modifié',
            body:title+' — '+fmtTime(body.start_at) });
        }
        closeEvModal(); return loadEvents();
      })
      .then(function(){ switchTab('cal'); })
      .catch(function(e){ msg.innerHTML='<div class="eq-msg eq-msg-err"><span class="eq-msg-ic">⚠️</span><span>'+esc(e.message)+'</span></div>'; btn.disabled=false; });
    } else {
      // CRÉATION : POST (avec récurrence éventuelle)
      var recurOn = document.getElementById('eqEvRecur') && document.getElementById('eqEvRecur').checked;
      var baseStart = new Date(start);
      var weeks = 1;
      if(recurOn){
        var untilVal=document.getElementById('eqEvUntil').value;
        if(!untilVal){ msg.innerHTML='<div class="eq-msg eq-msg-err"><span class="eq-msg-ic">⚠️</span><span>Choisis la date de fin de répétition.</span></div>'; btn.disabled=false; return; }
        // fin de journée pour inclure une séance le jour même
        var until=new Date(untilVal); until.setHours(23,59,59,999);
        if(until<baseStart){ msg.innerHTML='<div class="eq-msg eq-msg-err"><span class="eq-msg-ic">⚠️</span><span>La date de fin doit être après la date de début.</span></div>'; btn.disabled=false; return; }
        // compte les semaines entre le début et la date de fin (incluse)
        weeks=Math.floor((until.getTime()-baseStart.getTime())/(7*86400000))+1;
        if(weeks<1) weeks=1; if(weeks>104) weeks=104; // garde-fou : max 2 ans
      }
      // un événement réservé est ponctuel : jamais de récurrence
      if(restrictOn){ recurOn=false; weeks=1; }
      var baseDeadline = deadline ? new Date(deadline) : null;
      var baseConvocAt = convocAt ? new Date(convocAt) : null;
      // en récurrence + programmé : on utilise un délai (X jours avant chaque séance)
      var convocDelayDays = null;
      if(recurOn && convocMode==='scheduled'){
        var dsel=document.getElementById('eqEvConvocDelay');
        convocDelayDays = dsel ? (parseInt(dsel.value,10)||2) : 2;
      }
      var rows=[];
      for(var w=0; w<weeks; w++){
        var st=new Date(baseStart.getTime()); st.setDate(st.getDate()+w*7);
        var dl=null;
        if(baseDeadline){ var d2=new Date(baseDeadline.getTime()); d2.setDate(d2.getDate()+w*7); dl=d2.toISOString(); }
        var ca=null;
        if(convocMode==='scheduled'){
          if(convocDelayDays!==null){
            // délai : X jours avant la date de CETTE séance
            var cd=new Date(st.getTime()); cd.setDate(cd.getDate()-convocDelayDays); ca=cd.toISOString();
          } else if(baseConvocAt){
            // date fixe (événement unique programmé)
            var c2=new Date(baseConvocAt.getTime()); c2.setDate(c2.getDate()+w*7); ca=c2.toISOString();
          }
        }
        rows.push({ team_id:teamId, team_ids:teamIds, type:STATE.evType, title:title,
          start_at:st.toISOString(), end_at:computeEnd(st), location:loc, notes:note,
          signup_deadline:dl, created_by:USER.id,
          hide_attendance:hide, convocation:convocMode, convocation_at:ca, restricted:restrictOn });
      }

      // si réservé : on a besoin de l'id créé pour lier les joueurs -> return=representation
      // On demande toujours la représentation : sans l'identifiant de
      // l'événement, la notification ne peut pas savoir qu'il est
      // réservé, et prévient toute la catégorie.
      api('/rest/v1/events',{ method:'POST', body:rows, prefer:'return=representation' })
      .then(function(created){
        var newId = (created && created.length) ? created[0].id : null;
        if(restrictOn && newId){
          return api('/rest/v1/rpc/set_event_players',{ method:'POST', body:{ p_event_id:newId, p_players:restrictPlayers }, prefer:'return=minimal' })
            .catch(function(){})
            .then(function(){ return newId; });
        }
        return newId;
      })
      .then(function(newId){
        // notif immédiate seulement en mode "sent"
        if(convocMode==='sent'){
          sendPush({ mode:'new_event', team_ids:teamIds,
            // L'identifiant permet à l'envoi de ne retenir que les
            // joueurs convoqués quand l'événement est réservé.
            event_id: newId,
            title:'USV '+teamLabel+' · '+typeLabel,
            body: weeks>1 ? (weeks+' séances ajoutées — à partir du '+fmtTime(rows[0].start_at)) : (title+' — '+fmtTime(rows[0].start_at)) });
        }
        closeEvModal(); return loadEvents();
      })
      .then(function(){ switchTab('cal'); })
      .catch(function(e){ msg.innerHTML='<div class="eq-msg eq-msg-err"><span class="eq-msg-ic">⚠️</span><span>'+esc(e.message)+'</span></div>'; btn.disabled=false; });
    }
  }

  /* ============================================================
     ADMIN
     ============================================================ */
  /* ============================================================
     STAGES — inscriptions aux stages de vacances
     ============================================================
     Alimenté par la page d'inscription du site. Le staff y trouve les
     effectifs par journée — le chiffre qui sert à réserver les
     activités et prévoir les encadrants — puis le détail famille par
     famille. */
  function renderStage(){
    // Double sécurité : même si l'onglet était ouvert par un autre chemin,
    // un non-administrateur ne voit rien (et le serveur refuse de toute façon).
    if(!(PROFILE && PROFILE.role==='admin')){ var vv=document.getElementById('eqBody'); if(vv) vv.innerHTML=''; return; }
    var body=document.getElementById('eqBody');
    body.innerHTML='<div class="eq-h"><div class="eq-h-title">Stages</div></div>'+
      '<div class="eq-h-sub">Les inscriptions prises sur le site. '+
      'Les effectifs par journée servent à réserver les activités.</div>'+
      '<div id="eqStageBar" class="eq-calfilter"></div>'+
      '<div id="eqStageBody">'+loadingHTML()+'</div>';

    api('/rest/v1/rpc/stage_bookings_list',{ method:'POST', body:{ p_slug:null } })
      .then(function(rows){
        STATE.stageRows=rows||[];
        // Les stages présents dans les inscriptions : inutile de les
        // lister en dur, ils apparaissent dès la première réservation.
        var slugs=[];
        STATE.stageRows.forEach(function(r){
          if(!slugs.filter(function(x){ return x.slug===r.stage_slug; }).length)
            slugs.push({ slug:r.stage_slug, name:r.stage_name });
        });
        STATE.stageSlugs=slugs;
        if(!STATE.stageSlug && slugs.length) STATE.stageSlug=slugs[0].slug;
        paintStage();
      })
      .catch(function(e){
        document.getElementById('eqStageBody').innerHTML=
          '<div class="eq-empty"><div class="eq-empty-t">Chargement impossible</div>'+
          '<div class="eq-empty-d">'+esc(e.message)+'</div></div>';
      });
  }

  function paintStage(){
    var bar=document.getElementById('eqStageBar');
    var box=document.getElementById('eqStageBody');
    if(!box) return;

    var slugs=STATE.stageSlugs||[];
    if(bar){
      bar.innerHTML = slugs.length>1
        ? slugs.map(function(s){
            return '<button type="button" class="eq-calfilter-chip'+
              (STATE.stageSlug===s.slug?' on':'')+'" data-stg="'+esc(s.slug)+'">'+
              esc(s.name)+'</button>';
          }).join('')
        : '';
      bar.querySelectorAll('[data-stg]').forEach(function(b){
        b.addEventListener('click', function(){
          STATE.stageSlug=this.getAttribute('data-stg'); paintStage();
        });
      });
    }

    var rows=(STATE.stageRows||[]).filter(function(r){
      return !STATE.stageSlug || r.stage_slug===STATE.stageSlug;
    });

    if(!rows.length){
      box.innerHTML='<div class="eq-empty"><div class="eq-empty-ic">🏕</div>'+
        '<div class="eq-empty-t">Aucune inscription</div>'+
        '<div class="eq-empty-d">Les inscriptions prises sur le site apparaîtront ici.</div></div>';
      return;
    }

    // Mode de règlement, en clair. Une inscription payée par carte est
    // déjà encaissée ; un chèque reste à recevoir. Sans cette
    // distinction, le staff relancerait des familles à jour.
    var PAIEMENT = { cb:'Carte', cheque:'Chèque', especes:'Espèces' };

    var actifs=rows.filter(function(r){ return r.status!=='annule'; });
    var payes=rows.filter(function(r){ return r.status==='paye'; });
    var euros=payes.reduce(function(a,r){ return a+r.amount_cents; },0);
    var du=actifs.filter(function(r){ return r.status==='en_attente'; })
                 .reduce(function(a,r){ return a+r.amount_cents; },0);

    // Effectif par journée, calculé depuis les inscriptions : pas
    // besoin d'un second appel.
    var parJour={};
    actifs.forEach(function(r){
      (r.day_dates||[]).forEach(function(d){
        if(!parJour[d]) parJour[d]={ total:0, paye:0 };
        parJour[d].total++;
        if(r.status==='paye') parJour[d].paye++;
      });
    });
    var jours=Object.keys(parJour).sort();

    var h='<div class="eq-stage-sum">'+
      '<div class="eq-stage-stat"><b>'+actifs.length+'</b><span>inscrits</span></div>'+
      '<div class="eq-stage-stat"><b>'+payes.length+'</b><span>payés</span></div>'+
      '<div class="eq-stage-stat"><b>'+(euros/100).toFixed(0)+' €</b><span>encaissés</span></div>'+
      (du>0?'<div class="eq-stage-stat warn"><b>'+(du/100).toFixed(0)+' €</b><span>en attente</span></div>':'')+
      '</div>';

    // Ce qui reste à encaisser de la main à la main : c'est la somme
    // que le club doit aller chercher, distincte du total en attente.
    var horsLigne=actifs.filter(function(r){
      return r.status==='en_attente' && (r.payment_method==='cheque'||r.payment_method==='especes');
    });
    if(horsLigne.length){
      var montantHL=horsLigne.reduce(function(a,r){ return a+r.amount_cents; },0);
      h+='<div class="eq-stage-cash">'+
        '<b>'+horsLigne.length+' règlement'+(horsLigne.length>1?'s':'')+' à encaisser</b>'+
        '<span>'+(montantHL/100).toFixed(0)+' € en chèques ou espèces, à récupérer avant le stage</span>'+
        '</div>';
    }

    h+='<div class="eq-sec"><div class="eq-sech"><h3>Effectif par journée</h3>'+
       '<p>Le chiffre à donner pour réserver les activités</p></div>'+
       '<div class="eq-stage-days">';
    jours.forEach(function(d){
      var p=d.split('-');
      h+='<div class="eq-stage-day">'+
        '<div class="eq-stage-day-d">'+p[2]+'/'+p[1]+'</div>'+
        '<div class="eq-stage-day-n">'+parJour[d].total+'</div>'+
        '<div class="eq-stage-day-l">enfant'+(parJour[d].total>1?'s':'')+'</div>'+
        (parJour[d].paye<parJour[d].total
          ? '<div class="eq-stage-day-w">'+(parJour[d].total-parJour[d].paye)+' à régler</div>'
          : '')+
        '</div>';
    });
    h+='</div></div>';

    h+='<div class="eq-sec"><div class="eq-sech"><h3>Inscriptions</h3>'+
       '<p>'+rows.length+' au total</p></div></div>';

    rows.forEach(function(r){
      var d=(r.day_dates||[]).slice().sort().map(function(x){
        var p=x.split('-'); return p[2]+'/'+p[1];
      }).join(', ');
      var etat = r.status==='paye' ? 'paye' : (r.status==='annule' ? 'annule' : 'attente');
      h+='<div class="eq-stage-row '+etat+'">'+
        '<div class="eq-stage-row-h">'+
          '<div><b>'+esc(r.child)+'</b><span class="eq-stage-team">'+esc(r.team)+'</span></div>'+
          '<div class="eq-stage-amt">'+(r.amount_cents/100).toFixed(0)+' €'+
            (r.payment_method?'<span class="eq-stage-pay '+esc(r.payment_method)+'">'+
              PAIEMENT[r.payment_method]+'</span>':'')+'</div>'+
        '</div>'+
        '<div class="eq-stage-line">'+
          (r.formula==='semaine'?'Semaine complète':'À la journée')+' · '+esc(d)+'</div>'+
        '<div class="eq-stage-line">'+esc(r.parent)+
          ' · <a href="tel:'+esc(r.phone)+'">'+esc(r.phone)+'</a>'+
          ' · <a href="mailto:'+esc(r.email)+'">'+esc(r.email)+'</a></div>'+
        (r.notes?'<div class="eq-stage-note">⚠️ '+esc(r.notes)+'</div>':'')+
        '<div class="eq-stage-foot">'+
          '<span class="eq-stage-ref">'+esc(r.ref)+'</span>'+
          '<span class="eq-stage-badge '+etat+'">'+
            (r.status==='paye'?'Payé':(r.status==='annule'?'Annulé':'À régler'))+'</span>'+
          (r.status!=='paye'?'<button type="button" class="eq-stage-act" data-paye="'+r.id+'">Marquer payé</button>':'')+
          (r.status!=='annule'?'<button type="button" class="eq-stage-act danger" data-annul="'+r.id+'">Annuler</button>':'')+
        '</div>'+
      '</div>';
    });

    box.innerHTML=h;

    var maj=function(id, statut, question){
      if(question && !confirm(question)) return;
      api('/rest/v1/rpc/stage_set_status',{ method:'POST',
        body:{ p_id:id, p_status:statut }, prefer:'return=minimal' })
        .then(function(){ STATE.stageRows=null; renderStage(); })
        .catch(function(e){ alert(e.message); });
    };
    box.querySelectorAll('[data-paye]').forEach(function(b){
      b.addEventListener('click', function(){ maj(this.getAttribute('data-paye'),'paye'); });
    });
    box.querySelectorAll('[data-annul]').forEach(function(b){
      b.addEventListener('click', function(){
        maj(this.getAttribute('data-annul'),'annule',
          'Annuler cette inscription ?\n\nElle sortira des effectifs. Le remboursement se fait à part.');
      });
    });
  }

  function renderAdmin(){
    var body=document.getElementById('eqBody');
    body.innerHTML='<div class="eq-h"><div class="eq-h-title">Administration</div></div>'+
      '<div class="eq-h-sub">Gère les rôles des membres. Éducateur = crée des événements et voit les présences. Admin = accès complet.</div>'+
      '<div class="eq-search"><span class="eq-search-ic">'+IC.search+'</span><input class="eq-search-input" id="eqAdminSearch" type="text" placeholder="Rechercher un nom ou un email…"></div>'+
      '<div id="eqAdminList">'+loadingHTML()+'</div>'+
      '<div id="eqAdminPager"></div>';

    var searchEl=document.getElementById('eqAdminSearch');
    searchEl.value=STATE.adminQuery;
    searchEl.addEventListener('input', function(){
      STATE.adminQuery=this.value;
      STATE.adminPage=1;
      paintAdmin();
    });

    if(STATE.adminMembers){ paintAdmin(); return; }
    api('/rest/v1/rpc/list_members',{ method:'POST', body:{} }).then(function(members){
      STATE.adminMembers=members||[];
      paintAdmin();
    }).catch(function(e){ document.getElementById('eqAdminList').innerHTML='<div class="eq-empty"><div class="eq-empty-d">Erreur : '+esc(e.message)+'</div></div>'; });
  }

  function paintAdmin(){
    var box=document.getElementById('eqAdminList');
    var pager=document.getElementById('eqAdminPager');
    if(!box) return;
    var all=STATE.adminMembers||[];
    // filtre recherche (nom ou email)
    var q=(STATE.adminQuery||'').toLowerCase().trim();
    var filtered=all;
    if(q){
      filtered=all.filter(function(mb){
        var n=(mb.member_name||'').toLowerCase();
        var e=(mb.member_email||'').toLowerCase();
        return n.indexOf(q)!==-1 || e.indexOf(q)!==-1;
      });
    }
    if(!filtered.length){
      box.innerHTML='<div class="eq-empty"><div class="eq-empty-ic">🔍</div><div class="eq-empty-t">Aucun résultat</div><div class="eq-empty-d">Aucun membre ne correspond à « '+esc(STATE.adminQuery)+' ».</div></div>';
      if(pager) pager.innerHTML='';
      return;
    }
    // pagination
    var perPage=15;
    var totalPages=Math.ceil(filtered.length/perPage);
    if(STATE.adminPage>totalPages) STATE.adminPage=totalPages;
    if(STATE.adminPage<1) STATE.adminPage=1;
    var start=(STATE.adminPage-1)*perPage;
    var pageItems=filtered.slice(start, start+perPage);

    var html='';
    pageItems.forEach(function(mb){
      var rl=mb.member_role==='admin'?'Admin':(mb.member_role==='educateur'?'Éducateur':'Membre');
      var displayName = mb.member_name && mb.member_name.trim() ? mb.member_name : mb.member_email.split('@')[0];
      html+='<div class="eq-member"><div class="eq-member-top"><div class="eq-member-l">'+
        '<div class="eq-member-av">'+initials(displayName)+'</div>'+
        '<div style="min-width:0"><div class="eq-member-name">'+esc(displayName)+'</div><div class="eq-member-email">'+esc(mb.member_email)+'</div></div>'+
        '</div><span class="eq-role-tag eq-role-'+mb.member_role+'">'+rl+'</span></div>';
      if(mb.member_id!==USER.id){
        html+='<div class="eq-role-pick" data-uid="'+mb.member_id+'">'+
          '<button type="button" data-r="parent" class="'+(mb.member_role==='parent'?'on':'')+'">Membre</button>'+
          '<button type="button" data-r="educateur" class="'+(mb.member_role==='educateur'?'on':'')+'">Éducateur</button>'+
          '<button type="button" data-r="admin" class="'+(mb.member_role==='admin'?'on':'')+'">Admin</button></div>';
      } else { html+='<div class="eq-self-note">C\'est toi 👑</div>'; }
      html+='</div>';
    });
    box.innerHTML=html;

    var picks=box.querySelectorAll('.eq-role-pick');
    for(var i=0;i<picks.length;i++){(function(row){
      var bs=row.querySelectorAll('button');
      for(var j=0;j<bs.length;j++){ bs[j].addEventListener('click', function(){ setRole(row.getAttribute('data-uid'),this.getAttribute('data-r')); }); }
    })(picks[i]);}

    // pager
    if(totalPages>1){
      pager.innerHTML='<div class="eq-pager">'+
        '<button type="button" class="eq-pager-btn" id="eqPrev" '+(STATE.adminPage===1?'disabled':'')+'>‹</button>'+
        '<span class="eq-pager-info">Page '+STATE.adminPage+' / '+totalPages+' · '+filtered.length+' membres</span>'+
        '<button type="button" class="eq-pager-btn" id="eqNext" '+(STATE.adminPage===totalPages?'disabled':'')+'>›</button>'+
        '</div>';
      var prev=document.getElementById('eqPrev'), next=document.getElementById('eqNext');
      if(prev) prev.addEventListener('click', function(){ if(STATE.adminPage>1){ STATE.adminPage--; paintAdmin(); document.getElementById('eqAdminList').scrollIntoView(); } });
      if(next) next.addEventListener('click', function(){ if(STATE.adminPage<totalPages){ STATE.adminPage++; paintAdmin(); document.getElementById('eqAdminList').scrollIntoView(); } });
    } else {
      pager.innerHTML='<div class="eq-pager-info" style="text-align:center;padding:10px">'+filtered.length+' membre'+(filtered.length>1?'s':'')+'</div>';
    }
  }

  function setRole(uid,role){
    api('/rest/v1/rpc/set_user_role',{ method:'POST', body:{ target_user:uid, new_role:role } })
    .then(function(){
      // met à jour en mémoire sans tout recharger (garde page + recherche)
      if(STATE.adminMembers){
        for(var i=0;i<STATE.adminMembers.length;i++){ if(STATE.adminMembers[i].member_id===uid){ STATE.adminMembers[i].member_role=role; break; } }
      }
      paintAdmin();
    }).catch(function(e){ alert('Erreur : '+e.message); });
  }

  /* ============================================================
     RETOUR DEPUIS LE MAIL « MOT DE PASSE OUBLIÉ »
     ============================================================
     Supabase renvoie sur la page avec un jeton dans le fragment
     d'URL : #access_token=...&type=recovery. Sans traitement, la
     personne atterrit sur l'écran de connexion et ne comprend pas
     pourquoi rien ne lui demande son nouveau mot de passe. */
  function lireFragment(){
    var h=(window.location.hash||'').replace(/^#/,'');
    if(!h) return null;
    var o={};
    h.split('&').forEach(function(part){
      var kv=part.split('=');
      if(kv[0]) o[decodeURIComponent(kv[0])]=decodeURIComponent((kv[1]||'').replace(/\+/g,' '));
    });
    return o;
  }

  function nettoyerFragment(){
    // On retire le jeton de la barre d'adresse : il ne doit pas rester
    // dans l'historique ni partir dans un lien copié-collé.
    try{
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }catch(e){ window.location.hash=''; }
  }

  function renderNewPassword(frag){
    TOKEN = frag.access_token;
    // Même habillage que l'écran de connexion : la personne arrive
    // depuis son mail, elle doit reconnaître l'application.
    ROOT.innerHTML =
    '<div class="eq-auth">'+
      '<div class="eq-mesh"><span></span><span></span><span></span><span></span></div>'+
      '<div class="eq-grain"></div>'+
      '<div class="eq-auth-inner">'+
        '<div class="eq-auth-logo"><img src="https://cdn.shopify.com/s/files/1/0977/2200/7934/files/14_1.png?v=1776774666" alt="USV"></div>'+
        '<div class="eq-auth-title">Nouveau mot de passe</div>'+
        '<div class="eq-auth-sub">Choisis-en un, tu seras connecté dans la foulée</div>'+
        '<div class="eq-card">'+
          '<div id="eqMsg"></div>'+
          '<div class="eq-field"><label>Nouveau mot de passe</label>'+
            '<input class="eq-input" id="eqNp1" type="password" autocomplete="new-password" placeholder="6 caractères minimum"></div>'+
          '<div class="eq-field"><label>Confirme</label>'+
            '<input class="eq-input" id="eqNp2" type="password" autocomplete="new-password"></div>'+
          '<button type="button" class="eq-btn" id="eqNpSave">Enregistrer</button>'+
        '</div>'+
      '</div>'+
    '</div>';

    var valider=function(){
      var a=document.getElementById('eqNp1').value;
      var b=document.getElementById('eqNp2').value;
      if(a.length<6){ showMsg('err','⚠️','Six caractères minimum.'); return; }
      if(a!==b){ showMsg('err','⚠️','Les deux mots de passe ne sont pas identiques.'); return; }
      var btn=document.getElementById('eqNpSave');
      btn.disabled=true; showMsg('info','⏳','Enregistrement…');

      fetch(SUPA_URL+'/auth/v1/user', {
        method:'PUT',
        headers:{ 'apikey':SUPA_KEY, 'Authorization':'Bearer '+frag.access_token,
                  'Content-Type':'application/json' },
        body: JSON.stringify({ password:a })
      })
      .then(function(r){ return r.json().then(function(d){ return { ok:r.ok, d:d }; }); })
      .then(function(res){
        if(!res.ok) throw new Error((res.d && (res.d.msg||res.d.message||res.d.error_description)) || 'Échec');
        nettoyerFragment();
        showMsg('ok','✅','Mot de passe modifié. Connexion…');
        // Le lien de récupération ouvre une session valable : on
        // enchaîne directement plutôt que de redemander de se connecter.
        saveSession({ access_token:frag.access_token,
                      refresh_token:frag.refresh_token||null,
                      user:{ id:res.d.id, email:res.d.email } });
        setTimeout(function(){
          loadProfile().then(enterApp).catch(function(){ clearSession(); renderAuth(); });
        }, 700);
      })
      .catch(function(e){
        btn.disabled=false;
        showMsg('err','⚠️', e.message==='Failed to fetch'
          ? 'Connexion impossible. Réessaie dans un instant.'
          : 'Le lien a peut-être expiré. Redemande un e-mail depuis « Mot de passe oublié ».');
      });
    };
    document.getElementById('eqNpSave').addEventListener('click', valider);
    document.getElementById('eqNp2').addEventListener('keydown', function(e){
      if(e.key==='Enter'){ e.preventDefault(); valider(); }
    });
    document.getElementById('eqNp1').focus();
  }

  /* ---------- boot ---------- */
  var FRAG = lireFragment();
  if(FRAG && FRAG.error_description){
    // Lien expiré ou déjà utilisé : Supabase le dit dans le fragment.
    nettoyerFragment();
    renderAuth();
    showMsg('err','⚠️','Ce lien n\'est plus valable. Redemande un e-mail depuis « Mot de passe oublié ».');
  }
  else if(FRAG && FRAG.access_token && FRAG.type==='recovery'){
    renderNewPassword(FRAG);
  }
  else if(loadSession() && USER){
    // 1) on tente avec le token actuel. 2) s'il est expiré, on le régénère
    //    via le refresh_token (sans redemander le mot de passe). 3) sinon, login.
    loadProfile().then(enterApp).catch(function(){
      refreshSession()
        .then(function(){ return loadProfile().then(enterApp); })
        .catch(function(){ clearSession(); renderAuth(); });
    });
  }
  else { renderAuth(); }
})();
